/* eslint-disable no-console */
/* eslint-disable */
// eslint-disable-next-line react-hooks/exhaustive-deps
// src/App.jsx
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext'; // assuming you have this from earlier
import useContentful from './Hooks/Contentful';
import { mapContentfulItemToCard } from './utils/contentful';
//soft
//again
//import Header from './components/Header';
import Header from './components/Header';
import Footer from './components/Footer';
import CartModal from './components/CartModal';

import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import AllShopPage from './pages/AllShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AboutPage from './pages/AboutPage';
import CheckoutPage from './pages/CheckoutPage';
import Dashboard from './pages/Dashboard';
// import OrdersList from './pages/OrdersList';
import AdminPrototype from './pages/AdminPrototype';
import WarehouseQueue from './pages/WarehouseQueue';
import CustomerTracking from './pages/CustomerTracking';
import DeliveryDetail from './pages/DeliveryDetail';
import FulfillOrder from './pages/FulfillOrder';
import DeliveryQueue from './pages/DeliveryQueue';
import OrderDetail from './pages/OrderDetail';
import ParcelManagement from './pages/ParcelManagement';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardLayout from './pages/DashboardLayout';
import OrdersList from './pages/OrdersList';
import { Toaster } from 'react-hot-toast';


// import logo from './Images/logo.JPEG';

import { theme } from './utils/constants';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ReturnsPage from './pages/ReturnsPage';

function AppContent() {
  //ignore eslint for all
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function ProtectedDashboard() {
  const { user, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  
  return <DashboardLayout />;
}

  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [books, setBooks] = useState([]);
  const [accessories, setAccessories] = useState([]);
// eslint-disable-next-line 
  const { getAuthors } = useContentful();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAuthors();
        if (!response) return;

        const formatted = response.map((item, i) => mapContentfulItemToCard(item, i));
        setBooks(formatted.filter(p => p.category === 'books' || p.category === 'book'));
        setAccessories(formatted.filter(p => !['books', 'book'].includes(p.category)));
      } catch (err) {
        console.error('Failed to fetch products:', err);
      }
    };

    fetchData();
  }, []);

const navigateTo = (page, data = null) => {


  // Product details
  if(page === 'product-detail' && data){

    navigate(`/product/${data.title}`, {
      state:{
        product:data
      }
    });

    return;

  }



  const pathMap = {

    home:'/',
    books:'/books',
    accessories:'/accessories',
    shop:'/shop',
    about:'/about',
    checkout:'/checkout',
    login:'/login',
    signup:'/signup',
    returns:'/returns',
    tracking:'/customer-tracking',

  };



  // Search support
  if(page === 'shop' && data?.search){

    navigate(
      `/shop?search=${encodeURIComponent(data.search)}`
    );

    return;

  }



  navigate(pathMap[page] || '/');

};
// const navigateTo = (page, data = null) => {

//   // Product details navigation
//   if(page === 'product-detail' && data){

//     navigate(`/product/${data.title}`, {
//       state:{
//         product:data
//       }
//     });

//     return;
//   }


//   const pathMap = {
//     home:'/',
//     books:'/books',
//     accessories:'/accessories',
//     shop:'/shop',
//     about:'/about',
//     checkout:'/checkout',
//     login:'/login',
//     signup:'/signup',
//     returns:'/returns',
//   };


//   // Search navigation
//   if(page === 'shop' && data?.search){

//     navigate('/shop', {
//       state:{
//         search:data.search
//       }
//     });

//     return;
//   }


//   navigate(pathMap[page] || '/');

// };
  //usenavigate 
//   const navigateTo = (page, product = null) => {
//   if (page === 'product-detail' && product) {
//     //navigate(`/product/${product.id}`, { state: { product } });
//     navigate(`/product/${product?.title}`, { state: { product } });
//   } else {
//     const pathMap = {
//       home: '/',
//       books: '/books',
//       accessories: '/accessories',
//       shop: '/shop',
//       about: '/about',
//       checkout: '/checkout',
//       login: '/login',
//       signup: '/signup',
//       returns: '/returns',
//     };
//     navigate(pathMap[page] || '/');
//   }
// };

  // ─── Cart helpers ────────────────────────────────────────────────
  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((i) => i.id !== id));
  };

  const updateQuantity = (id, qty) => {
    if (qty < 1) return removeFromCart(id);
    setCartItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, quantity: qty } : i))
    );
  };

  const getTotalPrice = () =>
    cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0).toFixed(2);

  const getCartCount = () => cartItems.reduce((sum, i) => sum + i.quantity, 0);

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);

  // ─── Navigation helpers ──────────────────────────────────────────
  const goToProduct = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  const goTo = (path) => navigate(path);

  const allProducts = [...books, ...accessories];

  return (
    <div
      style={{
        fontFamily: "'Roboto', system-ui, sans-serif",
        minHeight: '100vh',
        backgroundColor: theme.bg,
        color: theme.text
      }}
    >
      {/* Google Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&family=Roboto+Slab:wght@400;700&display=swap"
        rel="stylesheet"
      />
      <Header
  cartItemsCount={getCartCount()}
  openCart={openCart}
  navigateTo={navigateTo} />
{/* 
      <Header
        cartItemsCount={getCartCount()}
        openCart={openCart}
        goTo={goTo}
      /> */}

      <main style={{ paddingTop: '1px' }}>
        <Routes>

          {/* <Route
            path="/"
            element={
              <HomePage
                addToCart={addToCart}
                goToProduct={goToProduct}
                goTo={goTo}
                books={books}
                accessories={accessories}
              />
            }
          />

          <Route
            path="/books"
            element={
              <ShopPage
                products={books}
                addToCart={addToCart}
                goToProduct={goToProduct}
                title="Books Collection"
              />
            }
          />

          <Route
            path="/accessories"
            element={
              <ShopPage
                products={accessories}
                addToCart={addToCart}
                goToProduct={goToProduct}
                title="Accessories Collection"
              />
            }
          />

          <Route
            path="/shop"
            element={
              <AllShopPage
                products={allProducts}
                addToCart={addToCart}
                goToProduct={goToProduct}
              />
            }
          />

          <Route path="/about" element={<AboutPage />} />

          <Route
            path="/product/:id"
            element={
              <ProductDetailPage
                addToCart={addToCart}
                goTo={goTo}
                allProducts={allProducts} // fallback if state is lost
              />
            }
          />

          <Route
            path="/checkout"
            element={
              <CheckoutPage
                cartItems={cartItems}
                getTotalPrice={getTotalPrice}
                goTo={goTo}
              />
            }
          /> */}

            <Route
              path="/"
              element={
                <HomePage
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← add this
                  books={books}
                  accessories={accessories}
                />
              }
            />
            <Route
              path="/Home"
              element={
                <Home
                  // addToCart={addToCart}
                  // navigateTo={navigateTo}           // ← add this
                  // books={books}
                  // accessories={accessories}
                />
              }
            />

            <Route
              path="/books"
              element={
                <ShopPage
                  products={books}
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← add
                  title="Books Collection"
                />
              }
            />
            <Route
              path="/returns"
              element={
                <ReturnsPage
                  products={books}
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← add
                  title="Books Collection"
                />
              }
            />

            <Route
              path="/accessories"
              element={
                <ShopPage
                  products={accessories}
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← add
                  title="Accessories Collection"
                />
              }
            />

            <Route
              path="/shop"
              element={

              <AllShopPage

              products={allProducts}

              addToCart={addToCart}

              navigateTo={navigateTo}

              />

              }
              />
            {/* <Route
              path="/shop"
              element={
                <AllShopPage
                  products={allProducts}
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← add
                />
              }
            /> */}
            <Route
              path="/shops"
              element={
                <Shop
                  // products={allProducts}
                  // addToCart={addToCart}
                  // navigateTo={navigateTo}           // ← add
                />
              }
            />

            <Route
              path="/about"
              element={<AboutPage />}               // no navigation needed → can skip
            />

            
            <Route path="/product/:slug" element={<ProductDetailPage addToCart={addToCart} allProducts={allProducts} navigateTo={navigateTo} />} />

            {/* <Route
              path="/product/:id"
              element={
                <ProductDetailPage
                  addToCart={addToCart}
                  navigateTo={navigateTo}           // ← critical — this is likely the source
                />
              }
            /> */}

            <Route
              path="/checkout"
              element={
                <CheckoutPage
                  cartItems={cartItems}
                  getTotalPrice={getTotalPrice}
                  navigateTo={navigateTo}           // ← add if you have back buttons etc.
                />
              }
            />

          {/* add dashboard layouyt route */}
            

            {/* protected routes */}
            {/* Protected dashboard + nested routes */}
            <Route path="/dashboard" element={<ProtectedDashboard />}>
              <Route index element={<Dashboard />} />                     {/* /dashboard → Dashboard */}
              <Route path="prototype" element={<AdminPrototype />} />             {/* /dashboard/dashboard → Dashboard */}
              <Route path="orders" element={<OrdersList />} />             {/* /dashboard/orders */}
              <Route path="order/:id" element={<OrderDetail />} />       {/* /dashboard/orders/123 */}
              <Route path="parcel" element={<ParcelManagement />} />      {/* /dashboard/parcel */}
              <Route path="tracking" element={<CustomerTracking />} />    {/* /dashboard/tracking */}
              <Route path="delivery-queue" element={<DeliveryQueue />} />  {/* /dashboard/delivery-queue */}
              <Route path="warehouse-queue" element={<WarehouseQueue />} />  {/* /dashboard/warehouse-queue */}
              <Route path="fulfill-order/:reference" element={<FulfillOrder />} />  {/* /dashboard/fulfill-order/:reference */}
              
              {/* Optional: 404 inside dashboard */}
              <Route path="*" element={<div>Page not found in dashboard</div>} />
            </Route>

          <Route path="/dashlayout" element={<DashboardLayout />} />

          <Route path="/login" element={<LoginPage navigateTo={navigateTo} />} />
          <Route path="/signup" element={<SignupPage navigateTo={navigateTo} />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route path="/orders" element={<OrdersList />} />
          <Route path="/admin-prototype" element={<AdminPrototype />} />
          <Route path="/warehouse-queue" element={<WarehouseQueue />} />
          <Route path="/customer-tracking" element={<CustomerTracking />} />
          <Route path="/delivery-detail" element={<DeliveryDetail />} />
          <Route path="/fulfill-order" element={<FulfillOrder />} />
          <Route path="/delivery-queue" element={<DeliveryQueue />} />
          <Route path="/order-detail" element={<OrderDetail />} />
          <Route path="/parcel-management" element={<ParcelManagement />} />

          {/* Fallback / 404 */}
          <Route path="*" element={<HomePage addToCart={addToCart} goToProduct={goToProduct} goTo={goTo} books={books} accessories={accessories} />} />
        </Routes>
      </main>

      <Footer goTo={goTo} />
      <CartModal
        isOpen={isCartOpen}
        closeCart={closeCart}
        cartItems={cartItems}
        updateQuantity={updateQuantity}
        removeFromCart={removeFromCart}
        getTotalPrice={getTotalPrice}
        navigateTo={navigateTo}           // ← add this (for "Proceed to Checkout")
      />

      //
      <Toaster
  position="top-right"
  gutter={12}
  reverseOrder={false}
  toastOptions={{
    duration: 2800,
    style: {
      background: "#fff",
      color: "#111",
      borderRadius: "14px",
      border: `1px solid ${theme.border}`,
      padding: "14px 18px",
      boxShadow: "0 15px 40px rgba(0,0,0,.12)",
      fontSize: "15px",
      fontWeight: 500,
    },
    success: {
      iconTheme: {
        primary: theme.primary,
        secondary: "#fff",
      },
    },
  }}
/>



      {/* <CartModal
        isOpen={isCartOpen}
        closeCart={closeCart}
        cartItems={cartItems}
        updateQuantity={updateQuantity}
        removeFromCart={removeFromCart}
        getTotalPrice={getTotalPrice}
        goTo={goTo}
      /> */}

      {isCartOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(30,30,47,0.55)',
            zIndex: 999
          }}
          onClick={closeCart}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
// /* eslint-disable no-console */
// import React, { useState, useEffect } from 'react';
// import { ShoppingCart, X, Minus, Plus, Trash2 } from 'lucide-react';
// import useContentful from "./Hooks/Contentful";

// // Images – adjust paths if needed
// import logo from './Images/logo.JPEG';
// import Book15 from './Images/Book15.jpg';
// import Book11 from './Images/Hero1.JPG';

// // ────────────────────────────────────────────────
// // Utilities
// // ────────────────────────────────────────────────

// const splitToArray = (value) => value ? value.split(",").map(v => v.trim()).filter(Boolean) : [];

// const getImageUrl = (asset) => asset?.fields?.file?.url ? `https:${asset.fields.file.url}` : null;

// const mapContentfulItemToCard = (item, index) => ({
//   id: item.sys?.id || index,
//   title: item?.title,
//   author: "UPENDO STORE Collection",
//   price: Number(item?.price) / 100,
//   image: getImageUrl(item?.backgroundImage || item.bgimage),
//   description: item?.description,
//   category: item?.category === "book" ? "books" : "accessories",
//   type: item?.category,
//   variants: { sizes: splitToArray(item?.sizes), colors: splitToArray(item?.colours) }
// });

// const BASE_URL = "https://booklenco-1.onrender.com";

// const theme = {
//   primary:    '#5e35b1',
//   primaryDark:'#4527a0',
//   accent:     '#ffb300',
//   accentDark: '#ff8f00',
//   text:       '#1e1e2f',
//   textLight:  '#4a4a68',
//   bg:         '#fdfbfe',
//   bgLight:    '#f8f5ff',
//   surface:    '#ffffff',
//   border:     '#e0d4ff',
//   shadowSm:   '0 4px 12px rgba(69,39,160,0.12)',
//   shadowMd:   '0 8px 24px rgba(69,39,160,0.18)',
// };

// // ────────────────────────────────────────────────
// // Main App
// // ────────────────────────────────────────────────

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [books, setBooks] = useState([]);
//   const [accessories, setAccessories] = useState([]);

//   const { getAuthors } = useContentful();

//   useEffect(() => {
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     const fetchData = async () => {
//       const response = await getAuthors();
//       if (!response) return;
//       const formatted = response.map((item, i) => mapContentfulItemToCard(item, i));
//       setBooks(formatted.filter(p => p.category === "books" || p.category === "book"));
//       setAccessories(formatted.filter(p => !["books", "book"].includes(p.category)));
//     };
//     fetchData();
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const allProducts = [...books, ...accessories];

//   const addToCart = (product) => {
//     setCartItems(prev => {
//       const existing = prev.find(i => i.id === product.id);
//       if (existing) return prev.map(i => i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i);
//       return [...prev, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => setCartItems(prev => prev.filter(i => i.id !== id));

//   const updateQuantity = (id, qty) => {
//     if (qty < 1) return removeFromCart(id);
//     setCartItems(prev => prev.map(i => i.id === id ? { ...i, quantity: qty } : i));
//   };

//   const getTotalPrice = () => cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0).toFixed(2);

//   const getCartCount = () => cartItems.reduce((sum, i) => sum + i.quantity, 0);

//   const navigateTo = (page, product = null) => {
//     setCurrentPage(page);
//     setSelectedProduct(product);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':           return <HomePage       addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//       case 'books':          return <ShopPage       navigateTo={navigateTo} products={books}      addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':    return <ShopPage       navigateTo={navigateTo} products={accessories} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':           return <AllShopPage    navigateTo={navigateTo} products={allProducts} addToCart={addToCart} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />;
//       case 'about':          return <AboutPage      />;
//       case 'checkout':       return <CheckoutPage   cartItems={cartItems} getTotalPrice={getTotalPrice} navigateTo={navigateTo} />;
//       case 'product-detail': return selectedProduct ? <ProductDetailPage product={selectedProduct} addToCart={addToCart} navigateTo={navigateTo} /> : <div>Product not found</div>;
//       default:               return <HomePage       addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Roboto', system-ui, sans-serif", minHeight: '100vh', backgroundColor: theme.bg, color: theme.text }}>
//       <link rel="preconnect" href="https://fonts.googleapis.com" />
//       <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
//       <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&family=Roboto+Slab:wght@400;700&display=swap" rel="stylesheet" />

//       <Header currentPage={currentPage} navigateTo={navigateTo} cartItemsCount={getCartCount()} openCart={() => setIsCartOpen(true)} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />

//       <main style={{ paddingTop: '1px' }}>{renderPage()}</main>

//       <Footer navigateTo={navigateTo} />

//       <CartModal isOpen={isCartOpen} closeCart={() => setIsCartOpen(false)} cartItems={cartItems} updateQuantity={updateQuantity} removeFromCart={removeFromCart} getTotalPrice={getTotalPrice} navigateTo={navigateTo} />

//       {isCartOpen && <div style={{ position: 'fixed', inset: 0, background: 'rgba(30,30,47,0.55)', zIndex: 999 }} onClick={() => setIsCartOpen(false)} />}
//     </div>
//   );
// }

// // ────────────────────────────────────────────────
// // Header
// // ────────────────────────────────────────────────

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   const navItems = [
//     { label: 'Home', page: 'home' },
//     { label: 'Books', page: 'books' },
//     { label: 'Accessories', page: 'accessories' },
//     { label: 'Shop', page: 'shop' },
//     { label: 'About', page: 'about' },
//   ];

//   return (
//     <header style={{
//       background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//       color: 'white',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100,
//       boxShadow: theme.shadowMd
//     }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '80px' }}>

//           <div onClick={() => navigateTo('home')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 12 }}>
//             <img src={logo} alt="Upendo Store" style={{ height: 52, borderRadius: 8 }} />
//             <span style={{ fontSize: '1.6rem', fontWeight: 700, letterSpacing: '0.4px', fontFamily: "'Roboto Slab', serif" }}>
//               UPENDO STORE
//             </span>
//           </div>

//           <nav style={{ display: 'flex', alignItems: 'center', gap: '2.2rem' }} className="desktop-nav">
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => navigateTo(item.page)}
//                 style={{
//                   fontWeight: currentPage === item.page ? 600 : 500,
//                   color: currentPage === item.page ? theme.accent : 'white',
//                   cursor: 'pointer',
//                   padding: '8px 0',
//                   borderBottom: currentPage === item.page ? `2px solid ${theme.accent}` : 'none',
//                   transition: 'all 0.2s',
//                   fontSize: '1.05rem'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}
//             <button onClick={openCart} style={{ background: 'none', border: 'none', color: 'white', position: 'relative', cursor: 'pointer' }}>
//               <ShoppingCart size={26} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute', top: -10, right: -10,
//                   background: theme.accent, color: '#111',
//                   width: 24, height: 24, borderRadius: '50%',
//                   fontSize: '0.8rem', fontWeight: 700,
//                   display: 'grid', placeItems: 'center'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           <button
//             className="mobile-hamburger"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{ background: 'none', border: 'none', color: 'white', fontSize: '2.1rem', cursor: 'pointer', display: 'none' }}
//           >
//             {mobileMenuOpen ? <X size={32} /> : '☰'}
//           </button>
//         </div>

//         {mobileMenuOpen && (
//           <div style={{
//             background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//             padding: '1.5rem 24px',
//             boxShadow: '0 12px 32px rgba(0,0,0,0.35)'
//           }} className="mobile-menu">
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => navigateTo(item.page)}
//                 style={{
//                   padding: '12px 0',
//                   fontSize: '1.15rem',
//                   fontWeight: currentPage === item.page ? 600 : 500,
//                   color: currentPage === item.page ? theme.accent : 'white',
//                   cursor: 'pointer'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       <style jsx global>{`
//         @media (max-width: 768px) {
//           .desktop-nav { display: none !important; }
//           .mobile-hamburger { display: block !important; }
//         }
//         @media (min-width: 769px) {
//           .mobile-menu { display: none !important; }
//         }
//       `}</style>
//     </header>
//   );
// }

// // ────────────────────────────────────────────────
// // Home Page
// // ────────────────────────────────────────────────

// function HomePage({ addToCart, navigateTo, books, accessories }) {
//   const featuredBooks = books.slice(0, 3);
//   const featuredAccessories = accessories.slice(0, 3);

//   return (
//     <>
//       <section style={{
//         background: `linear-gradient(rgba(30,30,47,0.72), rgba(30,30,47,0.82)), url(${Book11})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center 30%',
//         color: 'white',
//         textAlign: 'center',
//         padding: 'clamp(8rem, 18vw, 12rem) 24px 8rem'
//       }}>
//         <h1 style={{
//           fontSize: 'clamp(2.8rem, 8vw, 5.2rem)',
//           margin: '0 0 1.2rem',
//           fontFamily: "'Roboto Slab', serif",
//           fontWeight: 700,
//           letterSpacing: '-0.5px'
//         }}>
//           Discover The Captivating World of Colour
//         </h1>
//         <p style={{ fontSize: 'clamp(1.25rem, 3.5vw, 1.6rem)', maxWidth: '720px', margin: '0 auto 2.5rem', opacity: 0.95 }}>
//           Explore the vibrant world of our colour therapy books
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//             color: '#111',
//             border: 'none',
//             padding: '1rem 2.8rem',
//             fontSize: '1.15rem',
//             fontWeight: 600,
//             borderRadius: '50px',
//             cursor: 'pointer',
//             boxShadow: '0 8px 24px rgba(255,179,0,0.35)',
//             transition: 'all 0.28s ease'
//           }}
//         >
//           Browse Collection
//         </button>
//       </section>

//       <FeaturedSection title="Featured Books" products={featuredBooks} addToCart={addToCart} navigateTo={navigateTo} bg="white" />
//       <FeaturedSection title="Literary Accessories" products={featuredAccessories} addToCart={addToCart} navigateTo={navigateTo} bg={theme.bgLight} />

//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function FeaturedSection({ title, products, addToCart, navigateTo, bg }) {
//   return (
//     <section style={{ padding: '6rem 24px', background: bg }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.6rem',
//           marginBottom: '3.5rem',
//           fontFamily: "'Roboto Slab', serif",
//           position: 'relative',
//           color: theme.text
//         }}>
//           {title}
//           <span style={{
//             position: 'absolute',
//             bottom: '-12px', left: '50%', transform: 'translateX(-50%)',
//             width: '90px', height: '4px',
//             background: theme.accent,
//             borderRadius: '2px'
//           }} />
//         </h2>

//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {products.map(p => <ProductCard key={p.id} product={p} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>

//         <div style={{ textAlign: 'center', marginTop: '3.5rem' }}>
//           <button
//             onClick={() => navigateTo(title.includes('Books') ? 'books' : 'accessories')}
//             style={{
//               background: 'transparent',
//               border: `2px solid ${theme.primary}`,
//               color: theme.primary,
//               padding: '0.9rem 2.2rem',
//               fontSize: '1.05rem',
//               fontWeight: 500,
//               borderRadius: '50px',
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             View All {title.includes('Books') ? 'Books' : 'Accessories'}
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// // ────────────────────────────────────────────────
// // Product Card
// // ────────────────────────────────────────────────

// function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <div style={{
//       background: theme.surface,
//       borderRadius: '12px',
//       overflow: 'hidden',
//       boxShadow: theme.shadowSm,
//       transition: 'all 0.32s ease',
//       border: `1px solid ${theme.border}`
//     }}
//     onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-10px)'; e.currentTarget.style.boxShadow = theme.shadowMd; }}
//     onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = theme.shadowSm; }}>
//       <div style={{ height: '320px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
//           onMouseEnter={e => e.target.style.transform = 'scale(1.07)'}
//           onMouseLeave={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.6rem' }}>
//         <h3 style={{ fontSize: '1.28rem', margin: '0 0 0.5rem', fontWeight: 600 }}>{product.title}</h3>
//         <p style={{ color: theme.textLight, fontSize: '0.96rem', margin: '0 0 0.8rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.42rem', fontWeight: 700, color: theme.primary, margin: '0 0 1.2rem' }}>
//           zmk {product.price.toFixed(2)}
//         </p>
//         <div style={{ display: 'flex', gap: '12px' }}>
//           <button
//             onClick={() => navigateTo('product-detail', product)}
//             style={{
//               flex: 1,
//               background: 'transparent',
//               border: `2px solid ${theme.primary}`,
//               color: theme.primary,
//               padding: '0.8rem',
//               borderRadius: '50px',
//               fontWeight: 500,
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             Details
//           </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//               color: '#111',
//               border: 'none',
//               padding: '0.8rem',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ────────────────────────────────────────────────
// // Shop & All Shop Pages
// // ────────────────────────────────────────────────

// function ShopPage({ products, addToCart, title, navigateTo }) {
//   return (
//     <section style={{ padding: '6rem 24px', background: 'white' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.8rem',
//           marginBottom: '3.5rem',
//           fontFamily: "'Roboto Slab', serif",
//           position: 'relative'
//         }}>
//           {title}
//           <span style={{ position: 'absolute', bottom: '-14px', left: '50%', transform: 'translateX(-50%)', width: '100px', height: '4px', background: theme.accent, borderRadius: '2px' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {products.map(p => <ProductCard key={p.id} product={p} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory, navigateTo }) {
//   const filtered = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '6rem 24px', background: 'white' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.8rem',
//           marginBottom: '2.5rem',
//           fontFamily: "'Roboto Slab', serif"
//         }}>
//           Complete Collection
//         </h2>

//         <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3.5rem', flexWrap: 'wrap' }}>
//           {['all', 'books', 'accessories'].map(cat => (
//             <button
//               key={cat}
//               onClick={() => setSelectedCategory(cat)}
//               style={{
//                 background: selectedCategory === cat ? theme.primary : 'transparent',
//                 color: selectedCategory === cat ? 'white' : theme.primary,
//                 border: `2px solid ${theme.primary}`,
//                 padding: '0.8rem 1.8rem',
//                 borderRadius: '50px',
//                 fontWeight: 500,
//                 cursor: 'pointer',
//                 transition: 'all 0.25s'
//               }}
//             >
//               {cat === 'all' ? 'All Products' : cat.charAt(0).toUpperCase() + cat.slice(1)}
//             </button>
//           ))}
//         </div>

//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {filtered.map(p => <ProductCard key={p.id} product={p} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//       </div>
//     </section>
//   );
// }

// // ────────────────────────────────────────────────
// // Product Detail Page
// // ────────────────────────────────────────────────

// function ProductDetailPage({ product, addToCart, navigateTo }) {
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);

//   const hasSizes  = product.variants?.sizes?.length  > 0;
//   const hasColors = product.variants?.colors?.length > 0;

//   const handleAdd = () => {
//     if (hasSizes  && !selectedSize)  return alert("Please select a size");
//     if (hasColors && !selectedColor) return alert("Please select a color");

//     addToCart({
//       ...product,
//       quantity,
//       selectedSize:  selectedSize  || null,
//       selectedColor: selectedColor || null,
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     });
//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '6rem 24px 8rem', background: 'white', maxWidth: '1280px', margin: '0 auto' }}>
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: theme.primary,
//           fontSize: '1.1rem',
//           marginBottom: '2.5rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 8
//         }}
//       >
//         ← Back to Shop
//       </button>

//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: '4rem', alignItems: 'start' }}>
//         <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
//           <img src={product.image} alt={product.title} style={{ width: '100%', height: 'auto', display: 'block' }} />
//         </div>

//         <div>
//           <h1 style={{ fontSize: '2.6rem', margin: '0 0 0.8rem', fontFamily: "'Roboto Slab', serif" }}>{product.title}</h1>
//           <p style={{ color: theme.textLight, fontSize: '1.15rem', margin: '0 0 1.5rem' }}>{product.author}</p>
//           <p style={{ fontSize: '2.2rem', fontWeight: 700, color: theme.primary, margin: '0 0 2rem' }}>zmk{product.price.toFixed(2)}</p>

//           <p style={{ lineHeight: 1.8, color: theme.textLight, marginBottom: '2.5rem' }}>{product.description || "No description available."}</p>

//           {hasSizes && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(s => (
//                   <button
//                     key={s}
//                     onClick={() => setSelectedSize(s)}
//                     style={{
//                       padding: '0.7rem 1.4rem',
//                       border: selectedSize === s ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
//                       background: selectedSize === s ? theme.primary : 'white',
//                       color: selectedSize === s ? 'white' : theme.text,
//                       borderRadius: '50px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       minWidth: '80px'
//                     }}
//                   >
//                     {s}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {hasColors && (
//             <div style={{ marginBottom: '2.5rem' }}>
//               <h4 style={{ margin: '0 0 1rem', fontSize: '1.15rem' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(c => (
//                   <button
//                     key={c}
//                     onClick={() => setSelectedColor(c)}
//                     style={{
//                       padding: '0.7rem 1.4rem',
//                       border: selectedColor === c ? `2px solid ${theme.primary}` : `1px solid ${theme.border}`,
//                       background: selectedColor === c ? `${theme.primary}15` : 'white',
//                       color: theme.text,
//                       borderRadius: '50px',
//                       fontWeight: 500,
//                       cursor: 'pointer',
//                       minWidth: '100px'
//                     }}
//                   >
//                     {c}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
//             <div style={{ display: 'flex', border: `1px solid ${theme.border}`, borderRadius: '50px', overflow: 'hidden' }}>
//               <button onClick={() => setQuantity(q => Math.max(1, q - 1))} style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}><Minus size={20} /></button>
//               <span style={{ padding: '0.9rem 1.8rem', fontWeight: 600, minWidth: '60px', textAlign: 'center' }}>{quantity}</span>
//               <button onClick={() => setQuantity(q => q + 1)} style={{ padding: '0.9rem 1.2rem', background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer' }}><Plus size={20} /></button>
//             </div>

//             <button onClick={handleAdd} style={{ flex: 1, minWidth: '220px', background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`, color: '#111', border: 'none', padding: '1rem 2rem', borderRadius: '50px', fontSize: '1.1rem', fontWeight: 600, cursor: 'pointer' }}>
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// // ────────────────────────────────────────────────
// // Cart Modal
// // ────────────────────────────────────────────────

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   if (!isOpen) return null;

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0, right: 0,
//       width: '100%',
//       maxWidth: '420px',
//       height: '100%',
//       background: 'white',
//       boxShadow: '-8px 0 32px rgba(0,0,0,0.25)',
//       zIndex: 1000,
//       display: 'flex',
//       flexDirection: 'column'
//     }}>
//       <div style={{
//         padding: '1.5rem 1.8rem',
//         background: `linear-gradient(135deg, ${theme.primaryDark}, ${theme.primary})`,
//         color: 'white',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center'
//       }}>
//         <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}><X size={28} /></button>
//       </div>

//       <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '4rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.variantId || item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: `1px solid ${theme.border}` }}>
//               <img src={item.image} alt={item.title} style={{ width: '80px', height: '100px', objectFit: 'cover', borderRadius: '8px', marginRight: '1rem' }} />
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ margin: '0 0 0.4rem', fontSize: '1.1rem' }}>
//                   {item.title}
//                   {(item.selectedSize || item.selectedColor) && (
//                     <div style={{ fontSize: '0.9rem', color: theme.textLight, marginTop: '0.3rem' }}>
//                       {item.selectedSize && `Size: ${item.selectedSize}`}
//                       {item.selectedSize && item.selectedColor && ' • '}
//                       {item.selectedColor && `Color: ${item.selectedColor}`}
//                     </div>
//                   )}
//                 </h4>
//                 <p style={{ color: theme.primary, fontWeight: 600, margin: '0.4rem 0' }}>zmk {item.price.toFixed(2)}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
//                   <div style={{ display: 'flex', border: `1px solid ${theme.border}`, borderRadius: '50px' }}>
//                     <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ padding: '0.5rem 0.9rem', background: 'none', border: 'none', cursor: 'pointer' }}><Minus size={16} /></button>
//                     <span style={{ padding: '0.5rem 1rem', minWidth: '40px', textAlign: 'center', fontWeight: 600 }}>{item.quantity}</span>
//                     <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ padding: '0.5rem 0.9rem', background: 'none', border: 'none', cursor: 'pointer' }}><Plus size={16} /></button>
//                   </div>
//                   <button onClick={() => removeFromCart(item.id)} style={{ color: '#999', background: 'none', border: 'none', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', fontSize: '1.3rem', fontWeight: 600 }}>
//             <span>Total:</span>
//             <span style={{ color: theme.primary }}>zmk {getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.8rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//                 color: '#111',
//                 border: 'none',
//                 padding: '1.1rem',
//                 borderRadius: '50px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer'
//               }}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// // ────────────────────────────────────────────────
// // About Pages
// // ────────────────────────────────────────────────

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '4rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
//           <img src={Book15} alt="Author" style={{ width: '100%', height: 'auto', display: 'block' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2.2rem', marginBottom: '1.5rem', fontFamily: "'Roboto Slab', serif" }}>About the Author</h3>
//           <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '2rem', color: theme.textLight, lineHeight: 1.8 }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{ background: theme.primary, color: 'white', border: 'none', padding: '0.9rem 2.2rem', borderRadius: '50px', fontWeight: 500, cursor: 'pointer' }}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '6rem 24px', background: 'white' }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.8rem',
//           marginBottom: '3.5rem',
//           fontFamily: "'Roboto Slab', serif",
//           position: 'relative'
//         }}>
//           About the Store
//           <span style={{ position: 'absolute', bottom: '-14px', left: '50%', transform: 'translateX(-50%)', width: '100px', height: '4px', background: theme.accent, borderRadius: '2px' }} />
//         </h2>

//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '4rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
//             <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto', display: 'block' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2.2rem', marginBottom: '1.5rem', fontFamily: "'Roboto Slab', serif" }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
//               Her debut novel quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ color: theme.textLight, lineHeight: 1.8 }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring new sources of inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// // ────────────────────────────────────────────────
// // Footer
// // ────────────────────────────────────────────────

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       background: `linear-gradient(135deg, ${theme.primaryDark}, ${theme.primary})`,
//       color: 'white',
//       padding: '5rem 24px 3rem',
//       marginTop: 'auto'
//     }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '3rem' }}>
//         <div>
//           <h3 style={{ fontSize: '1.6rem', marginBottom: '1.5rem', fontFamily: "'Roboto Slab', serif" }}>UPENDO STORE</h3>
//           <p style={{ opacity: 0.9, lineHeight: 1.7, fontSize: '0.97rem' }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>
//         </div>

//         <div>
//           <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>Quick Links</h3>
//           {['home','books','accessories','about'].map(p => (
//             <div key={p} style={{ marginBottom: '0.9rem' }}>
//               <button onClick={() => navigateTo(p)} style={{ color: 'white', background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}>
//                 {p.charAt(0).toUpperCase() + p.slice(1)}
//               </button>
//             </div>
//           ))}
//         </div>

//         <div>
//           <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>Contact</h3>
//           <p style={{ marginBottom: '0.8rem' }}>📍 Lusaka, Zambia</p>
//           <p style={{ marginBottom: '0.8rem' }}>✉️ hello@upendostore.com</p>
//         </div>
//       </div>

//       <div style={{ textAlign: 'center', marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.15)', opacity: 0.8, fontSize: '0.95rem' }}>
//         © {new Date().getFullYear()} UPENDO STORE. All rights reserved.
//       </div>
//     </footer>
//   );
// }

// // ────────────────────────────────────────────────
// // Checkout Page
// // ────────────────────────────────────────────────

// // ────────────────────────────────────────────────
// // Checkout Page – restored full logic + premium styling
// // ────────────────────────────────────────────────

// function CheckoutPage({ cartItems, getTotalPrice, navigateTo }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [deliveryMethod, setDeliveryMethod] = useState('pickup');
//   const [deliveryAddress, setDeliveryAddress] = useState({
//     fullName: '',
//     street: '',
//     city: '',
//     province: '',
//     postalCode: '',
//     additionalInfo: ''
//   });
//   const [phone, setPhone] = useState('');
//   const [operator, setOperator] = useState('airtel');
//   const [loading, setLoading] = useState(false);
//   const [reference, setReference] = useState('');
//   const [paymentInitiated, setPaymentInitiated] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleAddressChange = (field, value) => {
//     setDeliveryAddress(prev => ({ ...prev, [field]: value }));
//   };

//   const isDeliveryComplete = () => {
//     if (deliveryMethod === 'pickup') return true;
//     const { fullName, street, city, province } = deliveryAddress;
//     return fullName.trim() && street.trim() && city.trim() && province.trim();
//   };

//   const initiatePayment = async () => {
//     if (!phone || phone.replace(/[^0-9]/g, '').length < 9) {
//       alert("Please enter a valid phone number");
//       return;
//     }

//     setLoading(true);

//     const items = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       quantity: item.quantity,
//       size: item.selectedSize || null,
//       color: item.selectedColor || null,
//       totalCost: item.price * item.quantity
//     }));

//     const payload = {
//       amount: parseFloat(getTotalPrice()),
//       phone_number: phone.replace(/[^0-9]/g, ''),
//       operator,
//       items,
//       delivery_method: deliveryMethod,
//       delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
//     };

//     try {
//       const response = await fetch(`${BASE_URL}/payment`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       const data = await response.json();

//       if (response.ok && data.data?.reference) {
//         setReference(data.data.reference);
//         setPaymentInitiated(true);
//         alert("Payment request sent! Check your phone for the payment prompt.");
//       } else {
//         alert(data.message || "Payment initiation failed. Try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error. Please check your connection and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async () => {
//     if (!reference) return;

//     try {
//       const response = await fetch(`${BASE_URL}/collections/status/${reference}`);
//       const data = await response.json();

//       setStatus(data);

//       if (data.data?.status === "success") {
//         alert("Payment successful! Thank you for your order.");
//         // Optional: clear cart, redirect home, etc.
//         navigateTo('home');
//       } else if (data.data?.status === "failed") {
//         alert("Payment failed. You can try again.");
//       } else {
//         alert("Payment is still processing. Please wait a moment and check again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Could not check payment status. Try again later.");
//     }
//   };

//   const total = getTotalPrice();

//   return (
//     <section style={{ padding: '6rem 1.5rem 10rem', maxWidth: '960px', margin: '0 auto', background: 'white' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.8rem',
//         marginBottom: '3.5rem',
//         fontFamily: "'Roboto Slab', serif",
//         color: theme.text
//       }}>
//         Checkout
//       </h2>

//       {/* Progress Steps */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         marginBottom: '4rem',
//         gap: '1.5rem',
//         flexWrap: 'wrap'
//       }}>
//         {['Cart Review', 'Delivery', 'Payment'].map((label, i) => (
//           <React.Fragment key={label}>
//             <div style={{ textAlign: 'center', minWidth: '140px' }}>
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 margin: '0 auto 0.8rem',
//                 borderRadius: '50%',
//                 background: currentStep > i + 1 ? theme.accent :
//                             currentStep === i + 1 ? theme.primary : '#e0e0e0',
//                 color: currentStep >= i + 1 ? 'white' : '#666',
//                 display: 'grid',
//                 placeItems: 'center',
//                 fontWeight: 600,
//                 fontSize: '1.2rem'
//               }}>
//                 {i + 1}
//               </div>
//               <div style={{
//                 fontWeight: currentStep === i + 1 ? 600 : 400,
//                 color: currentStep === i + 1 ? theme.primary : '#555'
//               }}>
//                 {label}
//               </div>
//             </div>
//             {i < 2 && (
//               <div style={{
//                 height: '3px',
//                 flex: 1,
//                 maxWidth: '120px',
//                 background: currentStep > i + 1 ? theme.primary : '#ddd',
//                 borderRadius: '2px'
//               }} />
//             )}
//           </React.Fragment>
//         ))}
//       </div>

//       {/* Step 1: Cart Review */}
//       {currentStep === 1 && (
//         <div>
//           <h3 style={{ fontSize: '1.9rem', marginBottom: '2rem', color: theme.text }}>Review Your Items</h3>

//           {cartItems.length === 0 ? (
//             <p style={{ textAlign: 'center', color: theme.textLight, fontSize: '1.2rem' }}>
//               Your cart is empty
//             </p>
//           ) : (
//             <>
//               {cartItems.map(item => (
//                 <div key={item.variantId || item.id} style={{
//                   display: 'flex',
//                   gap: '1.5rem',
//                   padding: '1.2rem',
//                   border: `1px solid ${theme.border}`,
//                   borderRadius: '12px',
//                   marginBottom: '1.2rem',
//                   alignItems: 'center',
//                   background: '#faf9ff'
//                 }}>
//                   <img
//                     src={item.image}
//                     alt={item.title}
//                     style={{ width: '100px', height: '120px', objectFit: 'cover', borderRadius: '8px' }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 0.4rem', fontSize: '1.25rem' }}>{item.title}</h4>
//                     {(item.selectedSize || item.selectedColor) && (
//                       <p style={{ color: theme.textLight, margin: '0.3rem 0' }}>
//                         {item.selectedSize && `Size: ${item.selectedSize}`}
//                         {item.selectedSize && item.selectedColor && ' • '}
//                         {item.selectedColor && `Color: ${item.selectedColor}`}
//                       </p>
//                     )}
//                     <p style={{ color: theme.primary, fontWeight: 600, margin: '0.5rem 0' }}>
//                       zmk{item.price.toFixed(2)} × {item.quantity} = zmk{(item.price * item.quantity).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               ))}

//               <div style={{
//                 textAlign: 'right',
//                 padding: '1.5rem',
//                 background: theme.bgLight,
//                 borderRadius: '12px',
//                 fontSize: '1.5rem',
//                 fontWeight: 700,
//                 margin: '2rem 0',
//                 color: theme.primary
//               }}>
//                 Total: zmk {total}
//               </div>

//               <div style={{ textAlign: 'right' }}>
//                 <button
//                   onClick={() => setCurrentStep(2)}
//                   style={btnPrimary}
//                 >
//                   Continue to Delivery
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       )}

//       {/* Step 2: Delivery */}
//       {currentStep === 2 && (
//         <div>
//           <h3 style={{ fontSize: '1.9rem', marginBottom: '2rem', color: theme.text }}>Delivery Method</h3>

//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
//             <div
//               onClick={() => setDeliveryMethod('pickup')}
//               style={{
//                 padding: '1.6rem',
//                 border: deliveryMethod === 'pickup' ? `3px solid ${theme.primary}` : `2px solid ${theme.border}`,
//                 borderRadius: '12px',
//                 background: deliveryMethod === 'pickup' ? `${theme.primary}08` : 'white',
//                 cursor: 'pointer',
//                 textAlign: 'center'
//               }}
//             >
//               <input
//                 type="radio"
//                 checked={deliveryMethod === 'pickup'}
//                 readOnly
//                 style={{ display: 'none' }}
//               />
//               <strong style={{ fontSize: '1.15rem' }}>Store Pickup</strong>
//               <p style={{ margin: '0.6rem 0 0', color: theme.textLight }}>Collect from UPENDO STORE location</p>
//             </div>

//             <div
//               onClick={() => setDeliveryMethod('delivery')}
//               style={{
//                 padding: '1.6rem',
//                 border: deliveryMethod === 'delivery' ? `3px solid ${theme.primary}` : `2px solid ${theme.border}`,
//                 borderRadius: '12px',
//                 background: deliveryMethod === 'delivery' ? `${theme.primary}08` : 'white',
//                 cursor: 'pointer',
//                 textAlign: 'center'
//               }}
//             >
//               <input
//                 type="radio"
//                 checked={deliveryMethod === 'delivery'}
//                 readOnly
//                 style={{ display: 'none' }}
//               />
//               <strong style={{ fontSize: '1.15rem' }}>Home Delivery</strong>
//               <p style={{ margin: '0.6rem 0 0', color: theme.textLight }}>We'll deliver to your address</p>
//             </div>
//           </div>

//           {deliveryMethod === 'delivery' && (
//             <div style={{
//               background: theme.bgLight,
//               padding: '2rem',
//               borderRadius: '12px',
//               marginBottom: '2.5rem'
//             }}>
//               <h4 style={{ marginBottom: '1.5rem', fontSize: '1.3rem' }}>Delivery Address</h4>

//               <input
//                 type="text"
//                 placeholder="Full Name *"
//                 value={deliveryAddress.fullName}
//                 onChange={e => handleAddressChange('fullName', e.target.value)}
//                 style={inputStyle}
//               />
//               <input
//                 type="text"
//                 placeholder="Street Address *"
//                 value={deliveryAddress.street}
//                 onChange={e => handleAddressChange('street', e.target.value)}
//                 style={inputStyle}
//               />
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <input
//                   type="text"
//                   placeholder="City *"
//                   value={deliveryAddress.city}
//                   onChange={e => handleAddressChange('city', e.target.value)}
//                   style={inputStyle}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Province *"
//                   value={deliveryAddress.province}
//                   onChange={e => handleAddressChange('province', e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>
//               <input
//                 type="text"
//                 placeholder="Postal Code (optional)"
//                 value={deliveryAddress.postalCode}
//                 onChange={e => handleAddressChange('postalCode', e.target.value)}
//                 style={inputStyle}
//               />
//               <textarea
//                 placeholder="Additional info (apt, landmark...)"
//                 value={deliveryAddress.additionalInfo}
//                 onChange={e => handleAddressChange('additionalInfo', e.target.value)}
//                 style={{ ...inputStyle, height: '100px', resize: 'vertical' }}
//               />
//             </div>
//           )}

//           <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
//             <button onClick={() => setCurrentStep(1)} style={btnSecondary}>← Back</button>
//             <button
//               onClick={() => setCurrentStep(3)}
//               disabled={!isDeliveryComplete()}
//               style={{
//                 ...btnPrimary,
//                 opacity: isDeliveryComplete() ? 1 : 0.5,
//                 cursor: isDeliveryComplete() ? 'pointer' : 'not-allowed'
//               }}
//             >
//               Continue to Payment →
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Step 3: Payment */}
//       {currentStep === 3 && (
//         <div style={{ maxWidth: '540px', margin: '0 auto' }}>
//           <h3 style={{ fontSize: '1.9rem', marginBottom: '2.2rem', textAlign: 'center' }}>Mobile Money Payment</h3>

//           {!paymentInitiated ? (
//             <>
//               <div style={{ marginBottom: '1.8rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.7rem', fontWeight: 500 }}>Mobile Operator</label>
//                 <select value={operator} onChange={e => setOperator(e.target.value)} style={inputStyle}>
//                   <option value="airtel">Airtel Money</option>
//                   <option value="mtn">MTN Mobile Money</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '2.2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.7rem', fontWeight: 500 }}>Phone Number</label>
//                 <input
//                   type="tel"
//                   placeholder="e.g. 0971234567"
//                   value={phone}
//                   onChange={e => setPhone(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               <div style={{
//                 background: theme.bgLight,
//                 padding: '1.8rem',
//                 borderRadius: '12px',
//                 textAlign: 'center',
//                 fontSize: '1.6rem',
//                 fontWeight: 700,
//                 marginBottom: '2.5rem',
//                 color: theme.primary
//               }}>
//                 Total to Pay: zmk {total}
//               </div>

//               <button
//                 onClick={initiatePayment}
//                 disabled={loading || !phone.trim()}
//                 style={{
//                   ...btnPrimary,
//                   width: '100%',
//                   padding: '1.2rem',
//                   fontSize: '1.15rem',
//                   opacity: loading || !phone.trim() ? 0.6 : 1,
//                   cursor: loading || !phone.trim() ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 {loading ? 'Processing...' : `Pay ${total} via ${operator.toUpperCase()}`}
//               </button>
//             </>
//           ) : (
//             <div style={{
//               background: '#f0fdf4',
//               padding: '3rem 1.5rem',
//               borderRadius: '16px',
//               border: `2px dashed ${theme.primary}`,
//               textAlign: 'center'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '80px',
//                 background: theme.primary,
//                 color: 'white',
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2.5rem',
//                 margin: '0 auto 1.5rem'
//               }}>
//                 ✓
//               </div>

//               <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Payment Request Sent!</h3>
//               <p style={{ color: theme.textLight, marginBottom: '2rem', lineHeight: 1.6 }}>
//                 Please check your phone and approve the payment request.
//               </p>

//               <div style={{
//                 background: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '10px',
//                 marginBottom: '2rem',
//                 fontFamily: 'monospace',
//                 fontSize: '1.3rem',
//                 color: theme.primary,
//                 wordBreak: 'break-all'
//               }}>
//                 Ref: {reference}
//               </div>

//               <button
//                 onClick={checkPaymentStatus}
//                 style={{ ...btnPrimary, padding: '1rem 2.5rem', fontSize: '1.1rem' }}
//               >
//                 Check Payment Status
//               </button>

//               {status && (
//                 <div style={{
//                   marginTop: '2rem',
//                   padding: '1.2rem',
//                   background: status.data?.status === 'success' ? '#d4edda' : '#f8d7da',
//                   borderRadius: '10px',
//                   color: status.data?.status === 'success' ? '#155724' : '#721c24'
//                 }}>
//                   Status: <strong>{status.data?.status?.toUpperCase()}</strong><br />
//                   {status.message || 'No additional message'}
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ marginTop: '3rem', textAlign: 'center' }}>
//             <button onClick={() => setCurrentStep(2)} style={btnSecondary}>← Back</button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// const btnPrimary = {
//   background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
//   color: '#111',
//   border: 'none',
//   padding: '0.9rem 2.2rem',
//   borderRadius: '50px',
//   fontWeight: 600,
//   cursor: 'pointer',
//   fontSize: '1.05rem',
//   transition: 'all 0.2s'
// };

// const btnSecondary = {
//   background: 'transparent',
//   border: `2px solid ${theme.primary}`,
//   color: theme.primary,
//   padding: '0.9rem 2.2rem',
//   borderRadius: '50px',
//   fontWeight: 500,
//   cursor: 'pointer',
//   fontSize: '1.05rem'
// };

// const inputStyle = {
//   width: '100%',
//   padding: '0.95rem',
//   marginBottom: '1.2rem',
//   border: `1px solid ${theme.border}`,
//   borderRadius: '10px',
//   fontSize: '1rem',
//   background: 'white'
// };



// export default App;
// /* eslint-disable no-console */
// import React, { useState, useEffect } from 'react';
// import './App.css';
// import { ShoppingCart, X, Minus, Plus, Trash2 } from 'lucide-react';
// import useContentful from "./Hooks/Contentful";
// //import images from /imges folder
// import logo from './Images/logo.JPEG';
// import Book15 from './Images/Book15.jpg';
// import Book11 from './Images/Hero1.JPG';

// // Utility functions (moved outside component)
// const splitToArray = (value) => {
//   if (!value) return [];
//   return value
//     .split(",")
//     .map(v => v.trim())
//     .filter(Boolean);
// };

// const getImageUrl = (asset) => {
//   if (!asset?.fields?.file?.url) return null;
//   return `https:${asset.fields.file.url}`;
// };

// const mapContentfulItemToCard = (item, index) => {
//   // console.log("item", item);
//   return {
//     id: item.sys?.id || index,
//     title: item?.title,
//     author: "UPENDO STORE Collection",
//     price: Number(item?.price) / 100,
//     image: getImageUrl(item?.backgroundImage || item.bgimage),
//     description: item?.description,
//     category: item?.category === "book" ? "books" : "accessories",
//     type: item?.category,
//     variants: {
//       sizes: splitToArray(item?.sizes),
//       colors: splitToArray(item?.colours),
//     }
//   };
// };

// // === CHANGE THIS TO YOUR ACTUAL DOMAIN ===
// //const BASE_URL = "http://localhost:2002";  // ← Replace with your real domain (e.g. https://albeutystore.store)
// //const BASE_URL = "https://booklenco.onrender.com";  // ← Replace with your real domain (e.g. https://albeutystore.store)
// const BASE_URL = "https://booklenco-1.onrender.com";

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [books, setBooks] = useState([]);
//   const [accessories, setAccessories] = useState([]);

//   const { getAuthors } = useContentful();



// useEffect(() => {
//   const fetchAuthors = async () => {
//     const response = await getAuthors();
//     if (!response) return;

//     const formattedData = response.map((item, index) =>
//       mapContentfulItemToCard(item, index)
//     );

//     const bookItems = formattedData.filter(
//       product => product.category === "books" || product.category === "book"
//     );
//     const accessoryItems = formattedData.filter(
//       product => product.category !== "books" && product.category !== "book"
//     );

//     setBooks(bookItems);
//     setAccessories(accessoryItems);
//   };

//   fetchAuthors();
//    // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);


//   // useEffect(() => {
//   //   getAuthors().then((response) => {
//   //     console.log("response", response);
//   //     if (!response) return;

//   //     const formattedData = response.map((item, index) =>
//   //       mapContentfulItemToCard(item, index)
//   //     );

//   //     const bookItems = formattedData.filter(
//   //       product => product.category === "books" || product.category === "book"
//   //     );
//   //     const accessoryItems = formattedData.filter(
//   //       product => product.category !== "books" && product.category !== "book"
//   //     );

//   //     setBooks(bookItems);
//   //     setAccessories(accessoryItems);

//   //     console.log("Books:", bookItems);
//   //     console.log("Accessories:", accessoryItems);
//   //   });
//   // }, []);
//   // }, [getAuthors]);

//   const allProducts = [...books, ...accessories];

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item =>
//           item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//         );
//       }
//       return [...prevItems, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems =>
//       prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   const navigateTo = (page, product = null) => {
//     setCurrentPage(page);
//     setSelectedProduct(product);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//       case 'books':
//         return <ShopPage navigateTo={navigateTo} products={books} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage navigateTo={navigateTo} products={accessories} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage navigateTo={navigateTo} products={allProducts} addToCart={addToCart} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage
//           cartItems={cartItems}
//           getTotalPrice={getTotalPrice}
//           navigateTo={navigateTo}
//         />;
//       case 'product-detail':
//         return selectedProduct ? (
//           <ProductDetailPage
//             product={selectedProduct}
//             addToCart={addToCart}
//             navigateTo={navigateTo}
//           />
//         ) : (
//           <div>Product not found</div>
//         );
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Crimson Text', 'Georgia', serif", minHeight: '100vh', backgroundColor: '#fdfaff', color: '#222' }}>
//       <Header
//         currentPage={currentPage}
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>{renderPage()}</main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal
//         isOpen={isCartOpen}
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 0' }}>
        
//         <div
//           onClick={() => navigateTo('home')}
//           className="navbar-logo"
//         >
//           <img
//             src={logo}
//             alt="Upendo Stores"
//             className="logo-image"
//           />
//           <span className="logo-text">
//             UPENDO STORE
//           </span>
//         </div>
        
//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#B39DDB',
//             flexDirection: 'column',
//             padding: '2rem',
//             boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)'
//           }} className="nav-menu">
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button onClick={openCart} style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               cursor: 'pointer',
//               position: 'relative',
//               fontSize: '1.2rem',
//               padding: '0.5rem'
//             }}>
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-8px',
//                   right: '-8px',
//                   backgroundColor: '#90C8FF',
//                   color: '#222',
//                   borderRadius: '50%',
//                   width: '22px',
//                   height: '22px',
//                   fontSize: '0.75rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>
//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               fontSize: '1.6rem',
//               cursor: 'pointer'
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>
//       <style jsx>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//             boxShadow: none !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#fff' : 'rgba(255,255,255,0.85)',
//         cursor: 'pointer',
//         padding: '0.5rem 0',
//         borderBottom: active ? '3px solid #90C8FF' : 'none',
//         transition: 'all 0.3s'
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo, books, accessories }) {
//   const featuredBooks = books.slice(0, 3);
//   const featuredAccessories = accessories.slice(0, 3);
//   return (
//     <>
//       <section className="hero"
//         style={{
//         backgroundImage: `
//   linear-gradient(
//     rgba(0, 0, 0, 0.6),
//     rgba(0, 0, 0, 0.6)
//   ),
//   url(${Book11})
// `,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           color: '#fff',
//           textAlign: 'center',
//           padding: '8rem 2rem'
//         }}
//       >
//         <h1
//           style={{
//             fontSize: '3.5rem',
//             marginBottom: '1rem',
//             fontFamily: "'Playfair Display', serif",
//             fontWeight: 700
//           }}
//         >
//           Discover The Captivating World of Colour
//         </h1>
//         <p style={{ fontSize: '1.5rem', marginBottom: '2rem', opacity: 0.95 }}>
//           Explore the vibrant world of our colour therapy books
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#90C8FF',
//             color: '#222',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => (e.target.style.backgroundColor = '#7ab8ff')}
//           onMouseOut={e => (e.target.style.backgroundColor = '#90C8FF')}
//         >
//           Browse Collection
//         </button>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredBooks.map(book => <ProductCard key={book.id} product={book} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8f3ff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredAccessories.map(item => <ProductCard key={item.id} product={item} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>
//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 6px 20px rgba(144, 200, 255, 0.18)',
//       transition: 'all 0.3s'
//     }}
//     onMouseOver={e => {
//       e.currentTarget.style.transform = 'translateY(-10px)';
//       e.currentTarget.style.boxShadow = '0 20px 40px rgba(144, 200, 255, 0.3)';
//     }}
//     onMouseOut={e => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 6px 20px rgba(144, 200, 255, 0.18)';
//     }}>
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
//           onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
//           onMouseOut={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>{product.title}</h3>
//         <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.3rem', fontWeight: 700, color: '#90C8FF', marginBottom: '1rem' }}>${product.price}</p>
//         <div style={{ display: 'flex', gap: '0.5rem' }}>
//           <button
//           onClick={() => navigateTo('product-detail', product)}
//           style={{
//             flex: 1,
//             backgroundColor: 'transparent',
//             color: '#90C8FF',
//             border: '2px solid #90C8FF',
//             padding: '0.6rem',
//             borderRadius: '8px',
//             fontWeight: 600,
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//           onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//         >
//           View Details
//         </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ShopPage({ products, addToCart, title, navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif",
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//       </h2>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {products.map(product => <ProductCard
//   key={product.id}
//   product={product}
//   addToCart={addToCart}
//   navigateTo={navigateTo}
// />)}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory, navigateTo }) {
//   const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//         Complete Collection
//       </h2>
//       <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         <FilterButton active={selectedCategory === 'all'} onClick={() => setSelectedCategory('all')}>All Products</FilterButton>
//         <FilterButton active={selectedCategory === 'books'} onClick={() => setSelectedCategory('books')}>Books</FilterButton>
//         <FilterButton active={selectedCategory === 'accessories'} onClick={() => setSelectedCategory('accessories')}>Accessories</FilterButton>
//       </div>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {filteredProducts.map(product => <ProductCard
//   key={product.id}
//   product={product}
//   addToCart={addToCart}
//   navigateTo={navigateTo}
// />)}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#90C8FF' : 'transparent',
//         color: active ? '#222' : '#90C8FF',
//         border: '2px solid #90C8FF',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s'
//       }}
//       onMouseOver={e => !active && (e.target.style.backgroundColor = '#90C8FF', e.target.style.color = '#222')}
//       onMouseOut={e => !active && (e.target.style.backgroundColor = 'transparent', e.target.style.color = '#90C8FF')}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#f8f3ff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//           <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//             About the Author
//           </h3>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Store
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//             <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring the outdoors for inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CheckoutPage({ cartItems, getTotalPrice, navigateTo }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [deliveryMethod, setDeliveryMethod] = useState('pickup');
//   const [deliveryAddress, setDeliveryAddress] = useState({
//     fullName: '',
//     street: '',
//     city: '',
//     province: '',
//     postalCode: '',
//     additionalInfo: ''
//   });
//   const [phone, setPhone] = useState('');
//   const [operator, setOperator] = useState('airtel');
//   const [loading, setLoading] = useState(false);
//   const [reference, setReference] = useState('');
//   const [paymentInitiated, setPaymentInitiated] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleAddressChange = (field, value) => {
//     setDeliveryAddress(prev => ({ ...prev, [field]: value }));
//   };

//   const isDeliveryComplete = () => {
//     if (deliveryMethod === 'pickup') return true;
//     return deliveryAddress.fullName && deliveryAddress.street && deliveryAddress.city && deliveryAddress.province;
//   };

//   const initiatePayment = async () => {
//     if (!phone || phone.length < 10) {
//       alert("Please enter a valid phone number");
//       return;
//     }

//     setLoading(true);

//     const items = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       quantity: item.quantity,
//       size: item.selectedSize || null,
//       color: item.selectedColor || null,
//       totalCost: item.price * item.quantity
//     }));

//     const payload = {
//       amount: parseFloat(getTotalPrice()),
//       phone_number: phone.replace(/[^0-9]/g, ''),
//       operator,
//       items,
//       delivery_method: deliveryMethod,
//       delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
//     };

//     try {
//       const response = await fetch(`${BASE_URL}/payment`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       const data = await response.json();

//       if (response.ok && data.data?.reference) {
//         setReference(data.data.reference);
//         setPaymentInitiated(true);
//         alert("Payment request sent! Check your phone for the payment prompt.");
//       } else {
//         alert(data.message || "Payment initiation failed. Try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error. Please check your connection and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async () => {
//     if (!reference) return;

//     try {
//       const response = await fetch(`${BASE_URL}/collections/status/${reference}`);
//       const data = await response.json();

//       setStatus(data);

//       if (data.data?.status === "success") {
//         alert("Payment successful! Thank you for your order.");
//         navigateTo('home');
//       } else if (data.data?.status === "failed") {
//         alert("Payment failed. You can try again.");
//       } else {
//         alert("Payment is still processing. Please wait a moment and check again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Could not check payment status. Try again later.");
//     }
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif"
//       }}>
//         Checkout
//       </h2>

//       {/* Progress Steps */}
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         {['Cart Review', 'Delivery', 'Payment'].map((label, i) => (
//           <div key={i} style={{ display: 'flex', alignItems: 'center', flex: '1 1 200px', maxWidth: '300px' }}>
//             <div style={{
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               backgroundColor: currentStep > i ? '#90C8FF' : currentStep === i + 1 ? '#B39DDB' : '#eee',
//               color: 'white',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '1.1rem'
//             }}>
//               {i + 1}
//             </div>
//             <span style={{ marginLeft: '1rem', fontWeight: currentStep === i + 1 ? '600' : '400', color: '#333' }}>
//               {label}
//             </span>
//             {i < 2 && (
//               <div style={{
//                 flex: 1,
//                 height: '3px',
//                 backgroundColor: currentStep > i + 1 ? '#90C8FF' : '#ddd',
//                 margin: '0 1rem'
//               }} />
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Step 1: Cart Review */}
//       {currentStep === 1 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Review Your Items</h3>
//           {cartItems.length === 0 ? (
//             <p style={{ textAlign: 'center', color: '#999', fontSize: '1.2rem' }}>Your cart is empty</p>
//           ) : (
//             <>
//               {cartItems.map(item => (
//                 <div key={item.variantId || item.id} style={{
//                   display: 'flex',
//                   gap: '1.5rem',
//                   padding: '1.5rem',
//                   border: '1px solid #eee',
//                   borderRadius: '8px',
//                   marginBottom: '1rem',
//                   alignItems: 'center'
//                 }}>
//                   <img src={item.image} alt={item.title} style={{ width: '100px', height: '120px', objectFit: 'cover', borderRadius: '8px' }} />
//                   <div style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 0.5rem', fontSize: '1.2rem' }}>{item.title}</h4>
//                     {item.selectedSize && <p style={{ margin: '0.3rem 0', color: '#666' }}>Size: {item.selectedSize}</p>}
//                     {item.selectedColor && <p style={{ margin: '0.3rem 0', color: '#666' }}>Color: {item.selectedColor}</p>}
//                     <p style={{ margin: '0.5rem 0', color: '#90C8FF', fontWeight: '600' }}>
//                       ${item.price} × {item.quantity} = ${(item.price * item.quantity).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//               <div style={{
//                 textAlign: 'right',
//                 padding: '1.5rem',
//                 backgroundColor: '#f8f3ff',
//                 borderRadius: '8px',
//                 fontSize: '1.4rem',
//                 fontWeight: '700',
//                 color: '#B39DDB'
//               }}>
//                 Total: ${getTotalPrice()}
//               </div>
//               <div style={{ textAlign: 'right', marginTop: '2rem' }}>
//                 <button
//                   onClick={() => setCurrentStep(2)}
//                   style={{
//                     backgroundColor: '#90C8FF',
//                     color: '#222',
//                     padding: '1rem 2rem',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Continue to Delivery
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       )}

//       {/* Step 2: Delivery */}
//       {currentStep === 2 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Delivery Method</h3>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
//             <label style={{
//               border: deliveryMethod === 'pickup' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'pickup' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="pickup"
//                 checked={deliveryMethod === 'pickup'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Store Pickup</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>Collect from UPENDO STORE location</p>
//             </label>
//             <label style={{
//               border: deliveryMethod === 'delivery' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'delivery' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="delivery"
//                 checked={deliveryMethod === 'delivery'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Home Delivery</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>We'll deliver to your address</p>
//             </label>
//           </div>

//           {deliveryMethod === 'delivery' && (
//             <div style={{ backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '12px' }}>
//               <h4 style={{ marginBottom: '1.5rem' }}>Delivery Address</h4>
//               <input type="text" placeholder="Full Name *" value={deliveryAddress.fullName} onChange={e => handleAddressChange('fullName', e.target.value)} style={inputStyle} />
//               <input type="text" placeholder="Street Address *" value={deliveryAddress.street} onChange={e => handleAddressChange('street', e.target.value)} style={inputStyle} />
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <input type="text" placeholder="City *" value={deliveryAddress.city} onChange={e => handleAddressChange('city', e.target.value)} style={inputStyle} />
//                 <input type="text" placeholder="Province *" value={deliveryAddress.province} onChange={e => handleAddressChange('province', e.target.value)} style={inputStyle} />
//               </div>
//               <input type="text" placeholder="Postal Code (optional)" value={deliveryAddress.postalCode} onChange={e => handleAddressChange('postalCode', e.target.value)} style={inputStyle} />
//               <textarea placeholder="Additional info (apt, landmark...)" value={deliveryAddress.additionalInfo} onChange={e => handleAddressChange('additionalInfo', e.target.value)} style={{ ...inputStyle, height: '100px' }} />
//             </div>
//           )}

//           <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(1)} style={secondaryBtn}>← Back</button>
//             <button onClick={() => setCurrentStep(3)} disabled={!isDeliveryComplete()} style={primaryBtn}>
//               Continue to Payment →
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Step 3: Payment */}
//       {currentStep === 3 && (
//         <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Mobile Money Payment</h3>

//           {!paymentInitiated ? (
//             <>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Mobile Operator</label>
//                 <select value={operator} onChange={e => setOperator(e.target.value)} style={inputStyle}>
//                   <option value="airtel">Airtel Money</option>
//                   <option value="mtn">MTN Mobile Money</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Phone Number</label>
//                 <input
//                   type="tel"
//                   placeholder="e.g. 0971234567"
//                   value={phone}
//                   onChange={e => setPhone(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               <div style={{
//                 backgroundColor: '#B39DDB',
//                 color: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '12px',
//                 fontSize: '1.5rem',
//                 fontWeight: '700',
//                 marginBottom: '2rem'
//               }}>
//                 Total to Pay: ${getTotalPrice()}
//               </div>

//               <button
//                 onClick={initiatePayment}
//                 disabled={loading || !phone}
//                 style={{
//                   ...primaryBtn,
//                   padding: '1.2rem 3rem',
//                   fontSize: '1.2rem',
//                   opacity: loading || !phone ? 0.7 : 1
//                 }}
//               >
//                 {loading ? 'Processing...' : `Pay ${getTotalPrice()} via ${operator.toUpperCase()}`}
//               </button>
//             </>
//           ) : (
//             <div style={{
//               backgroundColor: '#f0fdf4',
//               padding: '3rem',
//               borderRadius: '16px',
//               border: '2px dashed #90C8FF'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '80px',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2rem',
//                 margin: '0 auto 1.5rem'
//               }}>✓</div>

//               <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Payment Request Sent!</h3>
//               <p style={{ color: '#666', marginBottom: '2rem' }}>
//                 Please check your phone and approve the payment request.
//               </p>

//               <div style={{
//                 backgroundColor: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '8px',
//                 marginBottom: '2rem',
//                 fontFamily: 'monospace',
//                 fontSize: '1.3rem',
//                 color: '#B39DDB'
//               }}>
//                 Ref: {reference}
//               </div>

//               <button onClick={checkPaymentStatus} style={primaryBtn}>
//                 Check Payment Status
//               </button>

//               {status && (
//                 <div style={{
//                   marginTop: '1.5rem',
//                   padding: '1rem',
//                   backgroundColor: status.data?.status === 'success' ? '#d4edda' : '#f8d7da',
//                   borderRadius: '8px',
//                   color: status.data?.status === 'success' ? '#155724' : '#721c24'
//                 }}>
//                   Status: <strong>{status.data?.status?.toUpperCase()}</strong>
//                   <br />
//                   {status.message}
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(2)} style={secondaryBtn}>← Back</button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '1rem',
//   marginBottom: '1rem',
//   border: '2px solid #ddd',
//   borderRadius: '8px',
//   fontSize: '1rem'
// };

// const primaryBtn = {
//   backgroundColor: '#90C8FF',
//   color: '#222',
//   padding: '1rem 2rem',
//   border: 'none',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// const secondaryBtn = {
//   backgroundColor: 'transparent',
//   color: '#90C8FF',
//   padding: '1rem 2rem',
//   border: '2px solid #90C8FF',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// function ProductDetailPage({ product, addToCart, navigateTo }) {
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);

//   const hasSizes = product.variants?.sizes?.length > 0;
//   const hasColors = product.variants?.colors?.length > 0;

//   const handleAddToCart = () => {
//     if (hasSizes && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (hasColors && !selectedColor) {
//       alert("Please select a color");
//       return;
//     }
//     const cartItem = {
//       ...product,
//       quantity,
//       selectedSize: selectedSize || null,
//       selectedColor: selectedColor || null,
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     };
//     addToCart(cartItem);
//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: '#90C8FF',
//           fontSize: '1rem',
//           marginBottom: '2rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '0.5rem'
//         }}
//       >
//         ← Back to Shop
//       </button>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '4rem', alignItems: 'start' }}>
//         <div style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(144, 200, 255, 0.2)' }}>
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
//           />
//         </div>
//         <div>
//           <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontFamily: "'Playfair Display', serif", color: '#333' }}>
//             {product.title}
//           </h1>
//           <p style={{ color: '#666', marginBottom: '1rem', fontSize: '1.1rem' }}>{product.author}</p>
//           <p style={{ fontSize: '2rem', fontWeight: 700, color: '#90C8FF', marginBottom: '2rem' }}>
//             ${product.price}
//           </p>
//           <p style={{ lineHeight: '1.8', color: '#555', marginBottom: '2rem' }}>
//             {product.description}
//           </p>
//           {hasSizes && (
//             <div style={{ marginBottom: '1.5rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(size => (
//                   <button
//                     key={size}
//                     onClick={() => setSelectedSize(size)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedSize === size ? '2px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedSize === size ? '#90C8FF' : 'white',
//                       color: selectedSize === size ? '#222' : '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {size}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           {hasColors && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(color => (
//                   <button
//                     key={color}
//                     onClick={() => setSelectedColor(color)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedColor === color ? '3px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedColor === color ? '#f0f8ff' : 'white',
//                       color: '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       minWidth: '100px',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {color}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
//             <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #ddd', borderRadius: '8px' }}>
//               <button
//                 onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Minus size={20} />
//               </button>
//               <span style={{ padding: '0.8rem 1.5rem', fontWeight: 600 }}>{quantity}</span>
//               <button
//                 onClick={() => setQuantity(quantity + 1)}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Plus size={20} />
//               </button>
//             </div>
//             <button
//               onClick={handleAddToCart}
//               style={{
//                 flex: 1,
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 20px rgba(0,0,0,0.15)',
//       transition: 'right 0.3s ease',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         backgroundColor: '#B39DDB',
//         color: '#fff'
//       }}>
//         <h3 style={{ fontSize: '1.5rem', fontWeight: 600, fontFamily: "'Playfair Display', serif" }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
//           <X size={24} />
//         </button>
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '3rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.variantId || item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
//               <div style={{ width: '80px', height: '100px', marginRight: '1rem' }}>
//                 <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#333' }}>
//                   {item.title}
//                   {(item.selectedSize || item.selectedColor) && (
//                     <span style={{ display: 'block', fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
//                       {item.selectedSize && `Size: ${item.selectedSize}`}
//                       {item.selectedSize && item.selectedColor && ' | '}
//                       {item.selectedColor && `Color: ${item.selectedColor}`}
//                     </span>
//                   )}
//                 </h4>
//                 <p style={{ color: '#90C8FF', fontWeight: 600, marginBottom: '0.5rem' }}>${item.price}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Minus size={16} />
//                   </button>
//                   <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
//                   <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Plus size={16} />
//                   </button>
//                   <button onClick={() => removeFromCart(item.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#999', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 600, color: '#333' }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       padding: '4rem 2rem 2rem',
//       marginTop: 'auto'
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//         gap: '2rem'
//       }}>
//         <div>
//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 700,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '50px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <p style={{ lineHeight: '1.7', opacity: 0.9, fontSize: '0.95rem' }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>
//           <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
//             {['F', 'T', 'I', 'G'].map((letter, i) => (
//               <button
//                 key={i}
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255,255,255,0.1)',
//                   borderRadius: '50%',
//                   fontSize: '1.1rem',
//                   transition: 'all 0.3s',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#fff'
//                 }}
//                 onMouseOver={e => {
//                   e.target.style.backgroundColor = '#90C8FF';
//                   e.target.style.color = '#222';
//                   e.target.style.transform = 'translateY(-3px)';
//                 }}
//                 onMouseOut={e => {
//                   e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
//                   e.target.style.color = '#fff';
//                   e.target.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {letter}
//               </button>
//             ))}
//           </div>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Quick Links
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {[
//               { text: 'Home', page: 'home' },
//               { text: 'Books', page: 'books' },
//               { text: 'Accessories', page: 'accessories' },
//               { text: 'About', page: 'about' }
//             ].map((link) => (
//               <li key={link.page} style={{ marginBottom: '0.8rem' }}>
//                 <button
//                   onClick={() => navigateTo(link.page)}
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: 0,
//                     font: 'inherit'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.text}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Customer Service
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {['Shipping Info', 'Returns', 'Privacy Policy', 'Terms of Service', 'FAQ'].map((item) => (
//               <li key={item} style={{ marginBottom: '0.8rem' }}>
//                 <button
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: 0,
//                     font: 'inherit'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Contact
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem', lineHeight: '1.8' }}>
//             <li style={{ marginBottom: '0.8rem' }}>📍 123 Book Street, Literary City</li>
//             <li style={{ marginBottom: '0.8rem' }}>📞 (123) 456-7890</li>
//             <li style={{ marginBottom: '0.8rem' }}>✉️ info@upendostore.com</li>
//           </ul>
//         </div>
//       </div>
//       <div style={{
//         textAlign: 'center',
//         marginTop: '3rem',
//         paddingTop: '2rem',
//         borderTop: '1px solid rgba(255,255,255,0.2)',
//         opacity: 0.8,
//         fontSize: '0.9rem'
//       }}>
//         <p>&copy; {new Date().getFullYear()} UPENDOSTORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;

// /* eslint-disable no-console */
// import React, { useState, useEffect } from 'react';
// import './App.css';
// import { ShoppingCart, X, Minus, Plus, Trash2 } from 'lucide-react';
// import useContentful from "./Hooks/Contentful";
// //import images from /imges folder
// import logo from './Images/logo.JPEG';
// import Book15 from './Images/Book15.jpg';
// import Book11 from './Images/Hero1.JPG';

// // Utility functions moved OUTSIDE the component (stable, no re-creation on render)
// const splitToArray = (value) => {
//   if (!value) return [];
//   return value
//     .split(",")
//     .map(v => v.trim())
//     .filter(Boolean);
// };

// const getImageUrl = (asset) => {
//   if (!asset?.fields?.file?.url) return null;
//   return `https:${asset.fields.file.url}`;
// };

// const mapContentfulItemToCard = (item, index) => {
//   console.log("item", item);
//   return {
//     id: item.sys?.id || index,
//     title: item?.title,
//     author: "UPENDO STORE Collection",
//     price: Number(item?.price) / 100,
//     image: getImageUrl(item?.backgroundImage || item.bgimage),
//     description: item?.description,
//     category: item?.category === "book" ? "books" : "accessories",
//     type: item?.category,
//     variants: {
//       sizes: splitToArray(item?.sizes),
//       colors: splitToArray(item?.colours),
//     }
//   };
// };

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [books, setBooks] = useState([]);
//   const [accessories, setAccessories] = useState([]);

//   const { getAuthors } = useContentful();

//   useEffect(() => {
//     getAuthors().then((response) => {
//       console.log("response", response);
//       if (!response) return;

//       const formattedData = response.map((item, index) =>
//         mapContentfulItemToCard(item, index)
//       );

//       // Split into books and accessories based on category
//       const bookItems = formattedData.filter(
//         product => product.category === "books" || product.category === "book"
//       );
//       const accessoryItems = formattedData.filter(
//         product => product.category !== "books" && product.category !== "book"
//       );

//       setBooks(bookItems);
//       setAccessories(accessoryItems);

//       console.log("Books:", bookItems);
//       console.log("Accessories:", accessoryItems);
//     });
//   }, [getAuthors]);

//   const allProducts = [...books, ...accessories];

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item =>
//           item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//         );
//       }
//       return [...prevItems, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems =>
//       prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   const navigateTo = (page, product = null) => {
//     setCurrentPage(page);
//     setSelectedProduct(product);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//       case 'books':
//         return <ShopPage navigateTo={navigateTo} products={books} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage navigateTo={navigateTo} products={accessories} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage navigateTo={navigateTo} products={allProducts} addToCart={addToCart} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage
//           cartItems={cartItems}
//           getTotalPrice={getTotalPrice}
//           navigateTo={navigateTo}
//         />;
//       case 'product-detail':
//         return selectedProduct ? (
//           <ProductDetailPage
//             product={selectedProduct}
//             addToCart={addToCart}
//             navigateTo={navigateTo}
//           />
//         ) : (
//           <div>Product not found</div>
//         );
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Crimson Text', 'Georgia', serif", minHeight: '100vh', backgroundColor: '#fdfaff', color: '#222' }}>
//       <Header
//         currentPage={currentPage}
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>{renderPage()}</main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal
//         isOpen={isCartOpen}
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 0' }}>
        
//         <div
//           onClick={() => navigateTo('home')}
//           className="navbar-logo"
//         >
//           <img
//             src={logo}
//             alt="Upendo Stores"
//             className="logo-image"
//           />
//           <span className="logo-text">
//             UPENDO STORE
//           </span>
//         </div>
        
//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#B39DDB',
//             flexDirection: 'column',
//             padding: '2rem',
//             boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)'
//           }} className="nav-menu">
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button onClick={openCart} style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               cursor: 'pointer',
//               position: 'relative',
//               fontSize: '1.2rem',
//               padding: '0.5rem'
//             }}>
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-8px',
//                   right: '-8px',
//                   backgroundColor: '#90C8FF',
//                   color: '#222',
//                   borderRadius: '50%',
//                   width: '22px',
//                   height: '22px',
//                   fontSize: '0.75rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>
//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               fontSize: '1.6rem',
//               cursor: 'pointer'
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>
//       <style jsx>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//             boxShadow: none !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#fff' : 'rgba(255,255,255,0.85)',
//         cursor: 'pointer',
//         padding: '0.5rem 0',
//         borderBottom: active ? '3px solid #90C8FF' : 'none',
//         transition: 'all 0.3s'
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo, books, accessories }) {
//   const featuredBooks = books.slice(0, 3);
//   const featuredAccessories = accessories.slice(0, 3);
//   return (
//     <>
//       <section className="hero"
//         style={{
//         backgroundImage: `
//   linear-gradient(
//     rgba(0, 0, 0, 0.6),
//     rgba(0, 0, 0, 0.6)
//   ),
//   url(${Book11})
// `,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           color: '#fff',
//           textAlign: 'center',
//           padding: '8rem 2rem'
//         }}
//       >
//         <h1
//           style={{
//             fontSize: '3.5rem',
//             marginBottom: '1rem',
//             fontFamily: "'Playfair Display', serif",
//             fontWeight: 700
//           }}
//         >
//           Discover The Captivating World of Colour
//         </h1>
//         <p style={{ fontSize: '1.5rem', marginBottom: '2rem', opacity: 0.95 }}>
//           Explore the vibrant world of our colour therapy books
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#90C8FF',
//             color: '#222',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => (e.target.style.backgroundColor = '#7ab8ff')}
//           onMouseOut={e => (e.target.style.backgroundColor = '#90C8FF')}
//         >
//           Browse Collection
//         </button>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredBooks.map(book => <ProductCard key={book.id} product={book} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8f3ff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredAccessories.map(item => <ProductCard key={item.id} product={item} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>
//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 6px 20px rgba(144, 200, 255, 0.18)',
//       transition: 'all 0.3s'
//     }}
//     onMouseOver={e => {
//       e.currentTarget.style.transform = 'translateY(-10px)';
//       e.currentTarget.style.boxShadow = '0 20px 40px rgba(144, 200, 255, 0.3)';
//     }}
//     onMouseOut={e => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 6px 20px rgba(144, 200, 255, 0.18)';
//     }}>
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
//           onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
//           onMouseOut={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>{product.title}</h3>
//         <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.3rem', fontWeight: 700, color: '#90C8FF', marginBottom: '1rem' }}>${product.price}</p>
//         <div style={{ display: 'flex', gap: '0.5rem' }}>
//           <button
//           onClick={() => navigateTo('product-detail', product)}
//           style={{
//             flex: 1,
//             backgroundColor: 'transparent',
//             color: '#90C8FF',
//             border: '2px solid #90C8FF',
//             padding: '0.6rem',
//             borderRadius: '8px',
//             fontWeight: 600,
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//           onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//         >
//           View Details
//         </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ShopPage({ products, addToCart, title, navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif",
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//       </h2>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {products.map(product => <ProductCard
//   key={product.id}
//   product={product}
//   addToCart={addToCart}
//   navigateTo={navigateTo}
// />)}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory, navigateTo }) {
//   const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//         Complete Collection
//       </h2>
//       <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         <FilterButton active={selectedCategory === 'all'} onClick={() => setSelectedCategory('all')}>All Products</FilterButton>
//         <FilterButton active={selectedCategory === 'books'} onClick={() => setSelectedCategory('books')}>Books</FilterButton>
//         <FilterButton active={selectedCategory === 'accessories'} onClick={() => setSelectedCategory('accessories')}>Accessories</FilterButton>
//       </div>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {filteredProducts.map(product => <ProductCard
//   key={product.id}
//   product={product}
//   addToCart={addToCart}
//   navigateTo={navigateTo}
// />)}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#90C8FF' : 'transparent',
//         color: active ? '#222' : '#90C8FF',
//         border: '2px solid #90C8FF',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s'
//       }}
//       onMouseOver={e => !active && (e.target.style.backgroundColor = '#90C8FF', e.target.style.color = '#222')}
//       onMouseOut={e => !active && (e.target.style.backgroundColor = 'transparent', e.target.style.color = '#90C8FF')}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#f8f3ff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//           <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//             About the Author
//           </h3>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Store
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//             <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring the outdoors for inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CheckoutPage({ cartItems, getTotalPrice, navigateTo }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   // Delivery
//   const [deliveryMethod, setDeliveryMethod] = useState('pickup');
//   const [deliveryAddress, setDeliveryAddress] = useState({
//     fullName: '',
//     street: '',
//     city: '',
//     province: '',
//     postalCode: '',
//     additionalInfo: ''
//   });
//   // Payment
//   const [phone, setPhone] = useState('');
//   const [operator, setOperator] = useState('airtel');
//   // Status
//   const [loading, setLoading] = useState(false);
//   const [reference, setReference] = useState('');
//   const [paymentInitiated, setPaymentInitiated] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleAddressChange = (field, value) => {
//     setDeliveryAddress(prev => ({ ...prev, [field]: value }));
//   };

//   const isDeliveryComplete = () => {
//     if (deliveryMethod === 'pickup') return true;
//     return deliveryAddress.fullName && deliveryAddress.street && deliveryAddress.city && deliveryAddress.province;
//   };

//   const initiatePayment = async () => {
//     if (!phone || phone.length < 10) {
//       alert("Please enter a valid phone number");
//       return;
//     }
//     setLoading(true);
//     const items = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       quantity: item.quantity,
//       size: item.selectedSize || null,
//       color: item.selectedColor || null,
//       totalCost: item.price * item.quantity
//     }));
//     const payload = {
//       amount: parseFloat(getTotalPrice()),
//       phone_number: phone.replace(/[^0-9]/g, ''),
//       operator,
//       items,
//       delivery_method: deliveryMethod,
//       delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
//     };
//     try {
//       const response = await fetch("https://albeutystore.store/payment", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
//       const data = await response.json();
//       if (response.ok && data.data?.reference) {
//         setReference(data.data.reference);
//         setPaymentInitiated(true);
//         alert("Payment request sent! Check your phone for the payment prompt.");
//       } else {
//         alert(data.message || "Payment initiation failed. Try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error. Please check your connection and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async () => {
//     if (!reference) return;
//     try {
//       const response = await fetch(`https://albeutystore.store/collections/status/${reference}`);
//       const data = await response.json();
//       setStatus(data);
//       if (data.data?.status === "success") {
//         alert("Payment successful! Thank you for your order.");
//         navigateTo('home');
//       } else if (data.data?.status === "failed") {
//         alert("Payment failed. You can try again.");
//       }
//     } catch (err) {
//       alert("Could not check status. Try again later.");
//     }
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif"
//       }}>
//         Checkout
//       </h2>
//       {/* Progress Steps */}
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         {['Cart Review', 'Delivery', 'Payment'].map((label, i) => (
//           <div key={i} style={{ display: 'flex', alignItems: 'center', flex: '1 1 200px', maxWidth: '300px' }}>
//             <div style={{
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               backgroundColor: currentStep > i ? '#90C8FF' : currentStep === i + 1 ? '#B39DDB' : '#eee',
//               color: 'white',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '1.1rem'
//             }}>
//               {i + 1}
//             </div>
//             <span style={{ marginLeft: '1rem', fontWeight: currentStep === i + 1 ? '600' : '400', color: '#333' }}>
//               {label}
//             </span>
//             {i < 2 && (
//               <div style={{
//                 flex: 1,
//                 height: '3px',
//                 backgroundColor: currentStep > i + 1 ? '#90C8FF' : '#ddd',
//                 margin: '0 1rem'
//               }} />
//             )}
//           </div>
//         ))}
//       </div>
//       {/* Step 1: Cart Review */}
//       {currentStep === 1 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Review Your Items</h3>
//           {cartItems.length === 0 ? (
//             <p style={{ textAlign: 'center', color: '#999', fontSize: '1.2rem' }}>Your cart is empty</p>
//           ) : (
//             <>
//               {cartItems.map(item => (
//                 <div key={item.variantId || item.id} style={{
//                   display: 'flex',
//                   gap: '1.5rem',
//                   padding: '1.5rem',
//                   border: '1px solid #eee',
//                   borderRadius: '8px',
//                   marginBottom: '1rem',
//                   alignItems: 'center'
//                 }}>
//                   <img src={item.image} alt={item.title} style={{ width: '100px', height: '120px', objectFit: 'cover', borderRadius: '8px' }} />
//                   <div style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 0.5rem', fontSize: '1.2rem' }}>{item.title}</h4>
//                     {item.selectedSize && <p style={{ margin: '0.3rem 0', color: '#666' }}>Size: {item.selectedSize}</p>}
//                     {item.selectedColor && <p style={{ margin: '0.3rem 0', color: '#666' }}>Color: {item.selectedColor}</p>}
//                     <p style={{ margin: '0.5rem 0', color: '#90C8FF', fontWeight: '600' }}>
//                       ${item.price} × {item.quantity} = ${(item.price * item.quantity).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//               <div style={{
//                 textAlign: 'right',
//                 padding: '1.5rem',
//                 backgroundColor: '#f8f3ff',
//                 borderRadius: '8px',
//                 fontSize: '1.4rem',
//                 fontWeight: '700',
//                 color: '#B39DDB'
//               }}>
//                 Total: ${getTotalPrice()}
//               </div>
//               <div style={{ textAlign: 'right', marginTop: '2rem' }}>
//                 <button
//                   onClick={() => setCurrentStep(2)}
//                   style={{
//                     backgroundColor: '#90C8FF',
//                     color: '#222',
//                     padding: '1rem 2rem',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Continue to Delivery
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       )}
//       {/* Step 2: Delivery */}
//       {currentStep === 2 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Delivery Method</h3>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
//             <label style={{
//               border: deliveryMethod === 'pickup' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'pickup' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="pickup"
//                 checked={deliveryMethod === 'pickup'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Store Pickup</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>Collect from UPENDO STORE location</p>
//             </label>
//             <label style={{
//               border: deliveryMethod === 'delivery' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'delivery' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="delivery"
//                 checked={deliveryMethod === 'delivery'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Home Delivery</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>We'll deliver to your address</p>
//             </label>
//           </div>
//           {deliveryMethod === 'delivery' && (
//             <div style={{ backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '12px' }}>
//               <h4 style={{ marginBottom: '1.5rem' }}>Delivery Address</h4>
//               <input type="text" placeholder="Full Name *" value={deliveryAddress.fullName} onChange={e => handleAddressChange('fullName', e.target.value)} style={inputStyle} />
//               <input type="text" placeholder="Street Address *" value={deliveryAddress.street} onChange={e => handleAddressChange('street', e.target.value)} style={inputStyle} />
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <input type="text" placeholder="City *" value={deliveryAddress.city} onChange={e => handleAddressChange('city', e.target.value)} style={inputStyle} />
//                 <input type="text" placeholder="Province *" value={deliveryAddress.province} onChange={e => handleAddressChange('province', e.target.value)} style={inputStyle} />
//               </div>
//               <input type="text" placeholder="Postal Code (optional)" value={deliveryAddress.postalCode} onChange={e => handleAddressChange('postalCode', e.target.value)} style={inputStyle} />
//               <textarea placeholder="Additional info (apt, landmark...)" value={deliveryAddress.additionalInfo} onChange={e => handleAddressChange('additionalInfo', e.target.value)} style={{ ...inputStyle, height: '100px' }} />
//             </div>
//           )}
//           <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(1)} style={secondaryBtn}>← Back</button>
//             <button onClick={() => setCurrentStep(3)} disabled={!isDeliveryComplete()} style={primaryBtn}>
//               Continue to Payment →
//             </button>
//           </div>
//         </div>
//       )}
//       {/* Step 3: Payment */}
//       {currentStep === 3 && (
//         <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Mobile Money Payment</h3>
//           {!paymentInitiated ? (
//             <>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Mobile Operator</label>
//                 <select value={operator} onChange={e => setOperator(e.target.value)} style={inputStyle}>
//                   <option value="airtel">Airtel Money</option>
//                   <option value="mtn">MTN Mobile Money</option>
//                 </select>
//               </div>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Phone Number</label>
//                 <input
//                   type="tel"
//                   placeholder="e.g. 0971234567"
//                   value={phone}
//                   onChange={e => setPhone(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>
//               <div style={{
//                 backgroundColor: '#B39DDB',
//                 color: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '12px',
//                 fontSize: '1.5rem',
//                 fontWeight: '700',
//                 marginBottom: '2rem'
//               }}>
//                 Total to Pay: ${getTotalPrice()}
//               </div>
//               <button
//                 onClick={initiatePayment}
//                 disabled={loading || !phone}
//                 style={{
//                   ...primaryBtn,
//                   padding: '1.2rem 3rem',
//                   fontSize: '1.2rem',
//                   opacity: loading || !phone ? 0.7 : 1
//                 }}
//               >
//                 {loading ? 'Processing...' : `Pay ${getTotalPrice()} via ${operator.toUpperCase()}`}
//               </button>
//             </>
//           ) : (
//             <div style={{
//               backgroundColor: '#f0fdf4',
//               padding: '3rem',
//               borderRadius: '16px',
//               border: '2px dashed #90C8FF'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '80px',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2rem',
//                 margin: '0 auto 1.5rem'
//               }}>✓</div>
//               <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Payment Request Sent!</h3>
//               <p style={{ color: '#666', marginBottom: '2rem' }}>
//                 Please check your phone and approve the payment request.
//               </p>
//               <div style={{
//                 backgroundColor: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '8px',
//                 marginBottom: '2rem',
//                 fontFamily: 'monospace',
//                 fontSize: '1.3rem',
//                 color: '#B39DDB'
//               }}>
//                 Ref: {reference}
//               </div>
//               <button onClick={checkPaymentStatus} style={primaryBtn}>
//                 Check Payment Status
//               </button>
//               {status && (
//                 <div style={{
//                   marginTop: '1.5rem',
//                   padding: '1rem',
//                   backgroundColor: status.data?.status === 'success' ? '#d4edda' : '#f8d7da',
//                   borderRadius: '8px',
//                   color: status.data?.status === 'success' ? '#155724' : '#721c24'
//                 }}>
//                   Status: <strong>{status.data?.status?.toUpperCase()}</strong>
//                   <br />
//                   {status.message}
//                 </div>
//               )}
//             </div>
//           )}
//           <div style={{ marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(2)} style={secondaryBtn}>← Back</button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '1rem',
//   marginBottom: '1rem',
//   border: '2px solid #ddd',
//   borderRadius: '8px',
//   fontSize: '1rem'
// };

// const primaryBtn = {
//   backgroundColor: '#90C8FF',
//   color: '#222',
//   padding: '1rem 2rem',
//   border: 'none',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// const secondaryBtn = {
//   backgroundColor: 'transparent',
//   color: '#90C8FF',
//   padding: '1rem 2rem',
//   border: '2px solid #90C8FF',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// function ProductDetailPage({ product, addToCart, navigateTo }) {
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);

//   const hasSizes = product.variants?.sizes?.length > 0;
//   const hasColors = product.variants?.colors?.length > 0;

//   const handleAddToCart = () => {
//     if (hasSizes && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (hasColors && !selectedColor) {
//       alert("Please select a color");
//       return;
//     }
//     const cartItem = {
//       ...product,
//       quantity,
//       selectedSize: selectedSize || null,
//       selectedColor: selectedColor || null,
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     };
//     addToCart(cartItem);
//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: '#90C8FF',
//           fontSize: '1rem',
//           marginBottom: '2rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '0.5rem'
//         }}
//       >
//         ← Back to Shop
//       </button>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '4rem', alignItems: 'start' }}>
//         <div style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(144, 200, 255, 0.2)' }}>
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
//           />
//         </div>
//         <div>
//           <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontFamily: "'Playfair Display', serif", color: '#333' }}>
//             {product.title}
//           </h1>
//           <p style={{ color: '#666', marginBottom: '1rem', fontSize: '1.1rem' }}>{product.author}</p>
//           <p style={{ fontSize: '2rem', fontWeight: 700, color: '#90C8FF', marginBottom: '2rem' }}>
//             ${product.price}
//           </p>
//           <p style={{ lineHeight: '1.8', color: '#555', marginBottom: '2rem' }}>
//             {product.description}
//           </p>
//           {hasSizes && (
//             <div style={{ marginBottom: '1.5rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(size => (
//                   <button
//                     key={size}
//                     onClick={() => setSelectedSize(size)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedSize === size ? '2px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedSize === size ? '#90C8FF' : 'white',
//                       color: selectedSize === size ? '#222' : '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {size}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           {hasColors && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(color => (
//                   <button
//                     key={color}
//                     onClick={() => setSelectedColor(color)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedColor === color ? '3px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedColor === color ? '#f0f8ff' : 'white',
//                       color: '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       minWidth: '100px',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {color}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
//             <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #ddd', borderRadius: '8px' }}>
//               <button
//                 onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Minus size={20} />
//               </button>
//               <span style={{ padding: '0.8rem 1.5rem', fontWeight: 600 }}>{quantity}</span>
//               <button
//                 onClick={() => setQuantity(quantity + 1)}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Plus size={20} />
//               </button>
//             </div>
//             <button
//               onClick={handleAddToCart}
//               style={{
//                 flex: 1,
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 20px rgba(0,0,0,0.15)',
//       transition: 'right 0.3s ease',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         backgroundColor: '#B39DDB',
//         color: '#fff'
//       }}>
//         <h3 style={{ fontSize: '1.5rem', fontWeight: 600, fontFamily: "'Playfair Display', serif" }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
//           <X size={24} />
//         </button>
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '3rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.variantId || item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
//               <div style={{ width: '80px', height: '100px', marginRight: '1rem' }}>
//                 <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#333' }}>
//                   {item.title}
//                   {(item.selectedSize || item.selectedColor) && (
//                     <span style={{ display: 'block', fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
//                       {item.selectedSize && `Size: ${item.selectedSize}`}
//                       {item.selectedSize && item.selectedColor && ' | '}
//                       {item.selectedColor && `Color: ${item.selectedColor}`}
//                     </span>
//                   )}
//                 </h4>
//                 <p style={{ color: '#90C8FF', fontWeight: 600, marginBottom: '0.5rem' }}>${item.price}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Minus size={16} />
//                   </button>
//                   <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
//                   <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Plus size={16} />
//                   </button>
//                   <button onClick={() => removeFromCart(item.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#999', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 600, color: '#333' }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       padding: '4rem 2rem 2rem',
//       marginTop: 'auto'
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//         gap: '2rem'
//       }}>
//         {/* Column 1: Brand */}
//         <div>
//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 700,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '50px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <p style={{ lineHeight: '1.7', opacity: 0.9, fontSize: '0.95rem' }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>
//           {/* Social Icons */}
//           <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
//             {['F', 'T', 'I', 'G'].map((letter, i) => (
//               <button
//                 key={i}
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255,255,255,0.1)',
//                   borderRadius: '50%',
//                   fontSize: '1.1rem',
//                   transition: 'all 0.3s',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#fff'
//                 }}
//                 onMouseOver={e => {
//                   e.target.style.backgroundColor = '#90C8FF';
//                   e.target.style.color = '#222';
//                   e.target.style.transform = 'translateY(-3px)';
//                 }}
//                 onMouseOut={e => {
//                   e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
//                   e.target.style.color = '#fff';
//                   e.target.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {letter}
//               </button>
//             ))}
//           </div>
//         </div>
//         {/* Column 2: Quick Links */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Quick Links
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {[
//               { text: 'Home', page: 'home' },
//               { text: 'Books', page: 'books' },
//               { text: 'Accessories', page: 'accessories' },
//               { text: 'About', page: 'about' }
//             ].map((link) => (
//               <li key={link.page} style={{ marginBottom: '0.8rem' }}>
//                 <button
//                   onClick={() => navigateTo(link.page)}
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: 0,
//                     font: 'inherit'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.text}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//         {/* Column 3: Customer Service */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Customer Service
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {['Shipping Info', 'Returns', 'Privacy Policy', 'Terms of Service', 'FAQ'].map((item) => (
//               <li key={item} style={{ marginBottom: '0.8rem' }}>
//                 <button
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: 0,
//                     font: 'inherit'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//         {/* Column 4: Contact */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Contact
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem', lineHeight: '1.8' }}>
//             <li style={{ marginBottom: '0.8rem' }}>📍 123 Book Street, Literary City</li>
//             <li style={{ marginBottom: '0.8rem' }}>📞 (123) 456-7890</li>
//             <li style={{ marginBottom: '0.8rem' }}>✉️ info@upendostore.com</li>
//           </ul>
//         </div>
//       </div>
//       {/* Copyright */}
//       <div style={{
//         textAlign: 'center',
//         marginTop: '3rem',
//         paddingTop: '2rem',
//         borderTop: '1px solid rgba(255,255,255,0.2)',
//         opacity: 0.8,
//         fontSize: '0.9rem'
//       }}>
//         <p>&copy; {new Date().getFullYear()} UPENDOSTORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;

/* eslint-disable no-console */
// import React, { useState, useEffect } from 'react';
// import './App.css';
// import { ShoppingCart, X, Minus, Plus, Trash2, Book } from 'lucide-react';
// import useContentful from "./Hooks/Contentful";
// //import images from /imges folder
// import logo from './Images/logo.JPEG';
// import Book15 from './Images/Book15.jpg';
// import Book11 from './Images/Hero1.JPG';

// // Removed static booksData and accessoriesData

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [books, setBooks] = useState([]); // Dynamic books from Contentful
//   const [accessories, setAccessories] = useState([]); // Dynamic accessories from Contentful
//   const [cardData, setCardData] = useState([]); // Optional: full list if needed

//   const { getAuthors } = useContentful();

//   const splitToArray = (value) => {
//     if (!value) return [];
//     return value
//       .split(",")
//       .map(v => v.trim())
//       .filter(Boolean);
//   };

//   const getImageUrl = (asset) => {
//     if (!asset?.fields?.file?.url) return null;
//     return `https:${asset.fields.file.url}`;
//   };

//   const mapContentfulItemToCard = (item, index) => {
//     console.log("item", item);
//     return {
//       id: item.sys?.id || index,
//       title: item?.title,
//       author: "UPENDO STORE Collection",
//       price: Number(item?.price) / 100,
//       image: getImageUrl(item?.backgroundImage || item.bgimage),
//       description: item?.description,
//       category: item?.category === "book" ? "books" : "accessories",
//       type: item?.category,
//       variants: {
//         sizes: splitToArray(item?.sizes),
//         colors: splitToArray(item?.colours),
//       }
//     };
//   };

//   useEffect(() => {
//     getAuthors().then((response) => {
//       console.log("response", response);
//       if (!response) return;

//       const formattedData = response.map((item, index) =>
//         mapContentfulItemToCard(item, index)
//       );

//       // Split into books and accessories based on category
//       const bookItems = formattedData.filter(
//         product => product.category === "books" || product.category === "book"
//       );
//       const accessoryItems = formattedData.filter(
//         product => product.category !== "books" && product.category !== "book"
//       );

//       setBooks(bookItems);
//       setAccessories(accessoryItems);
//       setCardData(formattedData); // Full list if needed elsewhere

//       console.log("Books:", bookItems);
//       console.log("Accessories:", accessoryItems);
//     });
//   }, []);

//   const allProducts = [...books, ...accessories]; // Dynamic all products

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item =>
//           item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//         );
//       }
//       return [...prevItems, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems =>
//       prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   const navigateTo = (page, product = null) => {
//     setCurrentPage(page);
//     setSelectedProduct(product);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//       case 'books':
//         return <ShopPage navigateTo={navigateTo} products={books} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage navigateTo={navigateTo} products={accessories} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage navigateTo={navigateTo} products={allProducts} addToCart={addToCart} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage
//           cartItems={cartItems}
//           getTotalPrice={getTotalPrice}
//           navigateTo={navigateTo}
//         />;
//       case 'product-detail':
//         return selectedProduct ? (
//           <ProductDetailPage
//             product={selectedProduct}
//             addToCart={addToCart}
//             navigateTo={navigateTo}
//           />
//         ) : (
//           <div>Product not found</div>
//         );
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} books={books} accessories={accessories} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Crimson Text', 'Georgia', serif", minHeight: '100vh', backgroundColor: '#fdfaff', color: '#222' }}>
//       <Header
//         currentPage={currentPage}
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>{renderPage()}</main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal
//         isOpen={isCartOpen}
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 0' }}>
//           <div
//             onClick={() => navigateTo('home')}
//             className="navbar-logo"
//           >
//             <img
//               src={logo}
//               alt="Upendo Stores"
//               className="logo-image"
//             />
//             <span className="logo-text">
//               UPENDO STORE
//             </span>
//           </div>

//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#B39DDB',
//             flexDirection: 'column',
//             padding: '2rem',
//             boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)'
//           }} className="nav-menu">
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button onClick={openCart} style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               cursor: 'pointer',
//               position: 'relative',
//               fontSize: '1.2rem',
//               padding: '0.5rem'
//             }}>
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-8px',
//                   right: '-8px',
//                   backgroundColor: '#90C8FF',
//                   color: '#222',
//                   borderRadius: '50%',
//                   width: '22px',
//                   height: '22px',
//                   fontSize: '0.75rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>
//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               fontSize: '1.6rem',
//               cursor: 'pointer'
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>
//       <style jsx>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//             boxShadow: none !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#fff' : 'rgba(255,255,255,0.85)',
//         cursor: 'pointer',
//         padding: '0.5rem 0',
//         borderBottom: active ? '3px solid #90C8FF' : 'none',
//         transition: 'all 0.3s'
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo, books, accessories }) {
//   const featuredBooks = books.slice(0, 3);
//   const featuredAccessories = accessories.slice(0, 3);
//   return (
//     <>
//       <section className="hero"
//         style={{
//           backgroundImage: `
//   linear-gradient(
//     rgba(0, 0, 0, 0.6),
//     rgba(0, 0, 0, 0.6)
//   ),
//   url(${Book11})
// `,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           color: '#fff',
//           textAlign: 'center',
//           padding: '8rem 2rem'
//         }}
//       >
//         <h1
//           style={{
//             fontSize: '3.5rem',
//             marginBottom: '1rem',
//             fontFamily: "'Playfair Display', serif",
//             fontWeight: 700
//           }}
//         >
//           Discover The Captivating World of Colour
//         </h1>
//         <p style={{ fontSize: '1.5rem', marginBottom: '2rem', opacity: 0.95 }}>
//           Explore the vibrant world of our colour therapy books
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#90C8FF',
//             color: '#222',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => (e.target.style.backgroundColor = '#7ab8ff')}
//           onMouseOut={e => (e.target.style.backgroundColor = '#90C8FF')}
//         >
//           Browse Collection
//         </button>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredBooks.map(book => <ProductCard key={book.id} product={book} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>
//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8f3ff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredAccessories.map(item => <ProductCard key={item.id} product={item} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>
//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart, navigateTo }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 6px 20px rgba(144, 200, 255, 0.18)',
//       transition: 'all 0.3s'
//     }}
//     onMouseOver={e => {
//       e.currentTarget.style.transform = 'translateY(-10px)';
//       e.currentTarget.style.boxShadow = '0 20px 40px rgba(144, 200, 255, 0.3)';
//     }}
//     onMouseOut={e => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 6px 20px rgba(144, 200, 255, 0.18)';
//     }}>
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
//           onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
//           onMouseOut={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>{product.title}</h3>
//         <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.3rem', fontWeight: 700, color: '#90C8FF', marginBottom: '1rem' }}>${product.price}</p>
//         <div style={{ display: 'flex', gap: '0.5rem' }}>
//           <button
//             onClick={() => navigateTo('product-detail', product)}
//             style={{
//               flex: 1,
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View Details
//           </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ShopPage({ products, addToCart, title, navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif",
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//       </h2>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {products.map(product => <ProductCard
//           key={product.id}
//           product={product}
//           addToCart={addToCart}
//           navigateTo={navigateTo}
//         />)}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory, navigateTo }) {
//   const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//         Complete Collection
//       </h2>
//       <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         <FilterButton active={selectedCategory === 'all'} onClick={() => setSelectedCategory('all')}>All Products</FilterButton>
//         <FilterButton active={selectedCategory === 'books'} onClick={() => setSelectedCategory('books')}>Books</FilterButton>
//         <FilterButton active={selectedCategory === 'accessories'} onClick={() => setSelectedCategory('accessories')}>Accessories</FilterButton>
//       </div>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {filteredProducts.map(product => <ProductCard
//           key={product.id}
//           product={product}
//           addToCart={addToCart}
//           navigateTo={navigateTo}
//         />)}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#90C8FF' : 'transparent',
//         color: active ? '#222' : '#90C8FF',
//         border: '2px solid #90C8FF',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s'
//       }}
//       onMouseOver={e => !active && (e.target.style.backgroundColor = '#90C8FF', e.target.style.color = '#222')}
//       onMouseOut={e => !active && (e.target.style.backgroundColor = 'transparent', e.target.style.color = '#90C8FF')}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#f8f3ff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//           <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//             About the Author
//           </h3>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Store
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//             <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring the outdoors for inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CheckoutPage({ cartItems, getTotalPrice, navigateTo }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [deliveryMethod, setDeliveryMethod] = useState('pickup');
//   const [deliveryAddress, setDeliveryAddress] = useState({
//     fullName: '',
//     street: '',
//     city: '',
//     province: '',
//     postalCode: '',
//     additionalInfo: ''
//   });
//   const [phone, setPhone] = useState('');
//   const [operator, setOperator] = useState('airtel');
//   const [loading, setLoading] = useState(false);
//   const [reference, setReference] = useState('');
//   const [paymentInitiated, setPaymentInitiated] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleAddressChange = (field, value) => {
//     setDeliveryAddress(prev => ({ ...prev, [field]: value }));
//   };

//   const isDeliveryComplete = () => {
//     if (deliveryMethod === 'pickup') return true;
//     return deliveryAddress.fullName && deliveryAddress.street && deliveryAddress.city && deliveryAddress.province;
//   };

//   const initiatePayment = async () => {
//     if (!phone || phone.length < 10) {
//       alert("Please enter a valid phone number");
//       return;
//     }
//     setLoading(true);
//     const items = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       quantity: item.quantity,
//       size: item.selectedSize || null,
//       color: item.selectedColor || null,
//       totalCost: item.price * item.quantity
//     }));
//     const payload = {
//       amount: parseFloat(getTotalPrice()),
//       phone_number: phone.replace(/[^0-9]/g, ''),
//       operator,
//       items,
//       delivery_method: deliveryMethod,
//       delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
//     };
//     try {
//       const response = await fetch("https://albeutystore.store/payment", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
//       const data = await response.json();
//       if (response.ok && data.data?.reference) {
//         setReference(data.data.reference);
//         setPaymentInitiated(true);
//         alert("Payment request sent! Check your phone for the payment prompt.");
//       } else {
//         alert(data.message || "Payment initiation failed. Try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error. Please check your connection and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async () => {
//     if (!reference) return;
//     try {
//       const response = await fetch(`https://albeutystore.store/collections/status/${reference}`);
//       const data = await response.json();
//       setStatus(data);
//       if (data.data?.status === "success") {
//         alert("Payment successful! Thank you for your order.");
//         navigateTo('home');
//       } else if (data.data?.status === "failed") {
//         alert("Payment failed. You can try again.");
//       }
//     } catch (err) {
//       alert("Could not check status. Try again later.");
//     }
//   };

//   const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif"
//       }}>
//         Checkout
//       </h2>
//       {/* Progress Steps */}
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         {['Cart Review', 'Delivery', 'Payment'].map((label, i) => (
//           <div key={i} style={{ display: 'flex', alignItems: 'center', flex: '1 1 200px', maxWidth: '300px' }}>
//             <div style={{
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               backgroundColor: currentStep > i ? '#90C8FF' : currentStep === i + 1 ? '#B39DDB' : '#eee',
//               color: 'white',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '1.1rem'
//             }}>
//               {i + 1}
//             </div>
//             <span style={{ marginLeft: '1rem', fontWeight: currentStep === i + 1 ? '600' : '400', color: '#333' }}>
//               {label}
//             </span>
//             {i < 2 && (
//               <div style={{
//                 flex: 1,
//                 height: '3px',
//                 backgroundColor: currentStep > i + 1 ? '#90C8FF' : '#ddd',
//                 margin: '0 1rem'
//               }} />
//             )}
//           </div>
//         ))}
//       </div>
//       {/* Step 1: Cart Review */}
//       {currentStep === 1 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Review Your Items</h3>
//           {cartItems.length === 0 ? (
//             <p style={{ textAlign: 'center', color: '#999', fontSize: '1.2rem' }}>Your cart is empty</p>
//           ) : (
//             <>
//               {cartItems.map(item => (
//                 <div key={item.variantId || item.id} style={{
//                   display: 'flex',
//                   gap: '1.5rem',
//                   padding: '1.5rem',
//                   border: '1px solid #eee',
//                   borderRadius: '8px',
//                   marginBottom: '1rem',
//                   alignItems: 'center'
//                 }}>
//                   <img src={item.image} alt={item.title} style={{ width: '100px', height: '120px', objectFit: 'cover', borderRadius: '8px' }} />
//                   <div style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 0.5rem', fontSize: '1.2rem' }}>{item.title}</h4>
//                     {item.selectedSize && <p style={{ margin: '0.3rem 0', color: '#666' }}>Size: {item.selectedSize}</p>}
//                     {item.selectedColor && <p style={{ margin: '0.3rem 0', color: '#666' }}>Color: {item.selectedColor}</p>}
//                     <p style={{ margin: '0.5rem 0', color: '#90C8FF', fontWeight: '600' }}>
//                       ${item.price} × {item.quantity} = ${(item.price * item.quantity).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//               <div style={{
//                 textAlign: 'right',
//                 padding: '1.5rem',
//                 backgroundColor: '#f8f3ff',
//                 borderRadius: '8px',
//                 fontSize: '1.4rem',
//                 fontWeight: '700',
//                 color: '#B39DDB'
//               }}>
//                 Total: ${getTotalPrice()}
//               </div>
//               <div style={{ textAlign: 'right', marginTop: '2rem' }}>
//                 <button
//                   onClick={() => setCurrentStep(2)}
//                   style={{
//                     backgroundColor: '#90C8FF',
//                     color: '#222',
//                     padding: '1rem 2rem',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Continue to Delivery
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       )}
//       {/* Step 2: Delivery */}
//       {currentStep === 2 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Delivery Method</h3>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
//             <label style={{
//               border: deliveryMethod === 'pickup' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'pickup' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="pickup"
//                 checked={deliveryMethod === 'pickup'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Store Pickup</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>Collect from UPENDO STORE location</p>
//             </label>
//             <label style={{
//               border: deliveryMethod === 'delivery' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'delivery' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="delivery"
//                 checked={deliveryMethod === 'delivery'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Home Delivery</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>We'll deliver to your address</p>
//             </label>
//           </div>
//           {deliveryMethod === 'delivery' && (
//             <div style={{ backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '12px' }}>
//               <h4 style={{ marginBottom: '1.5rem' }}>Delivery Address</h4>
//               <input type="text" placeholder="Full Name *" value={deliveryAddress.fullName} onChange={e => handleAddressChange('fullName', e.target.value)} style={inputStyle} />
//               <input type="text" placeholder="Street Address *" value={deliveryAddress.street} onChange={e => handleAddressChange('street', e.target.value)} style={inputStyle} />
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <input type="text" placeholder="City *" value={deliveryAddress.city} onChange={e => handleAddressChange('city', e.target.value)} style={inputStyle} />
//                 <input type="text" placeholder="Province *" value={deliveryAddress.province} onChange={e => handleAddressChange('province', e.target.value)} style={inputStyle} />
//               </div>
//               <input type="text" placeholder="Postal Code (optional)" value={deliveryAddress.postalCode} onChange={e => handleAddressChange('postalCode', e.target.value)} style={inputStyle} />
//               <textarea placeholder="Additional info (apt, landmark...)" value={deliveryAddress.additionalInfo} onChange={e => handleAddressChange('additionalInfo', e.target.value)} style={{ ...inputStyle, height: '100px' }} />
//             </div>
//           )}
//           <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(1)} style={secondaryBtn}>← Back</button>
//             <button onClick={() => setCurrentStep(3)} disabled={!isDeliveryComplete()} style={primaryBtn}>
//               Continue to Payment →
//             </button>
//           </div>
//         </div>
//       )}
//       {/* Step 3: Payment */}
//       {currentStep === 3 && (
//         <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Mobile Money Payment</h3>
//           {!paymentInitiated ? (
//             <>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Mobile Operator</label>
//                 <select value={operator} onChange={e => setOperator(e.target.value)} style={inputStyle}>
//                   <option value="airtel">Airtel Money</option>
//                   <option value="mtn">MTN Mobile Money</option>
//                 </select>
//               </div>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Phone Number</label>
//                 <input
//                   type="tel"
//                   placeholder="e.g. 0971234567"
//                   value={phone}
//                   onChange={e => setPhone(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>
//               <div style={{
//                 backgroundColor: '#B39DDB',
//                 color: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '12px',
//                 fontSize: '1.5rem',
//                 fontWeight: '700',
//                 marginBottom: '2rem'
//               }}>
//                 Total to Pay: ${getTotalPrice()}
//               </div>
//               <button
//                 onClick={initiatePayment}
//                 disabled={loading || !phone}
//                 style={{
//                   ...primaryBtn,
//                   padding: '1.2rem 3rem',
//                   fontSize: '1.2rem',
//                   opacity: loading || !phone ? 0.7 : 1
//                 }}
//               >
//                 {loading ? 'Processing...' : `Pay ${getTotalPrice()} via ${operator.toUpperCase()}`}
//               </button>
//             </>
//           ) : (
//             <div style={{
//               backgroundColor: '#f0fdf4',
//               padding: '3rem',
//               borderRadius: '16px',
//               border: '2px dashed #90C8FF'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '80px',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2rem',
//                 margin: '0 auto 1.5rem'
//               }}>✓</div>
//               <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Payment Request Sent!</h3>
//               <p style={{ color: '#666', marginBottom: '2rem' }}>
//                 Please check your phone and approve the payment request.
//               </p>
//               <div style={{
//                 backgroundColor: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '8px',
//                 marginBottom: '2rem',
//                 fontFamily: 'monospace',
//                 fontSize: '1.3rem',
//                 color: '#B39DDB'
//               }}>
//                 Ref: {reference}
//               </div>
//               <button onClick={checkPaymentStatus} style={primaryBtn}>
//                 Check Payment Status
//               </button>
//               {status && (
//                 <div style={{
//                   marginTop: '1.5rem',
//                   padding: '1rem',
//                   backgroundColor: status.data?.status === 'success' ? '#d4edda' : '#f8d7da',
//                   borderRadius: '8px',
//                   color: status.data?.status === 'success' ? '#155724' : '#721c24'
//                 }}>
//                   Status: <strong>{status.data?.status?.toUpperCase()}</strong>
//                   <br />
//                   {status.message}
//                 </div>
//               )}
//             </div>
//           )}
//           <div style={{ marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(2)} style={secondaryBtn}>← Back</button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// const inputStyle = {
//   width: '100%',
//   padding: '1rem',
//   marginBottom: '1rem',
//   border: '2px solid #ddd',
//   borderRadius: '8px',
//   fontSize: '1rem'
// };

// const primaryBtn = {
//   backgroundColor: '#90C8FF',
//   color: '#222',
//   padding: '1rem 2rem',
//   border: 'none',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// const secondaryBtn = {
//   backgroundColor: 'transparent',
//   color: '#90C8FF',
//   padding: '1rem 2rem',
//   border: '2px solid #90C8FF',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// function ProductDetailPage({ product, addToCart, navigateTo }) {
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);

//   const hasSizes = product.variants?.sizes;
//   const hasColors = product.variants?.colors;

//   const handleAddToCart = () => {
//     if (hasSizes && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (hasColors && !selectedColor) {
//       alert("Please select a color");
//       return;
//     }
//     const cartItem = {
//       ...product,
//       quantity,
//       selectedSize: selectedSize || null,
//       selectedColor: selectedColor || null,
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     };
//     addToCart(cartItem);
//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: '#90C8FF',
//           fontSize: '1rem',
//           marginBottom: '2rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '0.5rem'
//         }}
//       >
//         ← Back to Shop
//       </button>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '4rem', alignItems: 'start' }}>
//         <div style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(144, 200, 255, 0.2)' }}>
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
//           />
//         </div>
//         <div>
//           <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontFamily: "'Playfair Display', serif", color: '#333' }}>
//             {product.title}
//           </h1>
//           <p style={{ color: '#666', marginBottom: '1rem', fontSize: '1.1rem' }}>{product.author}</p>
//           <p style={{ fontSize: '2rem', fontWeight: 700, color: '#90C8FF', marginBottom: '2rem' }}>
//             ${product.price}
//           </p>
//           <p style={{ lineHeight: '1.8', color: '#555', marginBottom: '2rem' }}>
//             {product.description}
//           </p>
//           {hasSizes && (
//             <div style={{ marginBottom: '1.5rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(size => (
//                   <button
//                     key={size}
//                     onClick={() => setSelectedSize(size)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedSize === size ? '2px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedSize === size ? '#90C8FF' : 'white',
//                       color: selectedSize === size ? '#222' : '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {size}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           {hasColors && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(color => (
//                   <button
//                     key={color}
//                     onClick={() => setSelectedColor(color)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedColor === color ? '3px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedColor === color ? '#f0f8ff' : 'white',
//                       color: '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       minWidth: '100px',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {color}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
//             <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #ddd', borderRadius: '8px' }}>
//               <button
//                 onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Minus size={20} />
//               </button>
//               <span style={{ padding: '0.8rem 1.5rem', fontWeight: 600 }}>{quantity}</span>
//               <button
//                 onClick={() => setQuantity(quantity + 1)}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Plus size={20} />
//               </button>
//             </div>
//             <button
//               onClick={handleAddToCart}
//               style={{
//                 flex: 1,
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 20px rgba(0,0,0,0.15)',
//       transition: 'right 0.3s ease',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         backgroundColor: '#B39DDB',
//         color: '#fff'
//       }}>
//         <h3 style={{ fontSize: '1.5rem', fontWeight: 600, fontFamily: "'Playfair Display', serif" }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
//           <X size={24} />
//         </button>
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '3rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
//               <div style={{ width: '80px', height: '100px', marginRight: '1rem' }}>
//                 <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#333' }}>{item.title}
//                   {(item.selectedSize || item.selectedColor) && (
//                     <span style={{ display: 'block', fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
//                       {item.selectedSize && `Size: ${item.selectedSize}`}
//                       {item.selectedSize && item.selectedColor && ' | '}
//                       {item.selectedColor && `Color: ${item.selectedColor}`}
//                     </span>
//                   )}
//                 </h4>
//                 <p style={{ color: '#90C8FF', fontWeight: 600, marginBottom: '0.5rem' }}>${item.price}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Minus size={16} />
//                   </button>
//                   <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
//                   <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Plus size={16} />
//                   </button>
//                   <button onClick={() => removeFromCart(item.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#999', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 600, color: '#333' }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       padding: '4rem 2rem 2rem',
//       marginTop: 'auto'
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//         gap: '2rem'
//       }}>
//         <div>
//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 700,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '50px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <p style={{ lineHeight: '1.7', opacity: 0.9, fontSize: '0.95rem' }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>
//           <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
//             {['F', 'T', 'I', 'G'].map((letter, i) => (
//               <a
//                 key={i}
//                 href="#"
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255,255,255,0.1)',
//                   borderRadius: '50%',
//                   fontSize: '1.1rem',
//                   transition: 'all 0.3s'
//                 }}
//                 onMouseOver={e => {
//                   e.target.style.backgroundColor = '#90C8FF';
//                   e.target.style.color = '#222';
//                   e.target.style.transform = 'translateY(-3px)';
//                 }}
//                 onMouseOut={e => {
//                   e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
//                   e.target.style.color = '#fff';
//                   e.target.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {letter}
//               </a>
//             ))}
//           </div>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Quick Links
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {[
//               { text: 'Home', page: 'home' },
//               { text: 'Books', page: 'books' },
//               { text: 'Accessories', page: 'accessories' },
//               { text: 'About', page: 'about' }
//             ].map((link) => (
//               <li key={link.page} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigateTo(link.page);
//                   }}
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.text}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Customer Service
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {['Shipping Info', 'Returns', 'Privacy Policy', 'Terms of Service', 'FAQ'].map((item) => (
//               <li key={item} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Contact
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem', lineHeight: '1.8' }}>
//             <li style={{ marginBottom: '0.8rem' }}>📍 123 Book Street, Literary City</li>
//             <li style={{ marginBottom: '0.8rem' }}>📞 (123) 456-7890</li>
//             <li style={{ marginBottom: '0.8rem' }}>✉️ info@upendostore.com</li>
//           </ul>
//         </div>
//       </div>
//       <div style={{
//         textAlign: 'center',
//         marginTop: '3rem',
//         paddingTop: '2rem',
//         borderTop: '1px solid rgba(255,255,255,0.2)',
//         opacity: 0.8,
//         fontSize: '0.9rem'
//       }}>
//         <p>&copy; {new Date().getFullYear()} UPENDOSTORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;


// import React, { useState,useEffect } from 'react';
// import './App.css';
// import { ShoppingCart, X, Minus, Plus, Trash2, Book } from 'lucide-react';
// import useContentful from "./Hooks/Contentful";


// //import images from /imges folder
// import logo from './Images/logo.JPEG';
// import Book15 from './Images/Book15.jpg';
// import Book1 from './Images/Book1.jpg';
// import Book2 from './Images/Book2.jpg';
// import Book3 from './Images/Book3.jpg';
// import Book4 from './Images/Book4.jpg';
// import Book5 from './Images/Book5.jpg';
// import Book6 from './Images/Book6.jpg';
// import Book7 from './Images/Book7.jpg';
// import Book8 from './Images/Book8.jpg';
// import Book9 from './Images/Book9.jpg';
// import Book10 from './Images/Book10.jpg';
// import Book11 from './Images/Hero1.JPG';
// import Book12 from './Images/Book12.jpg';
// import Book13 from './Images/Book13.jpg';
// import Book14 from './Images/Book14.jpg';

// import Book16 from './Images/Book16.jpg';
// import Book17 from './Images/Book17.jpg';
// import Book18 from './Images/Book18.jpg';
// import Book19 from './Images/Book19.jpg';


// // Books Data
// const booksData = [
//   {
//     id: 1,
//     title: "The Silent Echo",
//     author: "Musonda",
//     price: 24.99,
//     image: Book1,
//     //image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A gripping mystery novel that will keep you on the edge of your seat until the very last page.",
//     category: "books",
//     type: "Mystery"
//   },
//   {
//     id: 2,
//     title: "Beyond the Horizon",
//     author: "Musonda",
//     price: 19.99,
//     image: Book2,
//     description: "An epic adventure that takes you to worlds beyond your imagination.",
//     category: "books",
//     type: "Adventure"
//   },
//   {
//     id: 3,
//     title: "Whispers of the Past",
//     author: "Musonda",
//     price: 22.99,
//     image: Book3,
//     description: "A historical fiction that brings to life the untold stories of generations past.",
//     category: "books",
//     type: "Historical"
//   },
//   {
//     id: 4,
//     title: "Echoes of Tomorrow",
//     author: "Musonda",
//     price: 26.99,
//     image: Book4,
//     description: "A sci-fi thriller that explores the boundaries of time and reality.",
//     category: "books",
//     type: "Sci-Fi"
//   }
// ];

// // Accessories Data
// const accessoriesData = [
//   // {
//   //   id: 101,
//   //   title: "Literary Quote T-Shirt",
//   //   author: "UPENDO STORE Collection",
//   //   price: 29.99,
//   //   image: Book5,
//   //   description: "Premium cotton t-shirt featuring iconic quotes from classic literature.",
//   //   category: "accessories",
//   //   type: "Apparel"
//   // },
//   // {
//   //   id: 102,
//   //   title: "Bookworm Tote Bag",
//   //   author: "UPENDO STORE Collection",
//   //   price: 18.99,
//   //   image: Book6,
//   //   description: "Spacious canvas tote bag perfect for carrying your favorite reads.",
//   //   category: "accessories",
//   //   type: "Bags"
//   // },
//   {
//     id: 101,
//     title: "Literary Quote T-Shirt",
//     author: "UPENDO STORE Collection",
//     price: 29.99,
//     image: Book5,
//     description: "Premium cotton t-shirt featuring iconic quotes from classic literature.",
//     category: "accessories",
//     type: "Apparel",
//     variants: {
//       sizes: ["S", "M", "L", "XL", "XXL"],
//       colors: ["Black", "White", "Navy", "Gray"]
//     }
//   },
//   {
//     id: 102,
//     title: "Bookworm Tote Bag",
//     author: "UPENDO STORE Collection",
//     price: 18.99,
//     image: Book6,
//     description: "Spacious canvas tote bag perfect for carrying your favorite reads.",
//     category: "accessories",
//     type: "Bags",
//     variants: {
//       colors: ["Natural", "Black", "Pink"]
//     }
//   },
//   {
//     id: 103,
//     title: "Classic Fountain Pen Set",
//     author: "UPENDO STORE Collection",
//     price: 45.99,
//     image: Book7,
//     description: "Elegant fountain pen set for the discerning writer and note-taker.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 104,
//     title: "Reader's Ceramic Mug",
//     author: "UPENDO STORE Collection",
//     price: 16.99,
//     image: Book8,
//     description: "Beautiful ceramic mug with literary-inspired designs, perfect for tea or coffee.",
//     category: "accessories",
//     type: "Drinkware"
//   },
//   {
//     id: 105,
//     title: "Vintage Bookmark Set",
//     author: "UPENDO STORE Collection",
//     price: 12.99,
//     image: Book9,
//     description: "Set of 5 elegant metal bookmarks with classic literary motifs.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 106,
//     title: "Author's Notebook",
//     author: "UPENDO STORE Collection",
//     price: 19.99,
//     image: Book10,
//     description: "Leather-bound journal for capturing your thoughts and stories.",
//     category: "accessories",
//     type: "Stationery"
//   }
// ];

// const allProducts = [...booksData, ...accessoriesData];


// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [cardData, setCardData] = useState([]);


//       const splitToArray = (value) => {
//       if (!value) return [];
//       return value
//         .split(",")
//         .map(v => v.trim())
//         .filter(Boolean);
//     };

//     const getImageUrl = (asset) => {
//       if (!asset?.fields?.file?.url) return null;
//       return `https:${asset.fields.file.url}`;
//     };


//     const mapContentfulItemToCard = (item, index) => {

//       console.log("item",item)
//       return {
//         id: item.sys?.id || index, // fallback index if needed
//         title: item?.title,
//         author: "UPENDO STORE Collection", // or CMS field if you add one
//         price: Number(item?.price) / 100, // convert 2000 → 20.00
//         image: getImageUrl(item?.backgroundImage || item.bgimage),
//         description: item?.description,
//         category: item?.category === "book" ? "books" : "accessories",
//         type: item?.category, // or another CMS field if you have one
//         variants: {
//           sizes: splitToArray(item?.sizes),
//           colors: splitToArray(item?.colours),
//         }
//       };
//     };





//      const { getAuthors } = useContentful();

//     // useEffect(() => {
//     //     console.log("Hello")
//     //  // getAuthors().then((response) => console.log("ressedagt",response));
//     //   getAuthors().then((response) => response && setCardData(response));
//     // },[]);

//     useEffect(() => {
//   getAuthors().then((response) => {

//     console.log("response",response)
//     if (!response) return;

//     const formattedData = response.map((item, index) =>
//       mapContentfulItemToCard(item, index)
//     );
//     console.log("formattedData", formattedData); //debug log
//     setCardData(formattedData);
//      console.log("cardData",cardData);

//   });
// }, []);
   

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item => 
//           item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//         );
//       }
//       return [...prevItems, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems => 
//       prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   // const navigateTo = (page) => {
//   //   setCurrentPage(page);
//   //   setMobileMenuOpen(false);
//   //   setSelectedProduct(product);
//   // };

//   const navigateTo = (page, product = null) => {
//   setCurrentPage(page);
//   setSelectedProduct(product);
//   setMobileMenuOpen(false);
// };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//       case 'books':
//         return <ShopPage  navigateTo={navigateTo} products={cardData} addToCart={addToCart} title="Books Collection" />;
//        // return <ShopPage  navigateTo={navigateTo} products={booksData} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage products={accessoriesData} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage navigateTo={navigateTo} products={allProducts} addToCart={addToCart} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage 
//           cartItems={cartItems} 
//           getTotalPrice={getTotalPrice} 
//           navigateTo={navigateTo} 
//         />;
//         // return <CheckoutPage cartItems={cartItems} getTotalPrice={getTotalPrice} />;
//       case 'product-detail':
//   return selectedProduct ? (
//     <ProductDetailPage
//       product={selectedProduct}
//       addToCart={addToCart}
//       navigateTo={navigateTo}
//     />
//   ) : (
//     <div>Product not found</div>
//   );
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Crimson Text', 'Georgia', serif", minHeight: '100vh', backgroundColor: '#fdfaff', color: '#222' }}>
//       <Header
//         currentPage={currentPage}
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>{renderPage()}</main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal
//         isOpen={isCartOpen}
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 0' }}>
         
//         <div
//           onClick={() => navigateTo('home')}
//           className="navbar-logo"
//         >
//           <img
//             src={logo}
//             alt="Upendo Stores"
//             className="logo-image"
//           />

//           <span className="logo-text">
//             UPENDO STORE
//           </span>
//         </div>


         
//           {/* <div style={{
//             fontSize: '1.8rem',
//             fontWeight: 700,
//             fontFamily: "'Playfair Display', serif",
//             cursor: 'pointer'
//           }} onClick={() => navigateTo('home')}>
//             UPENDO STOREs
//           </div> */}

//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#B39DDB',
//             flexDirection: 'column',
//             padding: '2rem',
//             boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)'
//           }} className="nav-menu">
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button onClick={openCart} style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               cursor: 'pointer',
//               position: 'relative',
//               fontSize: '1.2rem',
//               padding: '0.5rem'
//             }}>
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-8px',
//                   right: '-8px',
//                   backgroundColor: '#90C8FF',
//                   color: '#222',
//                   borderRadius: '50%',
//                   width: '22px',
//                   height: '22px',
//                   fontSize: '0.75rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               fontSize: '1.6rem',
//               cursor: 'pointer'
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>

//       <style jsx>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//             boxShadow: none !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#fff' : 'rgba(255,255,255,0.85)',
//         cursor: 'pointer',
//         padding: '0.5rem 0',
//         borderBottom: active ? '3px solid #90C8FF' : 'none',
//         transition: 'all 0.3s'
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo }) {
//   const featuredBooks = booksData.slice(0, 3);
//   const featuredAccessories = accessoriesData.slice(0, 3);

//   return (
//     <>
//       <section className="hero" 
//         style={{
//         backgroundImage: `
//   linear-gradient(
//     rgba(0, 0, 0, 0.6),
//     rgba(0, 0, 0, 0.6)
//   ),
//   url(${Book11})
// `,


//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           color: '#fff',
//           textAlign: 'center',
//           padding: '8rem 2rem'
//         }}
//       >
//         <h1
//           style={{
//             fontSize: '3.5rem',
//             marginBottom: '1rem',
//             fontFamily: "'Playfair Display', serif",
//             fontWeight: 700
//           }}
//         >
//           Discover The Captivating World of Colour
//         </h1>

//         <p style={{ fontSize: '1.5rem', marginBottom: '2rem', opacity: 0.95 }}>
//           Explore the vibrant world of our colour therapy books
//         </p>

//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#90C8FF',
//             color: '#222',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => (e.target.style.backgroundColor = '#7ab8ff')}
//           onMouseOut={e => (e.target.style.backgroundColor = '#90C8FF')}
//         >
//           Browse Collection
//         </button>
//       </section>


//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredBooks.map(book => <ProductCard key={book.id} product={book} addToCart={addToCart} navigateTo={navigateTo} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>

//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8f3ff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredAccessories.map(item => <ProductCard key={item.id} product={item} addToCart={addToCart} navigateTo={navigateTo}/>)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>

//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart,navigateTo }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 6px 20px rgba(144, 200, 255, 0.18)',
//       transition: 'all 0.3s'
//     }}
//     onMouseOver={e => {
//       e.currentTarget.style.transform = 'translateY(-10px)';
//       e.currentTarget.style.boxShadow = '0 20px 40px rgba(144, 200, 255, 0.3)';
//     }}
//     onMouseOut={e => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 6px 20px rgba(144, 200, 255, 0.18)';
//     }}>
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
//           onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
//           onMouseOut={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 600, color: '#333' }}>{product.title}</h3>
//         <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.3rem', fontWeight: 700, color: '#90C8FF', marginBottom: '1rem' }}>${product.price}</p>
//         <div style={{ display: 'flex', gap: '0.5rem' }}>
//           <button
//           onClick={() => navigateTo('product-detail', product)}
//           style={{
//             flex: 1,
//             backgroundColor: 'transparent',
//             color: '#90C8FF',
//             border: '2px solid #90C8FF',
//             padding: '0.6rem',
//             borderRadius: '8px',
//             fontWeight: 600,
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//           onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//         >
//           View Details
//         </button>
//           {/* <button
//             style={{
//               flex: 1,
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View Details
//           </button> */}
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }



// // ProductCard Component end

// function ShopPage({ products, addToCart, title,navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif",
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//       </h2>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {products.map(product => <ProductCard 
//   key={product.id} 
//   product={product} 
//   addToCart={addToCart} 
//   navigateTo={navigateTo} 
// />)}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory,navigateTo }) {
//   const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//         Complete Collection
//       </h2>
//       <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         <FilterButton active={selectedCategory === 'all'} onClick={() => setSelectedCategory('all')}>All Products</FilterButton>
//         <FilterButton active={selectedCategory === 'books'} onClick={() => setSelectedCategory('books')}>Books</FilterButton>
//         <FilterButton active={selectedCategory === 'accessories'} onClick={() => setSelectedCategory('accessories')}>Accessories</FilterButton>
//       </div>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {filteredProducts.map(product => <ProductCard 
//   key={product.id} 
//   product={product} 
//   addToCart={addToCart} 
//   navigateTo={navigateTo} 
// />)}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#90C8FF' : 'transparent',
//         color: active ? '#222' : '#90C8FF',
//         border: '2px solid #90C8FF',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s'
//       }}
//       onMouseOver={e => !active && (e.target.style.backgroundColor = '#90C8FF', e.target.style.color = '#222')}
//       onMouseOut={e => !active && (e.target.style.backgroundColor = 'transparent', e.target.style.color = '#90C8FF')}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#f8f3ff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//           {/* <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} /> */}
//           <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>
//             About the Author
//           </h3>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Store
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//             <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//             <img src={Book15} alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring the outdoors for inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
// function CheckoutPage({ cartItems, getTotalPrice, navigateTo }) {
//   const [currentStep, setCurrentStep] = useState(1);

//   // Delivery
//   const [deliveryMethod, setDeliveryMethod] = useState('pickup'); // 'pickup' or 'delivery'
//   const [deliveryAddress, setDeliveryAddress] = useState({
//     fullName: '',
//     street: '',
//     city: '',
//     province: '',
//     postalCode: '',
//     additionalInfo: ''
//   });

//   // Payment
//   const [phone, setPhone] = useState('');
//   const [operator, setOperator] = useState('airtel'); // airtel or mtn

//   // Status
//   const [loading, setLoading] = useState(false);
//   const [reference, setReference] = useState('');
//   const [paymentInitiated, setPaymentInitiated] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleAddressChange = (field, value) => {
//     setDeliveryAddress(prev => ({ ...prev, [field]: value }));
//   };

//   const isDeliveryComplete = () => {
//     if (deliveryMethod === 'pickup') return true;
//     return deliveryAddress.fullName && deliveryAddress.street && deliveryAddress.city && deliveryAddress.province;
//   };

//   const initiatePayment = async () => {
//     if (!phone || phone.length < 10) {
//       alert("Please enter a valid phone number");
//       return;
//     }

//     setLoading(true);

//     const items = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       quantity: item.quantity,
//       size: item.selectedSize || null,
//       color: item.selectedColor || null,
//       totalCost: item.price * item.quantity
//     }));

//     const payload = {
//       amount: parseFloat(getTotalPrice()),
//       phone_number: phone.replace(/[^0-9]/g, ''), // clean phone
//       operator,
//       items,
//       delivery_method: deliveryMethod,
//       delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
//     };

//     try {
//       const response = await fetch("https://albeutystore.store/payment", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       const data = await response.json();

//       if (response.ok && data.data?.reference) {
//         setReference(data.data.reference);
//         setPaymentInitiated(true);
//         alert("Payment request sent! Check your phone for the payment prompt.");
//       } else {
//         alert(data.message || "Payment initiation failed. Try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network error. Please check your connection and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async () => {
//     if (!reference) return;

//     try {
//       const response = await fetch(`https://albeutystore.store/collections/status/${reference}`);
//       const data = await response.json();
//       setStatus(data);

//       if (data.data?.status === "success") {
//         alert("Payment successful! Thank you for your order.");
//         // Optionally: clear cart, redirect to home
//         navigateTo('home');
//       } else if (data.data?.status === "failed") {
//         alert("Payment failed. You can try again.");
//       }
//     } catch (err) {
//       alert("Could not check status. Try again later.");
//     }
//   };

//   const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Playfair Display', serif"
//       }}>
//         Checkout
//       </h2>

//       {/* Progress Steps */}
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         {['Cart Review', 'Delivery', 'Payment'].map((label, i) => (
//           <div key={i} style={{ display: 'flex', alignItems: 'center', flex: '1 1 200px', maxWidth: '300px' }}>
//             <div style={{
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               backgroundColor: currentStep > i ? '#90C8FF' : currentStep === i + 1 ? '#B39DDB' : '#eee',
//               color: 'white',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '1.1rem'
//             }}>
//               {i + 1}
//             </div>
//             <span style={{ marginLeft: '1rem', fontWeight: currentStep === i + 1 ? '600' : '400', color: '#333' }}>
//               {label}
//             </span>
//             {i < 2 && (
//               <div style={{
//                 flex: 1,
//                 height: '3px',
//                 backgroundColor: currentStep > i + 1 ? '#90C8FF' : '#ddd',
//                 margin: '0 1rem'
//               }} />
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Step 1: Cart Review */}
//       {currentStep === 1 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Review Your Items</h3>
//           {cartItems.length === 0 ? (
//             <p style={{ textAlign: 'center', color: '#999', fontSize: '1.2rem' }}>Your cart is empty</p>
//           ) : (
//             <>
//               {cartItems.map(item => (
//                 <div key={item.variantId || item.id} style={{
//                   display: 'flex',
//                   gap: '1.5rem',
//                   padding: '1.5rem',
//                   border: '1px solid #eee',
//                   borderRadius: '8px',
//                   marginBottom: '1rem',
//                   alignItems: 'center'
//                 }}>
//                   <img src={item.image} alt={item.title} style={{ width: '100px', height: '120px', objectFit: 'cover', borderRadius: '8px' }} />
//                   <div style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 0.5rem', fontSize: '1.2rem' }}>{item.title}</h4>
//                     {item.selectedSize && <p style={{ margin: '0.3rem 0', color: '#666' }}>Size: {item.selectedSize}</p>}
//                     {item.selectedColor && <p style={{ margin: '0.3rem 0', color: '#666' }}>Color: {item.selectedColor}</p>}
//                     <p style={{ margin: '0.5rem 0', color: '#90C8FF', fontWeight: '600' }}>
//                       ${item.price} × {item.quantity} = ${(item.price * item.quantity).toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//               ))}

//               <div style={{
//                 textAlign: 'right',
//                 padding: '1.5rem',
//                 backgroundColor: '#f8f3ff',
//                 borderRadius: '8px',
//                 fontSize: '1.4rem',
//                 fontWeight: '700',
//                 color: '#B39DDB'
//               }}>
//                 Total: ${getTotalPrice()}
//               </div>

//               <div style={{ textAlign: 'right', marginTop: '2rem' }}>
//                 <button
//                   onClick={() => setCurrentStep(2)}
//                   style={{
//                     backgroundColor: '#90C8FF',
//                     color: '#222',
//                     padding: '1rem 2rem',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Continue to Delivery
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       )}

//       {/* Step 2: Delivery */}
//       {currentStep === 2 && (
//         <div>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Delivery Method</h3>

//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
//             <label style={{
//               border: deliveryMethod === 'pickup' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'pickup' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="pickup"
//                 checked={deliveryMethod === 'pickup'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Store Pickup</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>Collect from UPENDO STORE location</p>
//             </label>

//             <label style={{
//               border: deliveryMethod === 'delivery' ? '3px solid #90C8FF' : '2px solid #ddd',
//               borderRadius: '12px',
//               padding: '1.5rem',
//               cursor: 'pointer',
//               backgroundColor: deliveryMethod === 'delivery' ? '#f0f8ff' : 'white'
//             }}>
//               <input
//                 type="radio"
//                 name="delivery"
//                 value="delivery"
//                 checked={deliveryMethod === 'delivery'}
//                 onChange={(e) => setDeliveryMethod(e.target.value)}
//                 style={{ marginRight: '1rem' }}
//               />
//               <strong>Home Delivery</strong>
//               <p style={{ margin: '0.5rem 0 0', color: '#666' }}>We'll deliver to your address</p>
//             </label>
//           </div>

//           {deliveryMethod === 'delivery' && (
//             <div style={{ backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '12px' }}>
//               <h4 style={{ marginBottom: '1.5rem' }}>Delivery Address</h4>
//               <input type="text" placeholder="Full Name *" value={deliveryAddress.fullName} onChange={e => handleAddressChange('fullName', e.target.value)} style={inputStyle} />
//               <input type="text" placeholder="Street Address *" value={deliveryAddress.street} onChange={e => handleAddressChange('street', e.target.value)} style={inputStyle} />
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
//                 <input type="text" placeholder="City *" value={deliveryAddress.city} onChange={e => handleAddressChange('city', e.target.value)} style={inputStyle} />
//                 <input type="text" placeholder="Province *" value={deliveryAddress.province} onChange={e => handleAddressChange('province', e.target.value)} style={inputStyle} />
//               </div>
//               <input type="text" placeholder="Postal Code (optional)" value={deliveryAddress.postalCode} onChange={e => handleAddressChange('postalCode', e.target.value)} style={inputStyle} />
//               <textarea placeholder="Additional info (apt, landmark...)" value={deliveryAddress.additionalInfo} onChange={e => handleAddressChange('additionalInfo', e.target.value)} style={{ ...inputStyle, height: '100px' }} />
//             </div>
//           )}

//           <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(1)} style={secondaryBtn}>← Back</button>
//             <button onClick={() => setCurrentStep(3)} disabled={!isDeliveryComplete()} style={primaryBtn}>
//               Continue to Payment →
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Step 3: Payment */}
//       {currentStep === 3 && (
//         <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
//           <h3 style={{ fontSize: '1.8rem', marginBottom: '2rem' }}>Mobile Money Payment</h3>

//           {!paymentInitiated ? (
//             <>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Mobile Operator</label>
//                 <select value={operator} onChange={e => setOperator(e.target.value)} style={inputStyle}>
//                   <option value="airtel">Airtel Money</option>
//                   <option value="mtn">MTN Mobile Money</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Phone Number</label>
//                 <input
//                   type="tel"
//                   placeholder="e.g. 0971234567"
//                   value={phone}
//                   onChange={e => setPhone(e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>

//               <div style={{
//                 backgroundColor: '#B39DDB',
//                 color: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '12px',
//                 fontSize: '1.5rem',
//                 fontWeight: '700',
//                 marginBottom: '2rem'
//               }}>
//                 Total to Pay: ${getTotalPrice()}
//               </div>

//               <button
//                 onClick={initiatePayment}
//                 disabled={loading || !phone}
//                 style={{
//                   ...primaryBtn,
//                   padding: '1.2rem 3rem',
//                   fontSize: '1.2rem',
//                   opacity: loading || !phone ? 0.7 : 1
//                 }}
//               >
//                 {loading ? 'Processing...' : `Pay ${getTotalPrice()} via ${operator.toUpperCase()}`}
//               </button>
//             </>
//           ) : (
//             <div style={{
//               backgroundColor: '#f0fdf4',
//               padding: '3rem',
//               borderRadius: '16px',
//               border: '2px dashed #90C8FF'
//             }}>
//               <div style={{
//                 width: '80px',
//                 height: '80px',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontSize: '2rem',
//                 margin: '0 auto 1.5rem'
//               }}>✓</div>

//               <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Payment Request Sent!</h3>
//               <p style={{ color: '#666', marginBottom: '2rem' }}>
//                 Please check your phone and approve the payment request.
//               </p>

//               <div style={{
//                 backgroundColor: 'white',
//                 padding: '1.5rem',
//                 borderRadius: '8px',
//                 marginBottom: '2rem',
//                 fontFamily: 'monospace',
//                 fontSize: '1.3rem',
//                 color: '#B39DDB'
//               }}>
//                 Ref: {reference}
//               </div>

//               <button onClick={checkPaymentStatus} style={primaryBtn}>
//                 Check Payment Status
//               </button>

//               {status && (
//                 <div style={{
//                   marginTop: '1.5rem',
//                   padding: '1rem',
//                   backgroundColor: status.data?.status === 'success' ? '#d4edda' : '#f8d7da',
//                   borderRadius: '8px',
//                   color: status.data?.status === 'success' ? '#155724' : '#721c24'
//                 }}>
//                   Status: <strong>{status.data?.status?.toUpperCase()}</strong>
//                   <br />
//                   {status.message}
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ marginTop: '3rem' }}>
//             <button onClick={() => setCurrentStep(2)} style={secondaryBtn}>← Back</button>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// // Reusable styles
// const inputStyle = {
//   width: '100%',
//   padding: '1rem',
//   marginBottom: '1rem',
//   border: '2px solid #ddd',
//   borderRadius: '8px',
//   fontSize: '1rem'
// };

// const primaryBtn = {
//   backgroundColor: '#90C8FF',
//   color: '#222',
//   padding: '1rem 2rem',
//   border: 'none',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };

// const secondaryBtn = {
//   backgroundColor: 'transparent',
//   color: '#90C8FF',
//   padding: '1rem 2rem',
//   border: '2px solid #90C8FF',
//   borderRadius: '8px',
//   fontWeight: '600',
//   fontSize: '1.1rem',
//   cursor: 'pointer'
// };
// // function CheckoutPage({ cartItems, getTotalPrice }) {
// //   const [formData, setFormData] = useState({
// //     firstName: '', lastName: '', email: '', address: '', city: '', zipCode: '',
// //     cardNumber: '', expiryDate: '', cvv: ''
// //   });

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: value }));
// //   };

// //   const handleCheckout = (e) => {
// //     e.preventDefault();
// //     alert('Order placed successfully! Thank you for your purchase.');
// //   };

// //   return (
// //     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
// //       <div style={{ maxWidth: '800px', margin: '0 auto' }}>
// //         <h2 style={{
// //           textAlign: 'center',
// //           fontSize: '2.5rem',
// //           marginBottom: '3rem',
// //           color: '#333',
// //           fontFamily: "'Playfair Display', serif"
// //         }}>
// //           Checkout
// //         </h2>
// //         <form onSubmit={handleCheckout} style={{
// //           backgroundColor: 'white',
// //           borderRadius: '8px',
// //           padding: '2rem',
// //           boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)'
// //         }}>
// //           {/* Shipping & Payment fields omitted for brevity – same styling */}

// //           <div style={{ backgroundColor: '#f8f3ff', borderRadius: '8px', padding: '1.5rem', margin: '2rem 0' }}>
// //             <h3 style={{ fontSize: '1.3rem', marginBottom: '1rem', color: '#333', fontFamily: "'Playfair Display', serif" }}>Order Summary</h3>
// //             {cartItems.map(item => (
// //               <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem', paddingBottom: '0.8rem', borderBottom: '1px solid #eee' }}>
// //                 <span>{item.title} (x{item.quantity})</span>
// //                 <span style={{ fontWeight: 600 }}>${(item.price * item.quantity).toFixed(2)}</span>
// //               </div>
// //             ))}
// //             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 700, marginTop: '1rem', paddingTop: '1rem', borderTop: '2px solid #B39DDB' }}>
// //               <span>Total</span>
// //               <span>${getTotalPrice()}</span>
// //             </div>
// //           </div>

// //           <button
// //             type="submit"
// //             style={{
// //               width: '100%',
// //               backgroundColor: '#90C8FF',
// //               color: '#222',
// //               border: 'none',
// //               padding: '1rem',
// //               borderRadius: '8px',
// //               fontSize: '1.1rem',
// //               fontWeight: 600,
// //               cursor: 'pointer',
// //               transition: 'all 0.3s'
// //             }}
// //             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
// //             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
// //           >
// //             Place Order
// //           </button>
// //         </form>
// //       </div>
// //     </section>
// //   );
// // }


// // product detail Component
// function ProductDetailPage({ product, addToCart, navigateTo }) {
//   const [selectedSize, setSelectedSize] = useState('');
//   const [selectedColor, setSelectedColor] = useState('');
//   const [quantity, setQuantity] = useState(1);

//   const hasSizes = product.variants?.sizes;
//   const hasColors = product.variants?.colors;

//   const handleAddToCart = () => {
//     if (hasSizes && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (hasColors && !selectedColor) {
//       alert("Please select a color");
//       return;
//     }

//     const cartItem = {
//       ...product,
//       quantity,
//       selectedSize: selectedSize || null,
//       selectedColor: selectedColor || null,
//       // Create a unique key for variants
//       variantId: `${product.id}-${selectedSize || ''}-${selectedColor || ''}`
//     };

//     addToCart(cartItem);
//     alert(`${product.title} added to cart!`);
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <button
//         onClick={() => navigateTo('shop')}
//         style={{
//           background: 'none',
//           border: 'none',
//           color: '#90C8FF',
//           fontSize: '1rem',
//           marginBottom: '2rem',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '0.5rem'
//         }}
//       >
//         ← Back to Shop
//       </button>

//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '4rem', alignItems: 'start' }}>
//         <div style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(144, 200, 255, 0.2)' }}>
//           <img
//             src={product.image}
//             alt={product.title}
//             style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
//           />
//         </div>

//         <div>
//           <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', fontFamily: "'Playfair Display', serif", color: '#333' }}>
//             {product.title}
//           </h1>
//           <p style={{ color: '#666', marginBottom: '1rem', fontSize: '1.1rem' }}>{product.author}</p>
//           <p style={{ fontSize: '2rem', fontWeight: 700, color: '#90C8FF', marginBottom: '2rem' }}>
//             ${product.price}
//           </p>

//           <p style={{ lineHeight: '1.8', color: '#555', marginBottom: '2rem' }}>
//             {product.description}
//           </p>

//           {/* Size Selector */}
//           {hasSizes && (
//             <div style={{ marginBottom: '1.5rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Size</h4>
//               <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
//                 {product.variants.sizes.map(size => (
//                   <button
//                     key={size}
//                     onClick={() => setSelectedSize(size)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedSize === size ? '2px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedSize === size ? '#90C8FF' : 'white',
//                       color: selectedSize === size ? '#222' : '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {size}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Color Selector */}
//           {hasColors && (
//             <div style={{ marginBottom: '2rem' }}>
//               <h4 style={{ marginBottom: '0.8rem', color: '#333' }}>Color</h4>
//               <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
//                 {product.variants.colors.map(color => (
//                   <button
//                     key={color}
//                     onClick={() => setSelectedColor(color)}
//                     style={{
//                       padding: '0.7rem 1.2rem',
//                       border: selectedColor === color ? '3px solid #90C8FF' : '2px solid #ddd',
//                       backgroundColor: selectedColor === color ? '#f0f8ff' : 'white',
//                       color: '#333',
//                       borderRadius: '8px',
//                       fontWeight: 600,
//                       cursor: 'pointer',
//                       minWidth: '100px',
//                       transition: 'all 0.3s'
//                     }}
//                   >
//                     {color}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Quantity & Add to Cart */}
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
//             <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #ddd', borderRadius: '8px' }}>
//               <button
//                 onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Minus size={20} />
//               </button>
//               <span style={{ padding: '0.8rem 1.5rem', fontWeight: 600 }}>{quantity}</span>
//               <button
//                 onClick={() => setQuantity(quantity + 1)}
//                 style={{ padding: '0.8rem 1rem', background: 'none', border: 'none', fontSize: '1.2rem' }}
//               >
//                 <Plus size={20} />
//               </button>
//             </div>

//             <button
//               onClick={handleAddToCart}
//               style={{
//                 flex: 1,
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Add to Cart
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// //end product detail component

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 20px rgba(0,0,0,0.15)',
//       transition: 'right 0.3s ease',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         backgroundColor: '#B39DDB',
//         color: '#fff'
//       }}>
//         <h3 style={{ fontSize: '1.5rem', fontWeight: 600, fontFamily: "'Playfair Display', serif" }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
//           <X size={24} />
//         </button>
//       </div>

//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '3rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
//               <div style={{ width: '80px', height: '100px', marginRight: '1rem' }}>
//                 <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#333' }}>{item.title}{(item.selectedSize || item.selectedColor) && (
//     <span style={{ display: 'block', fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
//       {item.selectedSize && `Size: ${item.selectedSize}`}
//       {item.selectedSize && item.selectedColor && ' | '}
//       {item.selectedColor && `Color: ${item.selectedColor}`}
//     </span>
//   )}</h4>
//                 <p style={{ color: '#90C8FF', fontWeight: 600, marginBottom: '0.5rem' }}>${item.price}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Minus size={16} />
//                   </button>
//                   <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
//                   <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Plus size={16} />
//                   </button>
//                   <button onClick={() => removeFromCart(item.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#999', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 600, color: '#333' }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

//   function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       padding: '4rem 2rem 2rem',
//       marginTop: 'auto' // Ensures footer stays at bottom if content is short
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//         gap: '2rem'
//       }}>
//         {/* Column 1: Brand */}
//         <div>
//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 700,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '50px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <p style={{ lineHeight: '1.7', opacity: 0.9, fontSize: '0.95rem' }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>

//           {/* Social Icons */}
//           <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
//             {['F', 'T', 'I', 'G'].map((letter, i) => (
//               <a
//                 key={i}
//                 href="#"
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255,255,255,0.1)',
//                   borderRadius: '50%',
//                   fontSize: '1.1rem',
//                   transition: 'all 0.3s'
//                 }}
//                 onMouseOver={e => {
//                   e.target.style.backgroundColor = '#90C8FF';
//                   e.target.style.color = '#222';
//                   e.target.style.transform = 'translateY(-3px)';
//                 }}
//                 onMouseOut={e => {
//                   e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
//                   e.target.style.color = '#fff';
//                   e.target.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {letter}
//               </a>
//             ))}
//           </div>
//         </div>

//         {/* Column 2: Quick Links */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Quick Links
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {[
//               { text: 'Home', page: 'home' },
//               { text: 'Books', page: 'books' },
//               { text: 'Accessories', page: 'accessories' },
//               { text: 'About', page: 'about' }
//             ].map((link) => (
//               <li key={link.page} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigateTo(link.page);
//                   }}
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.text}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Column 3: Customer Service */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Customer Service
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem' }}>
//             {['Shipping Info', 'Returns', 'Privacy Policy', 'Terms of Service', 'FAQ'].map((item) => (
//               <li key={item} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   style={{
//                     color: '#fff',
//                     textDecoration: 'none',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={e => {
//                     e.target.style.color = '#90C8FF';
//                     e.target.style.paddingLeft = '8px';
//                   }}
//                   onMouseOut={e => {
//                     e.target.style.color = '#fff';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Column 4: Contact */}
//         <div>
//           <h3 style={{
//             fontSize: '1.2rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 600,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Contact
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#90C8FF'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none', fontSize: '0.95rem', lineHeight: '1.8' }}>
//             <li style={{ marginBottom: '0.8rem' }}>📍 123 Book Street, Literary City</li>
//             <li style={{ marginBottom: '0.8rem' }}>📞 (123) 456-7890</li>
//             <li style={{ marginBottom: '0.8rem' }}>✉️ info@upendostore.com</li>
//           </ul>
//         </div>
//       </div>

//       {/* Copyright */}
//       <div style={{
//         textAlign: 'center',
//         marginTop: '3rem',
//         paddingTop: '2rem',
//         borderTop: '1px solid rgba(255,255,255,0.2)',
//         opacity: 0.8,
//         fontSize: '0.9rem'
//       }}>
//         <p>&copy; {new Date().getFullYear()} UPENDOSTORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;

// import React, { useState } from 'react';
// import { ShoppingCart, X, Minus, Plus, Trash2 } from 'lucide-react';

// // Books Data
// const booksData = [
//   {
//     id: 1,
//     title: "The Silent Echo",
//     author: "Musonda",
//     price: 24.99,
//     image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A gripping mystery novel that will keep you on the edge of your seat until the very last page.",
//     category: "books",
//     type: "Mystery"
//   },
//   {
//     id: 2,
//     title: "Beyond the Horizon",
//     author: "Musonda",
//     price: 19.99,
//     image: "https://images.unsplash.com/photo-1532012197267-da84d127e765?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "An epic adventure that takes you to worlds beyond your imagination.",
//     category: "books",
//     type: "Adventure"
//   },
//   {
//     id: 3,
//     title: "Whispers of the Past",
//     author: "Musonda",
//     price: 22.99,
//     image: "https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A historical fiction that brings to life the untold stories of generations past.",
//     category: "books",
//     type: "Historical"
//   },
//   {
//     id: 4,
//     title: "Echoes of Tomorrow",
//     author: "Musonda",
//     price: 26.99,
//     image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A sci-fi thriller that explores the boundaries of time and reality.",
//     category: "books",
//     type: "Sci-Fi"
//   }
// ];

// // Accessories Data
// const accessoriesData = [
//   {
//     id: 101,
//     title: "Literary Quote T-Shirt",
//     author: "UPENDO STORE Collection",
//     price: 29.99,
//     image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Premium cotton t-shirt featuring iconic quotes from classic literature.",
//     category: "accessories",
//     type: "Apparel"
//   },
//   {
//     id: 102,
//     title: "Bookworm Tote Bag",
//     author: "UPENDO STORE Collection",
//     price: 18.99,
//     image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Spacious canvas tote bag perfect for carrying your favorite reads.",
//     category: "accessories",
//     type: "Bags"
//   },
//   {
//     id: 103,
//     title: "Classic Fountain Pen Set",
//     author: "UPENDO STORE Collection",
//     price: 45.99,
//     image: "https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Elegant fountain pen set for the discerning writer and note-taker.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 104,
//     title: "Reader's Ceramic Mug",
//     author: "UPENDO STORE Collection",
//     price: 16.99,
//     image: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Beautiful ceramic mug with literary-inspired designs, perfect for tea or coffee.",
//     category: "accessories",
//     type: "Drinkware"
//   },
//   {
//     id: 105,
//     title: "Vintage Bookmark Set",
//     author: "UPENDO STORE Collection",
//     price: 12.99,
//     image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Set of 5 elegant metal bookmarks with classic literary motifs.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 106,
//     title: "Author's Notebook",
//     author: "UPENDO STORE Collection",
//     price: 19.99,
//     image: "https://images.unsplash.com/photo-1531346878377-a5be20888e57?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Leather-bound journal for capturing your thoughts and stories.",
//     category: "accessories",
//     type: "Stationery"
//   }
// ];

// const allProducts = [...booksData, ...accessoriesData];

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item => 
//           item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//         );
//       }
//       return [...prevItems, { ...product, quantity: 1 }];
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems => 
//       prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   const navigateTo = (page) => {
//     setCurrentPage(page);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//       case 'books':
//         return <ShopPage products={booksData} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage products={accessoriesData} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage 
//           products={allProducts} 
//           addToCart={addToCart} 
//           selectedCategory={selectedCategory}
//           setSelectedCategory={setSelectedCategory}
//         />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage cartItems={cartItems} getTotalPrice={getTotalPrice} />;
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//     }
//   };

//   return (
//     <div style={{ 
//       fontFamily: "'Nunito', sans-serif", 
//       minHeight: '100vh', 
//       backgroundColor: '#fdfaff', 
//       color: '#222',
//       lineHeight: '1.6'
//     }}>
//       <Header
//         currentPage={currentPage}
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>{renderPage()}</main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal
//         isOpen={isCartOpen}
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 0' }}>
//           <div style={{
//             fontSize: '2rem',
//             fontWeight: 700,
//             fontFamily: "'Lora', serif",
//             cursor: 'pointer'
//           }} onClick={() => navigateTo('home')}>
//             UPENDO STORE
//           </div>

//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#B39DDB',
//             flexDirection: 'column',
//             padding: '2rem',
//             boxShadow: '0 4px 20px rgba(179, 157, 219, 0.3)'
//           }} className="nav-menu">
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button onClick={openCart} style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               cursor: 'pointer',
//               position: 'relative',
//               fontSize: '1.2rem',
//               padding: '0.5rem'
//             }}>
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-8px',
//                   right: '-8px',
//                   backgroundColor: '#90C8FF',
//                   color: '#222',
//                   borderRadius: '50%',
//                   width: '22px',
//                   height: '22px',
//                   fontSize: '0.75rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#fff',
//               fontSize: '1.6rem',
//               cursor: 'pointer'
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>

//       <style jsx>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//             boxShadow: none !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#fff' : 'rgba(255,255,255,0.85)',
//         cursor: 'pointer',
//         padding: '0.5rem 0',
//         borderBottom: active ? '3px solid #90C8FF' : 'none',
//         transition: 'all 0.3s'
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo }) {
//   const featuredBooks = booksData.slice(0, 3);
//   const featuredAccessories = accessoriesData.slice(0, 3);

//   return (
//     <>
//       <section style={{
//         background: 'linear-gradient(rgba(179, 157, 219, 0.88), rgba(179, 157, 219, 0.88)), ur[](https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80)',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         color: '#fff',
//         textAlign: 'center',
//         padding: '8rem 2rem'
//       }}>
//         <h1 style={{
//           fontSize: '3.5rem',
//           marginBottom: '1rem',
//           fontFamily: "'Lora', serif",
//           fontWeight: 700
//         }}>
//           Discover Captivating Stories
//         </h1>
//         <p style={{ fontSize: '1.5rem', marginBottom: '2rem', opacity: 0.95 }}>
//           Explore the literary world of bestselling author Musonda
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#90C8FF',
//             color: '#222',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s'
//           }}
//           onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//           onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//         >
//           Browse Collection
//         </button>
//       </section>

//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Lora', serif",
//           fontWeight: 700,
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredBooks.map(book => <ProductCard key={book.id} product={book} addToCart={addToCart} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>

//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8f3ff' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Lora', serif",
//           fontWeight: 700,
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//           {featuredAccessories.map(item => <ProductCard key={item.id} product={item} addToCart={addToCart} />)}
//         </div>
//         <div style={{ textAlign: 'center', marginTop: '3rem' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>

//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 6px 20px rgba(144, 200, 255, 0.18)',
//       transition: 'all 0.3s'
//     }}
//     onMouseOver={e => {
//       e.currentTarget.style.transform = 'translateY(-10px)';
//       e.currentTarget.style.boxShadow = '0 20px 40px rgba(144, 200, 255, 0.3)';
//     }}
//     onMouseOut={e => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 6px 20px rgba(144, 200, 255, 0.18)';
//     }}>
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
//           onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
//           onMouseOut={e => e.target.style.transform = 'scale(1)'}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{ 
//           fontSize: '1.3rem', 
//           marginBottom: '0.5rem', 
//           fontWeight: 600, 
//           color: '#333',
//           fontFamily: "'Lora', serif"
//         }}>
//           {product.title}
//         </h3>
//         <p style={{ color: '#666', marginBottom: '0.5rem', fontSize: '0.95rem' }}>{product.author}</p>
//         <p style={{ fontSize: '1.4rem', fontWeight: 700, color: '#90C8FF', marginBottom: '1rem' }}>${product.price}</p>
//         <div style={{ display: 'flex', gap: '0.5rem' }}>
//           <button
//             style={{
//               flex: 1,
//               backgroundColor: 'transparent',
//               color: '#90C8FF',
//               border: '2px solid #90C8FF',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => { e.target.style.backgroundColor = '#90C8FF'; e.target.style.color = '#222'; }}
//             onMouseOut={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#90C8FF'; }}
//           >
//             View Details
//           </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ShopPage({ products, addToCart, title }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#333',
//         fontFamily: "'Lora', serif",
//         fontWeight: 700,
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//       </h2>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {products.map(product => <ProductCard key={product.id} product={product} addToCart={addToCart} />)}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory }) {
//   const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#fff' }}>
//       <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontFamily: "'Lora', serif", fontWeight: 700 }}>
//         Complete Collection
//       </h2>
//       <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '3rem', flexWrap: 'wrap' }}>
//         <FilterButton active={selectedCategory === 'all'} onClick={() => setSelectedCategory('all')}>All Products</FilterButton>
//         <FilterButton active={selectedCategory === 'books'} onClick={() => setSelectedCategory('books')}>Books</FilterButton>
//         <FilterButton active={selectedCategory === 'accessories'} onClick={() => setSelectedCategory('accessories')}>Accessories</FilterButton>
//       </div>
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
//         {filteredProducts.map(product => <ProductCard key={product.id} product={product} addToCart={addToCart} />)}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#90C8FF' : 'transparent',
//         color: active ? '#222' : '#90C8FF',
//         border: '2px solid #90C8FF',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s'
//       }}
//       onMouseOver={e => !active && (e.target.style.backgroundColor = '#90C8FF', e.target.style.color = '#222')}
//       onMouseOut={e => !active && (e.target.style.backgroundColor = 'transparent', e.target.style.color = '#90C8FF')}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#f8f3ff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//         <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//           <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//         </div>
//         <div>
//           <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Lora', serif", fontWeight: 700 }}>
//             About the Author
//           </h3>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide.
//           </p>
//           <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//             With multiple bestselling novels to her name, she continues to captivate audiences with each new release.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Lora', serif",
//           fontWeight: 700,
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Author
//           <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#90C8FF' }} />
//         </h2>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
//           <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)' }}>
//             <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Author Musonda" style={{ width: '100%', height: 'auto' }} />
//           </div>
//           <div>
//             <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333', fontFamily: "'Lora', serif", fontWeight: 700 }}>Musonda</h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Musonda enjoys mentoring aspiring authors and exploring the outdoors for inspiration.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CheckoutPage({ cartItems, getTotalPrice }) {
//   const [formData, setFormData] = useState({
//     firstName: '', lastName: '', email: '', address: '', city: '', zipCode: '',
//     cardNumber: '', expiryDate: '', cvv: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleCheckout = (e) => {
//     e.preventDefault();
//     alert('Order placed successfully! Thank you for your purchase.');
//   };

//   return (
//     <section style={{ padding: '5rem 2rem', backgroundColor: '#fff' }}>
//       <div style={{ maxWidth: '800px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#333',
//           fontFamily: "'Lora', serif",
//           fontWeight: 700
//         }}>
//           Checkout
//         </h2>
//         <form onSubmit={handleCheckout} style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           padding: '2rem',
//           boxShadow: '0 6px 20px rgba(144, 200, 255, 0.2)'
//         }}>
//           <div style={{ backgroundColor: '#f8f3ff', borderRadius: '8px', padding: '1.5rem', margin: '2rem 0' }}>
//             <h3 style={{ fontSize: '1.3rem', marginBottom: '1rem', color: '#333', fontFamily: "'Lora', serif", fontWeight: 700 }}>Order Summary</h3>
//             {cartItems.map(item => (
//               <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem', paddingBottom: '0.8rem', borderBottom: '1px solid #eee' }}>
//                 <span>{item.title} (x{item.quantity})</span>
//                 <span style={{ fontWeight: 600 }}>${(item.price * item.quantity).toFixed(2)}</span>
//               </div>
//             ))}
//             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 700, marginTop: '1rem', paddingTop: '1rem', borderTop: '2px solid #B39DDB' }}>
//               <span>Total</span>
//               <span>${getTotalPrice()}</span>
//             </div>
//           </div>

//           <button
//             type="submit"
//             style={{
//               width: '100%',
//               backgroundColor: '#90C8FF',
//               color: '#222',
//               border: 'none',
//               padding: '1rem',
//               borderRadius: '8px',
//               fontSize: '1.1rem',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//             onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//           >
//             Place Order
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// }

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 20px rgba(0,0,0,0.15)',
//       transition: 'right 0.3s ease',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         backgroundColor: '#B39DDB',
//         color: '#fff'
//       }}>
//         <h3 style={{ fontSize: '1.5rem', fontWeight: 600, fontFamily: "'Lora', serif" }}>Your Cart</h3>
//         <button onClick={closeCart} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
//           <X size={24} />
//         </button>
//       </div>

//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '3rem 0' }}>Your cart is empty</p>
//         ) : (
//           cartItems.map(item => (
//             <div key={item.id} style={{ display: 'flex', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '1px solid #eee' }}>
//               <div style={{ width: '80px', height: '100px', marginRight: '1rem' }}>
//                 <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#333', fontFamily: "'Lora', serif" }}>{item.title}</h4>
//                 <p style={{ color: '#90C8FF', fontWeight: 600, marginBottom: '0.5rem' }}>${item.price}</p>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                   <button onClick={() => updateQuantity(item.id, item.quantity - 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Minus size={16} />
//                   </button>
//                   <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
//                   <button onClick={() => updateQuantity(item.id, item.quantity + 1)} style={{ width: '30px', height: '30px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Plus size={16} />
//                   </button>
//                   <button onClick={() => removeFromCart(item.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#999', cursor: 'pointer' }}>
//                     <Trash2 size={20} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {cartItems.length > 0 && (
//         <>
//           <div style={{ padding: '1.5rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem', fontWeight: 600, color: '#333' }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => { navigateTo('checkout'); closeCart(); }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#90C8FF',
//                 color: '#222',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={e => e.target.style.backgroundColor = '#7ab8ff'}
//               onMouseOut={e => e.target.style.backgroundColor = '#90C8FF'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#B39DDB',
//       color: '#fff',
//       padding: '4rem 2rem 2rem'
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
//         <div>
//           <h3 style={{
//             fontSize: '1.3rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Lora', serif",
//             fontWeight: 700,
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{ position: 'absolute', bottom: 0, left: 0, width: '40px', height: '3px', backgroundColor: '#90C8FF' }} />
//           </h3>
//           <p style={{ lineHeight: '1.6', opacity: 0.9 }}>
//             Discover captivating stories from award-winning author Musonda and explore our curated literary accessories.
//           </p>
//         </div>
//       </div>
//       <div style={{ textAlign: 'center', marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.2)', opacity: 0.8 }}>
//         <p>&copy; {new Date().getFullYear()} UPENDO STORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;

// import React, { useState } from 'react';
// import { ShoppingCart, X, Minus, Plus, Trash2, Book, Shirt, Coffee, Pen, Package } from 'lucide-react';

// // Sample book data
// const booksData = [
//   {
//     id: 1,
//     title: "The Silent Echo",
//     author: "Musonda",
//     price: 24.99,
//     image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A gripping mystery novel that will keep you on the edge of your seat until the very last page.",
//     category: "books",
//     type: "Mystery"
//   },
//   {
//     id: 2,
//     title: "Beyond the Horizon",
//     author: "Musonda",
//     price: 19.99,
//     image: "https://images.unsplash.com/photo-1532012197267-da84d127e765?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "An epic adventure that takes you to worlds beyond your imagination.",
//     category: "books",
//     type: "Adventure"
//   },
//   {
//     id: 3,
//     title: "Whispers of the Past",
//     author: "Musonda",
//     price: 22.99,
//     image: "https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A historical fiction that brings to life the untold stories of generations past.",
//     category: "books",
//     type: "Historical"
//   },
//   {
//     id: 4,
//     title: "Echoes of Tomorrow",
//     author: "Musonda",
//     price: 26.99,
//     image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "A sci-fi thriller that explores the boundaries of time and reality.",
//     category: "books",
//     type: "Sci-Fi"
//   }
// ];

// // Accessories data
// const accessoriesData = [
//   {
//     id: 101,
//     title: "Literary Quote T-Shirt",
//     author: "UPENDO STORE Collection",
//     price: 29.99,
//     image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Premium cotton t-shirt featuring iconic quotes from classic literature.",
//     category: "accessories",
//     type: "Apparel"
//   },
//   {
//     id: 102,
//     title: "Bookworm Tote Bag",
//     author: "UPENDO STORE Collection",
//     price: 18.99,
//     image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Spacious canvas tote bag perfect for carrying your favorite reads.",
//     category: "accessories",
//     type: "Bags"
//   },
//   {
//     id: 103,
//     title: "Classic Fountain Pen Set",
//     author: "UPENDO STORE Collection",
//     price: 45.99,
//     image: "https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Elegant fountain pen set for the discerning writer and note-taker.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 104,
//     title: "Reader's Ceramic Mug",
//     author: "UPENDO STORE Collection",
//     price: 16.99,
//     image: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Beautiful ceramic mug with literary-inspired designs, perfect for tea or coffee.",
//     category: "accessories",
//     type: "Drinkware"
//   },
//   {
//     id: 105,
//     title: "Vintage Bookmark Set",
//     author: "UPENDO STORE Collection",
//     price: 12.99,
//     image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Set of 5 elegant metal bookmarks with classic literary motifs.",
//     category: "accessories",
//     type: "Stationery"
//   },
//   {
//     id: 106,
//     title: "Author's Notebook",
//     author: "UPENDO STORE Collection",
//     price: 19.99,
//     image: "https://images.unsplash.com/photo-1531346878377-a5be20888e57?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//     description: "Leather-bound journal for capturing your thoughts and stories.",
//     category: "accessories",
//     type: "Stationery"
//   }
// ];

// const allProducts = [...booksData, ...accessoriesData];

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const addToCart = (product) => {
//     setCartItems(prevItems => {
//       const existingItem = prevItems.find(item => item.id === product.id);
//       if (existingItem) {
//         return prevItems.map(item => 
//           item.id === product.id 
//             ? { ...item, quantity: item.quantity + 1 } 
//             : item
//         );
//       } else {
//         return [...prevItems, { ...product, quantity: 1 }];
//       }
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(id);
//       return;
//     }
//     setCartItems(prevItems => 
//       prevItems.map(item => 
//         item.id === id ? { ...item, quantity: newQuantity } : item
//       )
//     );
//   };

//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//   };

//   const getCartItemsCount = () => {
//     return cartItems.reduce((count, item) => count + item.quantity, 0);
//   };

//   const navigateTo = (page) => {
//     setCurrentPage(page);
//     setMobileMenuOpen(false);
//   };

//   const renderPage = () => {
//     switch(currentPage) {
//       case 'home':
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//       case 'books':
//         return <ShopPage products={booksData} addToCart={addToCart} title="Books Collection" />;
//       case 'accessories':
//         return <ShopPage products={accessoriesData} addToCart={addToCart} title="Accessories Collection" />;
//       case 'shop':
//         return <AllShopPage 
//           products={allProducts} 
//           addToCart={addToCart} 
//           selectedCategory={selectedCategory}
//           setSelectedCategory={setSelectedCategory}
//         />;
//       case 'about':
//         return <AboutPage />;
//       case 'checkout':
//         return <CheckoutPage cartItems={cartItems} getTotalPrice={getTotalPrice} />;
//       default:
//         return <HomePage addToCart={addToCart} navigateTo={navigateTo} />;
//     }
//   };

//   return (
//     <div style={{ fontFamily: "'Crimson Text', 'Georgia', serif", minHeight: '100vh', backgroundColor: '#faf8f5' }}>
//       <Header 
//         currentPage={currentPage} 
//         navigateTo={navigateTo}
//         cartItemsCount={getCartItemsCount()}
//         openCart={() => setIsCartOpen(true)}
//         mobileMenuOpen={mobileMenuOpen}
//         setMobileMenuOpen={setMobileMenuOpen}
//       />
//       <main>
//         {renderPage()}
//       </main>
//       <Footer navigateTo={navigateTo} />
//       <CartModal 
//         isOpen={isCartOpen} 
//         closeCart={() => setIsCartOpen(false)}
//         cartItems={cartItems}
//         updateQuantity={updateQuantity}
//         removeFromCart={removeFromCart}
//         getTotalPrice={getTotalPrice}
//         navigateTo={navigateTo}
//       />
//       {isCartOpen && (
//         <div 
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             zIndex: 999
//           }}
//           onClick={() => setIsCartOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//   return (
//     <header style={{
//       backgroundColor: '#2c3e50',
//       boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//       position: 'sticky',
//       top: 0,
//       zIndex: 100
//     }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           padding: '1rem 0'
//         }}>
//           <div style={{
//             fontSize: '1.8rem',
//             fontWeight: 700,
//             color: '#ecf0f1',
//             fontFamily: "'Playfair Display', serif",
//             cursor: 'pointer'
//           }} onClick={() => navigateTo('home')}>
//             UPENDO<span style={{ color: '#3498db' }}></span>
//             {/* Upendo<span style={{ color: '#3498db' }}>Books</span> */}
//           </div>
          
//           <nav style={{
//             display: mobileMenuOpen ? 'flex' : 'none',
//             position: 'absolute',
//             top: '70px',
//             left: 0,
//             right: 0,
//             backgroundColor: '#2c3e50',
//             flexDirection: 'column',
//             padding: '2rem',
//             '@media (min-width: 768px)': {
//               display: 'flex',
//               position: 'static',
//               flexDirection: 'row',
//               padding: 0
//             }
//           }}
//           className="nav-menu"
//           >
//             <NavItem active={currentPage === 'home'} onClick={() => navigateTo('home')}>Home</NavItem>
//             <NavItem active={currentPage === 'books'} onClick={() => navigateTo('books')}>Books</NavItem>
//             <NavItem active={currentPage === 'accessories'} onClick={() => navigateTo('accessories')}>Accessories</NavItem>
//             <NavItem active={currentPage === 'shop'} onClick={() => navigateTo('shop')}>All Shop</NavItem>
//             <NavItem active={currentPage === 'about'} onClick={() => navigateTo('about')}>About</NavItem>
//             <button
//               onClick={openCart}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 color: '#ecf0f1',
//                 cursor: 'pointer',
//                 marginLeft: '2rem',
//                 position: 'relative',
//                 fontSize: '1.2rem',
//                 padding: '0.5rem'
//               }}
//             >
//               <ShoppingCart size={24} />
//               {cartItemsCount > 0 && (
//                 <span style={{
//                   position: 'absolute',
//                   top: '-5px',
//                   right: '-5px',
//                   backgroundColor: '#e74c3c',
//                   color: 'white',
//                   borderRadius: '50%',
//                   width: '20px',
//                   height: '20px',
//                   fontSize: '0.7rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 'bold'
//                 }}>
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           <button
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               display: 'block',
//               background: 'none',
//               border: 'none',
//               color: '#ecf0f1',
//               fontSize: '1.5rem',
//               cursor: 'pointer',
//               '@media (min-width: 768px)': { display: 'none' }
//             }}
//             className="mobile-menu-btn"
//           >
//             {mobileMenuOpen ? <X size={28} /> : '☰'}
//           </button>
//         </div>
//       </div>
      
//       <style>{`
//         @media (min-width: 768px) {
//           .nav-menu {
//             display: flex !important;
//             position: static !important;
//             flex-direction: row !important;
//             padding: 0 !important;
//             background: transparent !important;
//           }
//           .mobile-menu-btn {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }

// function NavItem({ active, onClick, children }) {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         marginLeft: '2rem',
//         fontWeight: 600,
//         color: active ? '#3498db' : '#ecf0f1',
//         cursor: 'pointer',
//         position: 'relative',
//         padding: '0.5rem 0',
//         transition: 'color 0.3s',
//         borderBottom: active ? '3px solid #3498db' : 'none',
//         fontFamily: "'Lato', sans-serif"
//       }}
//     >
//       {children}
//     </div>
//   );
// }

// function HomePage({ addToCart, navigateTo }) {
//   const featuredBooks = booksData.slice(0, 3);
//   const featuredAccessories = accessoriesData.slice(0, 3);

//   return (
//     <>
//       <section style={{
//         background: 'linear-gradient(rgba(44, 62, 80, 0.85), rgba(44, 62, 80, 0.85)), url(https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80)',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         color: 'white',
//         textAlign: 'center',
//         padding: '8rem 2rem'
//       }}>
//         <h1 style={{
//           fontSize: '3.5rem',
//           marginBottom: '1rem',
//           fontFamily: "'Playfair Display', serif",
//           fontWeight: 700
//         }}>
//           Discover Captivating Stories
//         </h1>
//         <p style={{
//           fontSize: '1.5rem',
//           marginBottom: '2rem',
//           opacity: 0.9,
//           fontFamily: "'Lato', sans-serif"
//         }}>
//           Explore the literary world of bestselling author Musonda
//         </p>
//         <button
//           onClick={() => navigateTo('shop')}
//           style={{
//             backgroundColor: '#3498db',
//             color: 'white',
//             border: 'none',
//             padding: '1rem 2.5rem',
//             fontSize: '1.1rem',
//             fontWeight: 600,
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             fontFamily: "'Lato', sans-serif"
//           }}
//           onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
//           onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
//         >
//           Browse Collection
//         </button>
//       </section>

//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Featured Books
//           <div style={{
//             position: 'absolute',
//             bottom: 0,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             width: '80px',
//             height: '4px',
//             backgroundColor: '#3498db'
//           }} />
//         </h2>
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//           gap: '2rem',
//           marginBottom: '3rem'
//         }}>
//           {featuredBooks.map(book => (
//             <ProductCard key={book.id} product={book} addToCart={addToCart} />
//           ))}
//         </div>
//         <div style={{ textAlign: 'center' }}>
//           <button
//             onClick={() => navigateTo('books')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#3498db',
//               border: '2px solid #3498db',
//               padding: '0.8rem 2rem',
//               fontSize: '1rem',
//               fontWeight: 600,
//               borderRadius: '8px',
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => {
//               e.target.style.backgroundColor = '#3498db';
//               e.target.style.color = 'white';
//             }}
//             onMouseOut={(e) => {
//               e.target.style.backgroundColor = 'transparent';
//               e.target.style.color = '#3498db';
//             }}
//           >
//             View All Books
//           </button>
//         </div>
//       </section>

//       <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#ecf0f1' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           Literary Accessories
//           <div style={{
//             position: 'absolute',
//             bottom: 0,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             width: '80px',
//             height: '4px',
//             backgroundColor: '#3498db'
//           }} />
//         </h2>
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//           gap: '2rem',
//           marginBottom: '3rem'
//         }}>
//           {featuredAccessories.map(accessory => (
//             <ProductCard key={accessory.id} product={accessory} addToCart={addToCart} />
//           ))}
//         </div>
//         <div style={{ textAlign: 'center' }}>
//           <button
//             onClick={() => navigateTo('accessories')}
//             style={{
//               backgroundColor: 'transparent',
//               color: '#3498db',
//               border: '2px solid #3498db',
//               padding: '0.8rem 2rem',
//               fontSize: '1rem',
//               fontWeight: 600,
//               borderRadius: '8px',
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => {
//               e.target.style.backgroundColor = '#3498db';
//               e.target.style.color = 'white';
//             }}
//             onMouseOut={(e) => {
//               e.target.style.backgroundColor = 'transparent';
//               e.target.style.color = '#3498db';
//             }}
//           >
//             View All Accessories
//           </button>
//         </div>
//       </section>

//       <AboutPreview navigateTo={navigateTo} />
//     </>
//   );
// }

// function ProductCard({ product, addToCart }) {
//   return (
//     <div style={{
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       overflow: 'hidden',
//       boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//       transition: 'all 0.3s',
//       cursor: 'pointer'
//     }}
//     onMouseOver={(e) => {
//       e.currentTarget.style.transform = 'translateY(-5px)';
//       e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)';
//     }}
//     onMouseOut={(e) => {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
//     }}
//     >
//       <div style={{ height: '300px', overflow: 'hidden' }}>
//         <img
//           src={product.image}
//           alt={product.title}
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             transition: 'transform 0.3s'
//           }}
//         />
//       </div>
//       <div style={{ padding: '1.5rem' }}>
//         <h3 style={{
//           fontSize: '1.2rem',
//           marginBottom: '0.5rem',
//           fontWeight: 600,
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif"
//         }}>
//           {product.title}
//         </h3>
//         <p style={{
//           color: '#777',
//           marginBottom: '0.5rem',
//           fontSize: '0.9rem'
//         }}>
//           {product.author}
//         </p>
//         <p style={{
//           fontSize: '1.3rem',
//           fontWeight: 700,
//           color: '#e74c3c',
//           marginBottom: '1rem'
//         }}>
//           ${product.price}
//         </p>
//         <div style={{
//           display: 'flex',
//           gap: '0.5rem'
//         }}>
//           <button
//             style={{
//               flex: 1,
//               backgroundColor: 'transparent',
//               color: '#3498db',
//               border: '2px solid #3498db',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => {
//               e.target.style.backgroundColor = '#3498db';
//               e.target.style.color = 'white';
//             }}
//             onMouseOut={(e) => {
//               e.target.style.backgroundColor = 'transparent';
//               e.target.style.color = '#3498db';
//             }}
//           >
//             View Details
//           </button>
//           <button
//             onClick={() => addToCart(product)}
//             style={{
//               flex: 1,
//               backgroundColor: '#3498db',
//               color: 'white',
//               border: 'none',
//               padding: '0.6rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
//           >
//             Add to Cart
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function ShopPage({ products, addToCart, title }) {
//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '3rem',
//         color: '#2c3e50',
//         fontFamily: "'Playfair Display', serif",
//         position: 'relative',
//         paddingBottom: '1rem'
//       }}>
//         {title}
//         <div style={{
//           position: 'absolute',
//           bottom: 0,
//           left: '50%',
//           transform: 'translateX(-50%)',
//           width: '80px',
//           height: '4px',
//           backgroundColor: '#3498db'
//         }} />
//       </h2>
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//         gap: '2rem'
//       }}>
//         {products.map(product => (
//           <ProductCard key={product.id} product={product} addToCart={addToCart} />
//         ))}
//       </div>
//     </section>
//   );
// }

// function AllShopPage({ products, addToCart, selectedCategory, setSelectedCategory }) {
//   const filteredProducts = selectedCategory === 'all' 
//     ? products 
//     : products.filter(p => p.category === selectedCategory);

//   return (
//     <section style={{ padding: '5rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
//       <h2 style={{
//         textAlign: 'center',
//         fontSize: '2.5rem',
//         marginBottom: '2rem',
//         color: '#2c3e50',
//         fontFamily: "'Playfair Display', serif"
//       }}>
//         Complete Collection
//       </h2>
      
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '1rem',
//         marginBottom: '3rem',
//         flexWrap: 'wrap'
//       }}>
//         <FilterButton 
//           active={selectedCategory === 'all'} 
//           onClick={() => setSelectedCategory('all')}
//         >
//           All Products
//         </FilterButton>
//         <FilterButton 
//           active={selectedCategory === 'books'} 
//           onClick={() => setSelectedCategory('books')}
//         >
//           Books
//         </FilterButton>
//         <FilterButton 
//           active={selectedCategory === 'accessories'} 
//           onClick={() => setSelectedCategory('accessories')}
//         >
//           Accessories
//         </FilterButton>
//       </div>

//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//         gap: '2rem'
//       }}>
//         {filteredProducts.map(product => (
//           <ProductCard key={product.id} product={product} addToCart={addToCart} />
//         ))}
//       </div>
//     </section>
//   );
// }

// function FilterButton({ active, onClick, children }) {
//   return (
//     <button
//       onClick={onClick}
//       style={{
//         backgroundColor: active ? '#3498db' : 'transparent',
//         color: active ? 'white' : '#3498db',
//         border: '2px solid #3498db',
//         padding: '0.7rem 1.5rem',
//         borderRadius: '8px',
//         fontWeight: 600,
//         cursor: 'pointer',
//         transition: 'all 0.3s',
//         fontSize: '1rem'
//       }}
//       onMouseOver={(e) => {
//         if (!active) {
//           e.target.style.backgroundColor = '#3498db';
//           e.target.style.color = 'white';
//         }
//       }}
//       onMouseOut={(e) => {
//         if (!active) {
//           e.target.style.backgroundColor = 'transparent';
//           e.target.style.color = '#3498db';
//         }
//       }}
//     >
//       {children}
//     </button>
//   );
// }

// function AboutPreview({ navigateTo }) {
//   return (
//     <section style={{
//       padding: '5rem 2rem',
//       backgroundColor: '#ecf0f1'
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//         gap: '3rem',
//         alignItems: 'center'
//       }}>
//         <div style={{
//           borderRadius: '8px',
//           overflow: 'hidden',
//           boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
//         }}>
//           <img
//             src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
//             alt="Author Musonda"
//             style={{ width: '100%', height: 'auto' }}
//           />
//         </div>
//         <div>
//           <h3 style={{
//             fontSize: '2rem',
//             marginBottom: '1.5rem',
//             color: '#2c3e50',
//             fontFamily: "'Playfair Display', serif"
//           }}>
//             About the Author
//           </h3>
//           <p style={{
//             marginBottom: '1.5rem',
//             lineHeight: '1.8',
//             color: '#555'
//           }}>
//             Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide. Her unique storytelling style blends rich character development with intricate plots.
//           </p>
//           <p style={{
//             marginBottom: '1.5rem',
//             lineHeight: '1.8',
//             color: '#555'
//           }}>
//             With multiple bestselling novels to her name, Jane continues to captivate audiences with each new release. Her works have been translated into 15 languages and have sold millions of copies globally.
//           </p>
//           <button
//             onClick={() => navigateTo('about')}
//             style={{
//               backgroundColor: '#3498db',
//               color: 'white',
//               border: 'none',
//               padding: '0.8rem 2rem',
//               borderRadius: '8px',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
//           >
//             Read More
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutPage() {
//   return (
//     <section style={{ padding: '5rem 2rem' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif",
//           position: 'relative',
//           paddingBottom: '1rem'
//         }}>
//           About the Author
//           <div style={{
//             position: 'absolute',
//             bottom: 0,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             width: '80px',
//             height: '4px',
//             backgroundColor: '#3498db'
//           }} />
//         </h2>
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//           gap: '3rem',
//           alignItems: 'center'
//         }}>
//           <div style={{
//             borderRadius: '8px',
//             overflow: 'hidden',
//             boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
//           }}>
//             <img
//               src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
//               alt="Author Musonda"
//               style={{ width: '100%', height: 'auto' }}
//             />
//           </div>
//           <div>
//             <h3 style={{
//               fontSize: '2rem',
//               marginBottom: '1.5rem',
//               color: '#2c3e50',
//               fontFamily: "'Playfair Display', serif"
//             }}>
//               Musonda
//             </h3>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters. With a background in literature and creative writing, Jane has dedicated her career to creating immersive literary experiences for readers around the world.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction. Since then, she has published several critically acclaimed works that have been praised for their emotional depth and narrative complexity.
//             </p>
//             <p style={{ marginBottom: '1.5rem', lineHeight: '1.8', color: '#555' }}>
//               When she's not writing, Jane enjoys mentoring aspiring authors, participating in literary festivals, and exploring the great outdoors for inspiration. She lives with her family in a quiet countryside home where she finds the peace necessary for her creative process.
//             </p>
//             <h4 style={{
//               fontSize: '1.5rem',
//               marginTop: '2rem',
//               marginBottom: '1rem',
//               color: '#2c3e50',
//               fontFamily: "'Playfair Display', serif"
//             }}>
//               Awards and Recognition
//             </h4>
//             <ul style={{
//               listStyle: 'disc',
//               paddingLeft: '2rem',
//               color: '#555',
//               lineHeight: '2'
//             }}>
//               <li>National Book Award for Fiction (2020)</li>
//               <li>Reader's Choice Award for Best Novel (2019, 2021)</li>
//               <li>Literary Excellence Medal (2018)</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function CheckoutPage({ cartItems, getTotalPrice }) {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     address: '',
//     city: '',
//     zipCode: '',
//     cardNumber: '',
//     expiryDate: '',
//     cvv: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevData => ({
//       ...prevData,
//       [name]: value
//     }));
//   };

//   const handleCheckout = (e) => {
//     e.preventDefault();
//     alert('Order placed successfully! Thank you for your purchase.');
//   };

//   return (
//     <section style={{ padding: '5rem 2rem' }}>
//       <div style={{ maxWidth: '800px', margin: '0 auto' }}>
//         <h2 style={{
//           textAlign: 'center',
//           fontSize: '2.5rem',
//           marginBottom: '3rem',
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif"
//         }}>
//           Checkout
//         </h2>
//         <form onSubmit={handleCheckout} style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           padding: '2rem',
//           boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
//         }}>
//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             color: '#2c3e50',
//             fontFamily: "'Playfair Display', serif"
//           }}>
//             Shipping Information
//           </h3>
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 First Name
//               </label>
//               <input
//                 type="text"
//                 name="firstName"
//                 value={formData.firstName}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 Last Name
//               </label>
//               <input
//                 type="text"
//                 name="lastName"
//                 value={formData.lastName}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//           </div>
//           <div style={{ marginBottom: '1.5rem' }}>
//             <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//               Email
//             </label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleInputChange}
//               required
//               style={{
//                 width: '100%',
//                 padding: '0.8rem',
//                 border: '1px solid #ddd',
//                 borderRadius: '8px',
//                 fontSize: '1rem'
//               }}
//             />
//           </div>
//           <div style={{ marginBottom: '1.5rem' }}>
//             <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//               Address
//             </label>
//             <input
//               type="text"
//               name="address"
//               value={formData.address}
//               onChange={handleInputChange}
//               required
//               style={{
//                 width: '100%',
//                 padding: '0.8rem',
//                 border: '1px solid #ddd',
//                 borderRadius: '8px',
//                 fontSize: '1rem'
//               }}
//             />
//           </div>
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '2rem' }}>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 City
//               </label>
//               <input
//                 type="text"
//                 name="city"
//                 value={formData.city}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 ZIP Code
//               </label>
//               <input
//                 type="text"
//                 name="zipCode"
//                 value={formData.zipCode}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//           </div>

//           <h3 style={{
//             fontSize: '1.5rem',
//             marginBottom: '1.5rem',
//             color: '#2c3e50',
//             fontFamily: "'Playfair Display', serif"
//           }}>
//             Payment Information
//           </h3>
//           <div style={{ marginBottom: '1.5rem' }}>
//             <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//               Card Number
//             </label>
//             <input
//               type="text"
//               name="cardNumber"
//               value={formData.cardNumber}
//               onChange={handleInputChange}
//               required
//               style={{
//                 width: '100%',
//                 padding: '0.8rem',
//                 border: '1px solid #ddd',
//                 borderRadius: '8px',
//                 fontSize: '1rem'
//               }}
//             />
//           </div>
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '2rem' }}>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 Expiry Date
//               </label>
//               <input
//                 type="text"
//                 name="expiryDate"
//                 placeholder="MM/YY"
//                 value={formData.expiryDate}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//             <div>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: '#2c3e50' }}>
//                 CVV
//               </label>
//               <input
//                 type="text"
//                 name="cvv"
//                 value={formData.cvv}
//                 onChange={handleInputChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.8rem',
//                   border: '1px solid #ddd',
//                   borderRadius: '8px',
//                   fontSize: '1rem'
//                 }}
//               />
//             </div>
//           </div>

//           <div style={{
//             backgroundColor: '#f9f9f9',
//             borderRadius: '8px',
//             padding: '1.5rem',
//             marginBottom: '2rem'
//           }}>
//             <h3 style={{
//               fontSize: '1.3rem',
//               marginBottom: '1rem',
//               color: '#2c3e50',
//               fontFamily: "'Playfair Display', serif"
//             }}>
//               Order Summary
//             </h3>
//             {cartItems.map(item => (
//               <div key={item.id} style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 marginBottom: '0.8rem',
//                 paddingBottom: '0.8rem',
//                 borderBottom: '1px solid #eee'
//               }}>
//                 <span>{item.title} (x{item.quantity})</span>
//                 <span style={{ fontWeight: 600 }}>${(item.price * item.quantity).toFixed(2)}</span>
//               </div>
//             ))}
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               fontSize: '1.2rem',
//               fontWeight: 700,
//               marginTop: '1rem',
//               paddingTop: '1rem',
//               borderTop: '2px solid #ddd',
//               color: '#2c3e50'
//             }}>
//               <span>Total</span>
//               <span>${getTotalPrice()}</span>
//             </div>
//           </div>

//           <button
//             type="submit"
//             style={{
//               width: '100%',
//               backgroundColor: '#3498db',
//               color: 'white',
//               border: 'none',
//               padding: '1rem',
//               borderRadius: '8px',
//               fontSize: '1.1rem',
//               fontWeight: 600,
//               cursor: 'pointer',
//               transition: 'all 0.3s'
//             }}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
//           >
//             Place Order
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// }

// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       right: isOpen ? 0 : '-100%',
//       width: '100%',
//       maxWidth: '400px',
//       height: '100%',
//       backgroundColor: 'white',
//       boxShadow: '-5px 0 15px rgba(0,0,0,0.1)',
//       transition: 'right 0.3s',
//       zIndex: 1000,
//       overflowY: 'auto'
//     }}>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '1.5rem',
//         borderBottom: '1px solid #eee'
//       }}>
//         <h3 style={{
//           fontSize: '1.5rem',
//           fontWeight: 600,
//           color: '#2c3e50',
//           fontFamily: "'Playfair Display', serif"
//         }}>
//           Your Cart
//         </h3>
//         <button
//           onClick={closeCart}
//           style={{
//             background: 'none',
//             border: 'none',
//             fontSize: '1.5rem',
//             color: '#777',
//             cursor: 'pointer'
//           }}
//         >
//           <X size={24} />
//         </button>
//       </div>
      
//       <div style={{ padding: '1.5rem' }}>
//         {cartItems.length === 0 ? (
//           <p style={{ textAlign: 'center', color: '#777', margin: '2rem 0' }}>
//             Your cart is empty
//           </p>
//         ) : (
//           <>
//             {cartItems.map(item => (
//               <div key={item.id} style={{
//                 display: 'flex',
//                 marginBottom: '1.5rem',
//                 paddingBottom: '1.5rem',
//                 borderBottom: '1px solid #eee'
//               }}>
//                 <div style={{
//                   width: '80px',
//                   height: '100px',
//                   marginRight: '1rem'
//                 }}>
//                   <img
//                     src={item.image}
//                     alt={item.title}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                       borderRadius: '4px'
//                     }}
//                   />
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <h4 style={{
//                     fontWeight: 600,
//                     marginBottom: '0.5rem',
//                     fontSize: '1rem',
//                     color: '#2c3e50'
//                   }}>
//                     {item.title}
//                   </h4>
//                   <p style={{
//                     color: '#e74c3c',
//                     fontWeight: 600,
//                     marginBottom: '0.5rem'
//                   }}>
//                     ${item.price}
//                   </p>
//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '0.5rem'
//                   }}>
//                     <button
//                       onClick={() => updateQuantity(item.id, item.quantity - 1)}
//                       style={{
//                         width: '30px',
//                         height: '30px',
//                         backgroundColor: '#f0f0f0',
//                         border: 'none',
//                         borderRadius: '50%',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <Minus size={16} />
//                     </button>
//                     <span style={{ fontWeight: 600, minWidth: '30px', textAlign: 'center' }}>
//                       {item.quantity}
//                     </span>
//                     <button
//                       onClick={() => updateQuantity(item.id, item.quantity + 1)}
//                       style={{
//                         width: '30px',
//                         height: '30px',
//                         backgroundColor: '#f0f0f0',
//                         border: 'none',
//                         borderRadius: '50%',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <Plus size={16} />
//                     </button>
//                     <button
//                       onClick={() => removeFromCart(item.id)}
//                       style={{
//                         marginLeft: 'auto',
//                         background: 'none',
//                         border: 'none',
//                         color: '#777',
//                         cursor: 'pointer'
//                       }}
//                     >
//                       <Trash2 size={20} />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </>
//         )}
//       </div>
      
//       {cartItems.length > 0 && (
//         <>
//           <div style={{
//             padding: '1.5rem',
//             borderTop: '1px solid #eee',
//             display: 'flex',
//             justifyContent: 'space-between',
//             fontSize: '1.2rem',
//             fontWeight: 600,
//             color: '#2c3e50'
//           }}>
//             <span>Total:</span>
//             <span>${getTotalPrice()}</span>
//           </div>
//           <div style={{ padding: '0 1.5rem 1.5rem' }}>
//             <button
//               onClick={() => {
//                 navigateTo('checkout');
//                 closeCart();
//               }}
//               style={{
//                 width: '100%',
//                 backgroundColor: '#3498db',
//                 color: 'white',
//                 border: 'none',
//                 padding: '1rem',
//                 borderRadius: '8px',
//                 fontSize: '1.1rem',
//                 fontWeight: 600,
//                 cursor: 'pointer',
//                 transition: 'all 0.3s'
//               }}
//               onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
//               onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function Footer({ navigateTo }) {
//   return (
//     <footer style={{
//       backgroundColor: '#2c3e50',
//       color: 'white',
//       padding: '4rem 2rem 2rem'
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//         gap: '2rem'
//       }}>
//         <div>
//           <h3 style={{
//             fontSize: '1.3rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Playfair Display', serif",
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             UPENDO STORE
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#3498db'
//             }} />
//           </h3>
//           <p style={{ marginBottom: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
//             Discover captivating stories from award-winning author Musonda. Explore literary works and accessories that celebrate the world of books.
//           </p>
//           <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
//             {['F', 'T', 'I', 'G'].map((letter, i) => (
//               <a
//                 key={i}
//                 href="#"
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   width: '40px',
//                   height: '40px',
//                   backgroundColor: 'rgba(255,255,255,0.1)',
//                   borderRadius: '50%',
//                   transition: 'all 0.3s',
//                   color: 'white'
//                 }}
//                 onMouseOver={(e) => {
//                   e.target.style.backgroundColor = '#3498db';
//                   e.target.style.transform = 'translateY(-3px)';
//                 }}
//                 onMouseOut={(e) => {
//                   e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
//                   e.target.style.transform = 'translateY(0)';
//                 }}
//               >
//                 {letter}
//               </a>
//             ))}
//           </div>
//         </div>
        
//         <div>
//           <h3 style={{
//             fontSize: '1.3rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Playfair Display', serif",
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Quick Links
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#3498db'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none' }}>
//             {[
//               { text: 'Home', page: 'home' },
//               { text: 'Books', page: 'books' },
//               { text: 'Accessories', page: 'accessories' },
//               { text: 'About', page: 'about' }
//             ].map((link, i) => (
//               <li key={i} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigateTo(link.page);
//                   }}
//                   style={{
//                     color: 'white',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={(e) => {
//                     e.target.style.color = '#3498db';
//                     e.target.style.paddingLeft = '5px';
//                   }}
//                   onMouseOut={(e) => {
//                     e.target.style.color = 'white';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {link.text}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
        
//         <div>
//           <h3 style={{
//             fontSize: '1.3rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Playfair Display', serif",
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Customer Service
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#3498db'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none' }}>
//             {['Shipping Info', 'Returns', 'Privacy Policy', 'Terms of Service', 'FAQ'].map((item, i) => (
//               <li key={i} style={{ marginBottom: '0.8rem' }}>
//                 <a
//                   href="#"
//                   style={{
//                     color: 'white',
//                     transition: 'all 0.3s',
//                     display: 'inline-block'
//                   }}
//                   onMouseOver={(e) => {
//                     e.target.style.color = '#3498db';
//                     e.target.style.paddingLeft = '5px';
//                   }}
//                   onMouseOut={(e) => {
//                     e.target.style.color = 'white';
//                     e.target.style.paddingLeft = '0';
//                   }}
//                 >
//                   {item}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
        
//         <div>
//           <h3 style={{
//             fontSize: '1.3rem',
//             marginBottom: '1.5rem',
//             fontFamily: "'Playfair Display', serif",
//             position: 'relative',
//             paddingBottom: '0.5rem'
//           }}>
//             Contact
//             <div style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: '40px',
//               height: '3px',
//               backgroundColor: '#3498db'
//             }} />
//           </h3>
//           <ul style={{ listStyle: 'none' }}>
//             <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//               📍 123 Book Street, Literary City
//             </li>
//             <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//               📞 (123) 456-7890
//             </li>
//             <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//               ✉️ info@UPENDO STORE.com
//             </li>
//           </ul>
//         </div>
//       </div>
      
//       <div style={{
//         textAlign: 'center',
//         marginTop: '3rem',
//         paddingTop: '2rem',
//         borderTop: '1px solid rgba(255,255,255,0.1)',
//         opacity: 0.8
//       }}>
//         <p>&copy; {new Date().getFullYear()} UPENDO STORE. All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default App;
// import React, { useState } from 'react';
// import './App.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faShoppingCart, faTimes, faBars, faMinus, faPlus, faTrash, faMapMarkerAlt, faPhone, faEnvelope, faFacebookF, faTwitter, faInstagram, faGoodreads } from '@fortawesome/free-solid-svg-icons';
// import { faFacebookF as fabFacebookF, faTwitter as fabTwitter, faInstagram as fabInstagram, faGoodreads as fabGoodreads } from '@fortawesome/free-brands-svg-icons';

// // Sample book data
// const booksData = [
//     {
//         id: 1,
//         title: "The Silent Echo",
//         author: "Musonda",
//         price: 24.99,
//         image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//         description: "A gripping mystery novel that will keep you on the edge of your seat until the very last page."
//     },
//     {
//         id: 2,
//         title: "Beyond the Horizon",
//         author: "Musonda",
//         price: 19.99,
//         image: "https://images.unsplash.com/photo-1532012197267-da84d127e765?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//         description: "An epic adventure that takes you to worlds beyond your imagination."
//     },
//     {
//         id: 3,
//         title: "Whispers of the Past",
//         author: "Musonda",
//         price: 22.99,
//         image: "https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//         description: "A historical fiction that brings to life the untold stories of generations past."
//     },
//     {
//         id: 4,
//         title: "Echoes of Tomorrow",
//         author: "Musonda",
//         price: 26.99,
//         image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
//         description: "A sci-fi thriller that explores the boundaries of time and reality."
//     }
// ];

// // Main App Component
// function App() {
//     const [currentPage, setCurrentPage] = useState('home');
//     const [cartItems, setCartItems] = useState([]);
//     const [isCartOpen, setIsCartOpen] = useState(false);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//     // Add to cart function
//     const addToCart = (book) => {
//         setCartItems(prevItems => {
//             const existingItem = prevItems.find(item => item.id === book.id);
//             if (existingItem) {
//                 return prevItems.map(item => 
//                     item.id === book.id 
//                         ? { ...item, quantity: item.quantity + 1 } 
//                         : item
//                 );
//             } else {
//                 return [...prevItems, { ...book, quantity: 1 }];
//             }
//         });
//     };

//     // Remove from cart function
//     const removeFromCart = (id) => {
//         setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//     };

//     // Update quantity function
//     const updateQuantity = (id, newQuantity) => {
//         if (newQuantity < 1) {
//             removeFromCart(id);
//             return;
//         }
        
//         setCartItems(prevItems => 
//             prevItems.map(item => 
//                 item.id === id ? { ...item, quantity: newQuantity } : item
//             )
//         );
//     };

//     // Calculate total price
//     const getTotalPrice = () => {
//         return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
//     };

//     // Get cart items count
//     const getCartItemsCount = () => {
//         return cartItems.reduce((count, item) => count + item.quantity, 0);
//     };

//     // Navigation function
//     const navigateTo = (page) => {
//         setCurrentPage(page);
//         setMobileMenuOpen(false);
//     };

//     // Render current page
//     const renderPage = () => {
//         switch(currentPage) {
//             case 'home':
//                 return <HomePage books={booksData} addToCart={addToCart} />;
//             case 'books':
//                 return <BooksPage books={booksData} addToCart={addToCart} />;
//             case 'about':
//                 return <AboutPage />;
//             case 'checkout':
//                 return <CheckoutPage cartItems={cartItems} getTotalPrice={getTotalPrice} />;
//             default:
//                 return <HomePage books={booksData} addToCart={addToCart} />;
//         }
//     };

//     return (
//         <div className="App">
//             <Header 
//                 currentPage={currentPage} 
//                 navigateTo={navigateTo}
//                 cartItemsCount={getCartItemsCount()}
//                 openCart={() => setIsCartOpen(true)}
//                 mobileMenuOpen={mobileMenuOpen}
//                 setMobileMenuOpen={setMobileMenuOpen}
//             />
//             <main>
//                 {renderPage()}
//             </main>
//             <Footer navigateTo={navigateTo} />
//             <CartModal 
//                 isOpen={isCartOpen} 
//                 closeCart={() => setIsCartOpen(false)}
//                 cartItems={cartItems}
//                 updateQuantity={updateQuantity}
//                 removeFromCart={removeFromCart}
//                 getTotalPrice={getTotalPrice}
//                 navigateTo={navigateTo}
//             />
//             <div className={`overlay ${isCartOpen ? 'active' : ''}`} onClick={() => setIsCartOpen(false)}></div>
//         </div>
//     );
// }

// // Header Component
// function Header({ currentPage, navigateTo, cartItemsCount, openCart, mobileMenuOpen, setMobileMenuOpen }) {
//     return (
//         <header className="header">
//             <div className="container">
//                 <div className="header-content">
//                     <div className="logo">Author<span>Books</span></div>
//                     <nav className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
//                         <div className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}>
//                             <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }}>Home</a>
//                         </div>
//                         <div className={`nav-item ${currentPage === 'books' ? 'active' : ''}`}>
//                             <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('books'); }}>Books</a>
//                         </div>
//                         <div className={`nav-item ${currentPage === 'about' ? 'active' : ''}`}>
//                             <a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>About</a>
//                         </div>
//                         <div className="nav-item cart-icon">
//                             <a href="#" onClick={(e) => { e.preventDefault(); openCart(); }}>
//                                 <FontAwesomeIcon icon={faShoppingCart} />
//                                 {cartItemsCount > 0 && <span className="cart-count">{cartItemsCount}</span>}
//                             </a>
//                         </div>
//                     </nav>
//                     <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
//                         <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
//                     </button>
//                 </div>
//             </div>
//         </header>
//     );
// }

// // Home Page Component
// function HomePage({ books, addToCart }) {
//     return (
//         <>
//             <section className="hero">
//                 <div className="container">
//                     <div className="hero-content">
//                         <h1 className="hero-title">Discover Captivating Stories</h1>
//                         <p className="hero-subtitle">Explore the literary world of bestselling author Musonda</p>
//                         <button className="btn btn-primary" onClick={() => window.scrollTo({ top: document.querySelector('.featured-books').offsetTop - 100, behavior: 'smooth' })}>Browse Books</button>
//                     </div>
//                 </div>
//             </section>

//             <section className="section featured-books">
//                 <div className="container">
//                     <h2 className="section-title">Featured Books</h2>
//                     <div className="books-grid">
//                         {books.map(book => (
//                             <BookCard key={book.id} book={book} addToCart={addToCart} />
//                         ))}
//                     </div>
//                 </div>
//             </section>

//             <AboutPreview />
//         </>
//     );
// }

// // Book Card Component
// function BookCard({ book, addToCart }) {
//     return (
//         <div className="book-card">
//             <div className="book-image">
//                 <img src={book.image} alt={book.title} />
//             </div>
//             <div className="book-info">
//                 <h3 className="book-title">{book.title}</h3>
//                 <p className="book-author">by {book.author}</p>
//                 <p className="book-price">${book.price}</p>
//                 <div className="book-actions">
//                     <button className="btn btn-outline">View Details</button>
//                     <button className="btn btn-primary" onClick={() => addToCart(book)}>Add to Cart</button>
//                 </div>
//             </div>
//         </div>
//     );
// }

// // About Preview Component
// function AboutPreview() {
//     return (
//         <section className="section about">
//             <div className="container">
//                 <div className="about-content">
//                     <div className="about-image">
//                         <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Author Musonda" />
//                     </div>
//                     <div className="about-text">
//                         <h3>About the Author</h3>
//                         <p>Musonda is an award-winning author with over a decade of experience in crafting compelling narratives that resonate with readers worldwide. Her unique storytelling style blends rich character development with intricate plots.</p>
//                         <p>With multiple bestselling novels to her name, Jane continues to captivate audiences with each new release. Her works have been translated into 15 languages and have sold millions of copies globally.</p>
//                         <button className="btn btn-primary">Read More</button>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }

// // Books Page Component
// function BooksPage({ books, addToCart }) {
//     return (
//         <section className="section">
//             <div className="container">
//                 <h2 className="section-title">All Books</h2>
//                 <div className="books-grid">
//                     {books.map(book => (
//                         <BookCard key={book.id} book={book} addToCart={addToCart} />
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// }

// // About Page Component
// function AboutPage() {
//     return (
//         <section className="section">
//             <div className="container">
//                 <h2 className="section-title">About the Author</h2>
//                 <div className="about-content">
//                     <div className="about-image">
//                         <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Author Musonda" />
//                     </div>
//                     <div className="about-text">
//                         <h3>Musonda</h3>
//                         <p>Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters. With a background in literature and creative writing, Jane has dedicated her career to creating immersive literary experiences for readers around the world.</p>
//                         <p>Her debut novel, "The Silent Echo," quickly became a bestseller and established her as a prominent voice in contemporary fiction. Since then, she has published several critically acclaimed works that have been praised for their emotional depth and narrative complexity.</p>
//                         <p>When she's not writing, Jane enjoys mentoring aspiring authors, participating in literary festivals, and exploring the great outdoors for inspiration. She lives with her family in a quiet countryside home where she finds the peace necessary for her creative process.</p>
//                         <h4>Awards and Recognition</h4>
//                         <ul>
//                             <li>National Book Award for Fiction (2020)</li>
//                             <li>Reader's Choice Award for Best Novel (2019, 2021)</li>
//                             <li>Literary Excellence Medal (2018)</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// }

// // Checkout Page Component
// function CheckoutPage({ cartItems, getTotalPrice }) {
//     const [formData, setFormData] = useState({
//         firstName: '',
//         lastName: '',
//         email: '',
//         address: '',
//         city: '',
//         zipCode: '',
//         cardNumber: '',
//         expiryDate: '',
//         cvv: ''
//     });

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prevData => ({
//             ...prevData,
//             [name]: value
//         }));
//     };

//     const handleCheckout = () => {
//         alert('Order placed successfully! Thank you for your purchase.');
//         // In a real application, you would send the data to a server here
//     };

//     return (
//         <section className="checkout-page section">
//             <div className="container">
//                 <h2 className="section-title">Checkout</h2>
//                 <div className="checkout-form">
//                     <h3>Shipping Information</h3>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="firstName">First Name</label>
//                             <input 
//                                 type="text" 
//                                 id="firstName" 
//                                 name="firstName" 
//                                 className="form-input" 
//                                 value={formData.firstName}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="lastName">Last Name</label>
//                             <input 
//                                 type="text" 
//                                 id="lastName" 
//                                 name="lastName" 
//                                 className="form-input" 
//                                 value={formData.lastName}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                     </div>
//                     <div className="form-group">
//                         <label className="form-label" htmlFor="email">Email</label>
//                         <input 
//                             type="email" 
//                             id="email" 
//                             name="email" 
//                             className="form-input" 
//                             value={formData.email}
//                             onChange={handleInputChange}
//                             required 
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label className="form-label" htmlFor="address">Address</label>
//                         <input 
//                             type="text" 
//                             id="address" 
//                             name="address" 
//                             className="form-input" 
//                             value={formData.address}
//                             onChange={handleInputChange}
//                             required 
//                         />
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="city">City</label>
//                             <input 
//                                 type="text" 
//                                 id="city" 
//                                 name="city" 
//                                 className="form-input" 
//                                 value={formData.city}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="zipCode">ZIP Code</label>
//                             <input 
//                                 type="text" 
//                                 id="zipCode" 
//                                 name="zipCode" 
//                                 className="form-input" 
//                                 value={formData.zipCode}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                     </div>
                    
//                     <h3>Payment Information</h3>
//                     <div className="form-group">
//                         <label className="form-label" htmlFor="cardNumber">Card Number</label>
//                         <input 
//                             type="text" 
//                             id="cardNumber" 
//                             name="cardNumber" 
//                             className="form-input" 
//                             value={formData.cardNumber}
//                             onChange={handleInputChange}
//                             required 
//                         />
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="expiryDate">Expiry Date</label>
//                             <input 
//                                 type="text" 
//                                 id="expiryDate" 
//                                 name="expiryDate" 
//                                 placeholder="MM/YY" 
//                                 className="form-input" 
//                                 value={formData.expiryDate}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label className="form-label" htmlFor="cvv">CVV</label>
//                             <input 
//                                 type="text" 
//                                 id="cvv" 
//                                 name="cvv" 
//                                 className="form-input" 
//                                 value={formData.cvv}
//                                 onChange={handleInputChange}
//                                 required 
//                             />
//                         </div>
//                     </div>
                    
//                     <div className="order-summary">
//                         <h3>Order Summary</h3>
//                         {cartItems.map(item => (
//                             <div key={item.id} className="order-item">
//                                 <span>{item.title} (x{item.quantity})</span>
//                                 <span>${(item.price * item.quantity).toFixed(2)}</span>
//                             </div>
//                         ))}
//                         <div className="order-total">
//                             <span>Total</span>
//                             <span>${getTotalPrice()}</span>
//                         </div>
//                     </div>
                    
//                     <button className="btn btn-primary checkout-btn" onClick={handleCheckout}>Place Order</button>
//                 </div>
//             </div>
//         </section>
//     );
// }

// // Cart Modal Component
// function CartModal({ isOpen, closeCart, cartItems, updateQuantity, removeFromCart, getTotalPrice, navigateTo }) {
//     return (
//         <div className={`cart-modal ${isOpen ? 'open' : ''}`}>
//             <div className="cart-header">
//                 <h3 className="cart-title">Your Cart</h3>
//                 <button className="close-cart" onClick={closeCart}>
//                     <FontAwesomeIcon icon={faTimes} />
//                 </button>
//             </div>
//             <div className="cart-items">
//                 {cartItems.length === 0 ? (
//                     <p>Your cart is empty</p>
//                 ) : (
//                     cartItems.map(item => (
//                         <div key={item.id} className="cart-item">
//                             <div className="cart-item-image">
//                                 <img src={item.image} alt={item.title} />
//                             </div>
//                             <div className="cart-item-details">
//                                 <h4 className="cart-item-title">{item.title}</h4>
//                                 <p className="cart-item-price">${item.price}</p>
//                                 <div className="cart-item-actions">
//                                     <button className="quantity-btn" onClick={() => updateQuantity(item.id, item.quantity - 1)}>
//                                         <FontAwesomeIcon icon={faMinus} />
//                                     </button>
//                                     <span className="quantity">{item.quantity}</span>
//                                     <button className="quantity-btn" onClick={() => updateQuantity(item.id, item.quantity + 1)}>
//                                         <FontAwesomeIcon icon={faPlus} />
//                                     </button>
//                                     <button className="remove-item" onClick={() => removeFromCart(item.id)}>
//                                         <FontAwesomeIcon icon={faTrash} />
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//             {cartItems.length > 0 && (
//                 <>
//                     <div className="cart-total">
//                         <span>Total:</span>
//                         <span>${getTotalPrice()}</span>
//                     </div>
//                     <div className="cart-actions">
//                         <button className="btn btn-primary checkout-btn" onClick={() => { navigateTo('checkout'); closeCart(); }}>
//                             Proceed to Checkout
//                         </button>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// }

// // Footer Component
// function Footer({ navigateTo }) {
//     return (
//         <footer className="footer">
//             <div className="container">
//                 <div className="footer-content">
//                     <div className="footer-column">
//                         <h3>UPENDO STORE</h3>
//                         <p>Discover captivating stories from award-winning author Musonda. Explore literary works that transport you to new worlds and unforgettable experiences.</p>
//                         <div className="social-links">
//                             <a href="#"><FontAwesomeIcon icon={fabFacebookF} /></a>
//                             <a href="#"><FontAwesomeIcon icon={fabTwitter} /></a>
//                             <a href="#"><FontAwesomeIcon icon={fabInstagram} /></a>
//                             <a href="#"><FontAwesomeIcon icon={fabGoodreads} /></a>
//                         </div>
//                     </div>
//                     <div className="footer-column">
//                         <h3>Quick Links</h3>
//                         <ul className="footer-links">
//                             <li><a href="#" onClick={(e) => { e.preventDefault(); navigateTo('home'); }}>Home</a></li>
//                             <li><a href="#" onClick={(e) => { e.preventDefault(); navigateTo('books'); }}>Books</a></li>
//                             <li><a href="#" onClick={(e) => { e.preventDefault(); navigateTo('about'); }}>About</a></li>
//                             <li><a href="#">Events</a></li>
//                             <li><a href="#">Blog</a></li>
//                         </ul>
//                     </div>
//                     <div className="footer-column">
//                         <h3>Customer Service</h3>
//                         <ul className="footer-links">
//                             <li><a href="#">Shipping Info</a></li>
//                             <li><a href="#">Returns</a></li>
//                             <li><a href="#">Privacy Policy</a></li>
//                             <li><a href="#">Terms of Service</a></li>
//                             <li><a href="#">FAQ</a></li>
//                         </ul>
//                     </div>
//                     <div className="footer-column">
//                         <h3>Contact</h3>
//                         <ul className="footer-links">
//                             <li><FontAwesomeIcon icon={faMapMarkerAlt} /> 123 Book Street, Literary City</li>
//                             <li><FontAwesomeIcon icon={faPhone} /> (123) 456-7890</li>
//                             <li><FontAwesomeIcon icon={faEnvelope} /> info@UPENDO STORE.com</li>
//                         </ul>
//                     </div>
//                 </div>
//                 <div className="footer-bottom">
//                     <p>&copy; {new Date().getFullYear()} UPENDO STORE. All rights reserved.</p>
//                 </div>
//             </div>
//         </footer>
//     );
// }

// export default App;

// here
// import React, { useState, useEffect } from 'react';
// import { ShoppingCart, User, Book, Star, Plus, Minus, X, Check } from 'lucide-react';

// //const BookStore = () => {
// const App = () => {
//   const [books] = useState([
//     {
//       id: 1,
//       title: "The Digital Renaissance",
//       price: 24.99,
//       image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=300&h=400&fit=crop",
//       rating: 4.8,
//       reviews: 142,
//       description: "A compelling exploration of how technology is reshaping our world and creative expression.",
//       category: "Technology",
//       pages: 324,
//       published: "2023"
//     },
//     {
//       id: 2,
//       title: "Mindful Leadership",
//       price: 19.99,
//       image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&h=400&fit=crop",
//       rating: 4.6,
//       reviews: 89,
//       description: "Transform your leadership approach with mindfulness techniques and emotional intelligence.",
//       category: "Business",
//       pages: 268,
//       published: "2023"
//     },
//     {
//       id: 3,
//       title: "Ocean's Whisper",
//       price: 16.99,
//       image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=400&fit=crop",
//       rating: 4.9,
//       reviews: 203,
//       description: "A haunting tale of love, loss, and redemption set against the backdrop of coastal Maine.",
//       category: "Fiction",
//       pages: 412,
//       published: "2022"
//     },
//     {
//       id: 4,
//       title: "The Creative Process",
//       price: 22.99,
//       image: "https://images.unsplash.com/photo-1519682577862-22b62bb24e93?w=300&h=400&fit=crop",
//       rating: 4.7,
//       reviews: 156,
//       description: "Unlock your creative potential with proven strategies and inspiring insights.",
//       category: "Self-Help",
//       pages: 298,
//       published: "2023"
//     }
//   ]);

//   const [cart, setCart] = useState([]);
//   const [selectedBook, setSelectedBook] = useState(null);
//   const [showCart, setShowCart] = useState(false);
//   const [showCheckout, setShowCheckout] = useState(false);
//   const [orderComplete, setOrderComplete] = useState(false);

//   const addToCart = (book) => {
//     setCart(prev => {
//       const existing = prev.find(item => item.id === book.id);
//       if (existing) {
//         return prev.map(item => 
//           item.id === book.id 
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         );
//       }
//       return [...prev, { ...book, quantity: 1 }];
//     });
//   };

//   const updateQuantity = (id, newQuantity) => {
//     if (newQuantity === 0) {
//       setCart(prev => prev.filter(item => item.id !== id));
//     } else {
//       setCart(prev => prev.map(item => 
//         item.id === id ? { ...item, quantity: newQuantity } : item
//       ));
//     }
//   };

//   const getTotalPrice = () => {
//     return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
//   };

//   const getTotalItems = () => {
//     return cart.reduce((total, item) => total + item.quantity, 0);
//   };

//   const handleCheckout = () => {
//     setOrderComplete(true);
//     setCart([]);
//     setTimeout(() => {
//       setOrderComplete(false);
//       setShowCheckout(false);
//     }, 3000);
//   };

//   return (
//     <div style={{
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
//       minHeight: '100vh',
//       backgroundColor: '#fafafa'
//     }}>
//       {/* Header */}
//       <header style={{
//         backgroundColor: 'white',
//         borderBottom: '1px solid #e5e5e5',
//         padding: '1rem 0',
//         position: 'sticky',
//         top: 0,
//         zIndex: 100,
//         boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
//       }}>
//         <div style={{
//           maxWidth: '1200px',
//           margin: '0 auto',
//           padding: '0 2rem',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//             <Book size={32} color="#2563eb" />
//             <h1 style={{
//               margin: 0,
//               fontSize: '1.5rem',
//               fontWeight: '700',
//               color: '#1f2937'
//             }}>
//               Sarah Mitchell Books
//             </h1>
//           </div>
          
//           <button
//             onClick={() => setShowCart(true)}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '0.5rem',
//               background: '#2563eb',
//               color: 'white',
//               border: 'none',
//               padding: '0.75rem 1.5rem',
//               borderRadius: '50px',
//               fontSize: '1rem',
//               fontWeight: '600',
//               cursor: 'pointer',
//               transition: 'all 0.2s',
//               position: 'relative'
//             }}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
//           >
//             <ShoppingCart size={20} />
//             Cart
//             {getTotalItems() > 0 && (
//               <span style={{
//                 position: 'absolute',
//                 top: '-8px',
//                 right: '-8px',
//                 backgroundColor: '#ef4444',
//                 color: 'white',
//                 borderRadius: '50%',
//                 width: '24px',
//                 height: '24px',
//                 fontSize: '0.75rem',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontWeight: 'bold'
//               }}>
//                 {getTotalItems()}
//               </span>
//             )}
//           </button>
//         </div>
//       </header>

//       {/* Hero Section */}
//       <section style={{
//         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         color: 'white',
//         padding: '4rem 0',
//         textAlign: 'center'
//       }}>
//         <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 2rem' }}>
//           <h2 style={{
//             fontSize: '3rem',
//             fontWeight: '700',
//             margin: '0 0 1rem 0',
//             lineHeight: '1.1'
//           }}>
//             Welcome to My Literary World
//           </h2>
//           <p style={{
//             fontSize: '1.25rem',
//             opacity: '0.9',
//             margin: '0 0 2rem 0',
//             lineHeight: '1.6'
//           }}>
//             Discover thought-provoking stories and insights that inspire, challenge, and transform
//           </p>
//         </div>
//       </section>

//       {/* Books Grid */}
//       <main style={{
//         maxWidth: '1200px',
//         margin: '0 auto',
//         padding: '4rem 2rem'
//       }}>
//         <h3 style={{
//           fontSize: '2rem',
//           fontWeight: '600',
//           color: '#1f2937',
//           marginBottom: '2rem',
//           textAlign: 'center'
//         }}>
//           Featured Books
//         </h3>
        
//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//           gap: '2rem',
//           marginBottom: '4rem'
//         }}>
//           {books.map(book => (
//             <div
//               key={book.id}
//               style={{
//                 backgroundColor: 'white',
//                 borderRadius: '12px',
//                 overflow: 'hidden',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//                 transition: 'transform 0.2s, box-shadow 0.2s',
//                 cursor: 'pointer'
//               }}
//               onMouseOver={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
//               }}
//               onMouseOut={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
//               }}
//               onClick={() => setSelectedBook(book)}
//             >
//               <img
//                 src={book.image}
//                 alt={book.title}
//                 style={{
//                   width: '100%',
//                   height: '300px',
//                   objectFit: 'cover'
//                 }}
//               />
//               <div style={{ padding: '1.5rem' }}>
//                 <div style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '0.5rem',
//                   marginBottom: '0.5rem'
//                 }}>
//                   <Star size={16} fill="#fbbf24" color="#fbbf24" />
//                   <span style={{ fontSize: '0.9rem', color: '#6b7280' }}>
//                     {book.rating} ({book.reviews} reviews)
//                   </span>
//                 </div>
                
//                 <h4 style={{
//                   fontSize: '1.25rem',
//                   fontWeight: '600',
//                   color: '#1f2937',
//                   margin: '0 0 0.5rem 0'
//                 }}>
//                   {book.title}
//                 </h4>
                
//                 <p style={{
//                   color: '#6b7280',
//                   fontSize: '0.9rem',
//                   lineHeight: '1.5',
//                   margin: '0 0 1rem 0'
//                 }}>
//                   {book.description.substring(0, 100)}...
//                 </p>
                
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center'
//                 }}>
//                   <span style={{
//                     fontSize: '1.5rem',
//                     fontWeight: '700',
//                     color: '#2563eb'
//                   }}>
//                     ${book.price}
//                   </span>
                  
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       addToCart(book);
//                     }}
//                     style={{
//                       background: '#2563eb',
//                       color: 'white',
//                       border: 'none',
//                       padding: '0.75rem 1.5rem',
//                       borderRadius: '8px',
//                       fontSize: '0.9rem',
//                       fontWeight: '600',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.2s'
//                     }}
//                     onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
//                     onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
//                   >
//                     Add to Cart
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </main>

//       {/* Book Detail Modal */}
//       {selectedBook && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 200,
//           padding: '2rem'
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             borderRadius: '12px',
//             maxWidth: '800px',
//             width: '100%',
//             maxHeight: '90vh',
//             overflow: 'auto',
//             position: 'relative'
//           }}>
//             <button
//               onClick={() => setSelectedBook(null)}
//               style={{
//                 position: 'absolute',
//                 top: '1rem',
//                 right: '1rem',
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 padding: '0.5rem',
//                 borderRadius: '50%',
//                 backgroundColor: '#f3f4f6'
//               }}
//             >
//               <X size={20} />
//             </button>
            
//             <div style={{ display: 'flex', flexWrap: 'wrap' }}>
//               <div style={{ flex: '1', minWidth: '300px' }}>
//                 <img
//                   src={selectedBook.image}
//                   alt={selectedBook.title}
//                   style={{
//                     width: '100%',
//                     height: '400px',
//                     objectFit: 'cover',
//                     borderRadius: '12px 0 0 12px'
//                   }}
//                 />
//               </div>
              
//               <div style={{
//                 flex: '1',
//                 minWidth: '300px',
//                 padding: '2rem'
//               }}>
//                 <div style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '0.5rem',
//                   marginBottom: '1rem'
//                 }}>
//                   <Star size={18} fill="#fbbf24" color="#fbbf24" />
//                   <span style={{ fontSize: '1rem', color: '#6b7280' }}>
//                     {selectedBook.rating} ({selectedBook.reviews} reviews)
//                   </span>
//                 </div>
                
//                 <h3 style={{
//                   fontSize: '2rem',
//                   fontWeight: '700',
//                   color: '#1f2937',
//                   margin: '0 0 1rem 0'
//                 }}>
//                   {selectedBook.title}
//                 </h3>
                
//                 <p style={{
//                   color: '#6b7280',
//                   lineHeight: '1.6',
//                   margin: '0 0 1.5rem 0'
//                 }}>
//                   {selectedBook.description}
//                 </p>
                
//                 <div style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   gap: '1rem',
//                   marginBottom: '2rem',
//                   padding: '1rem',
//                   backgroundColor: '#f9fafb',
//                   borderRadius: '8px'
//                 }}>
//                   <div>
//                     <span style={{ fontWeight: '600', color: '#374151' }}>Category:</span>
//                     <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>{selectedBook.category}</span>
//                   </div>
//                   <div>
//                     <span style={{ fontWeight: '600', color: '#374151' }}>Pages:</span>
//                     <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>{selectedBook.pages}</span>
//                   </div>
//                   <div>
//                     <span style={{ fontWeight: '600', color: '#374151' }}>Published:</span>
//                     <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>{selectedBook.published}</span>
//                   </div>
//                 </div>
                
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center'
//                 }}>
//                   <span style={{
//                     fontSize: '2rem',
//                     fontWeight: '700',
//                     color: '#2563eb'
//                   }}>
//                     ${selectedBook.price}
//                   </span>
                  
//                   <button
//                     onClick={() => {
//                       addToCart(selectedBook);
//                       setSelectedBook(null);
//                     }}
//                     style={{
//                       background: '#2563eb',
//                       color: 'white',
//                       border: 'none',
//                       padding: '1rem 2rem',
//                       borderRadius: '8px',
//                       fontSize: '1rem',
//                       fontWeight: '600',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.2s'
//                     }}
//                     onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
//                     onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
//                   >
//                     Add to Cart
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Cart Modal */}
//       {showCart && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 200,
//           padding: '2rem'
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             borderRadius: '12px',
//             maxWidth: '600px',
//             width: '100%',
//             maxHeight: '90vh',
//             overflow: 'auto'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               padding: '1.5rem',
//               borderBottom: '1px solid #e5e5e5'
//             }}>
//               <h3 style={{
//                 fontSize: '1.5rem',
//                 fontWeight: '600',
//                 color: '#1f2937',
//                 margin: 0
//               }}>
//                 Shopping Cart ({getTotalItems()} items)
//               </h3>
//               <button
//                 onClick={() => setShowCart(false)}
//                 style={{
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   padding: '0.5rem',
//                   borderRadius: '50%',
//                   backgroundColor: '#f3f4f6'
//                 }}
//               >
//                 <X size={20} />
//               </button>
//             </div>
            
//             <div style={{ padding: '1.5rem' }}>
//               {cart.length === 0 ? (
//                 <p style={{
//                   textAlign: 'center',
//                   color: '#6b7280',
//                   margin: '2rem 0'
//                 }}>
//                   Your cart is empty
//                 </p>
//               ) : (
//                 <>
//                   {cart.map(item => (
//                     <div key={item.id} style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '1rem',
//                       padding: '1rem 0',
//                       borderBottom: '1px solid #f3f4f6'
//                     }}>
//                       <img
//                         src={item.image}
//                         alt={item.title}
//                         style={{
//                           width: '60px',
//                           height: '80px',
//                           objectFit: 'cover',
//                           borderRadius: '4px'
//                         }}
//                       />
//                       <div style={{ flex: 1 }}>
//                         <h4 style={{
//                           fontSize: '1rem',
//                           fontWeight: '600',
//                           color: '#1f2937',
//                           margin: '0 0 0.25rem 0'
//                         }}>
//                           {item.title}
//                         </h4>
//                         <p style={{
//                           color: '#6b7280',
//                           fontSize: '0.9rem',
//                           margin: 0
//                         }}>
//                           ${item.price} each
//                         </p>
//                       </div>
//                       <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '0.5rem'
//                       }}>
//                         <button
//                           onClick={() => updateQuantity(item.id, item.quantity - 1)}
//                           style={{
//                             background: '#f3f4f6',
//                             border: 'none',
//                             borderRadius: '4px',
//                             padding: '0.25rem',
//                             cursor: 'pointer'
//                           }}
//                         >
//                           <Minus size={16} />
//                         </button>
//                         <span style={{
//                           minWidth: '2rem',
//                           textAlign: 'center',
//                           fontWeight: '600'
//                         }}>
//                           {item.quantity}
//                         </span>
//                         <button
//                           onClick={() => updateQuantity(item.id, item.quantity + 1)}
//                           style={{
//                             background: '#f3f4f6',
//                             border: 'none',
//                             borderRadius: '4px',
//                             padding: '0.25rem',
//                             cursor: 'pointer'
//                           }}
//                         >
//                           <Plus size={16} />
//                         </button>
//                       </div>
//                       <div style={{
//                         fontWeight: '600',
//                         color: '#1f2937',
//                         minWidth: '4rem',
//                         textAlign: 'right'
//                       }}>
//                         ${(item.price * item.quantity).toFixed(2)}
//                       </div>
//                     </div>
//                   ))}
                  
//                   <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginTop: '1.5rem',
//                     padding: '1rem 0',
//                     borderTop: '2px solid #e5e5e5'
//                   }}>
//                     <span style={{
//                       fontSize: '1.25rem',
//                       fontWeight: '700',
//                       color: '#1f2937'
//                     }}>
//                       Total: ${getTotalPrice().toFixed(2)}
//                     </span>
//                     <button
//                       onClick={() => {
//                         setShowCart(false);
//                         setShowCheckout(true);
//                       }}
//                       style={{
//                         background: '#2563eb',
//                         color: 'white',
//                         border: 'none',
//                         padding: '1rem 2rem',
//                         borderRadius: '8px',
//                         fontSize: '1rem',
//                         fontWeight: '600',
//                         cursor: 'pointer',
//                         transition: 'background-color 0.2s'
//                       }}
//                       onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
//                       onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
//                     >
//                       Checkout
//                     </button>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Checkout Modal */}
//       {showCheckout && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 200,
//           padding: '2rem'
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             borderRadius: '12px',
//             maxWidth: '500px',
//             width: '100%',
//             maxHeight: '90vh',
//             overflow: 'auto'
//           }}>
//             {orderComplete ? (
//               <div style={{
//                 padding: '3rem',
//                 textAlign: 'center'
//               }}>
//                 <div style={{
//                   width: '80px',
//                   height: '80px',
//                   backgroundColor: '#10b981',
//                   borderRadius: '50%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   margin: '0 auto 1.5rem'
//                 }}>
//                   <Check size={40} color="white" />
//                 </div>
//                 <h3 style={{
//                   fontSize: '1.5rem',
//                   fontWeight: '600',
//                   color: '#1f2937',
//                   margin: '0 0 0.5rem 0'
//                 }}>
//                   Order Complete!
//                 </h3>
//                 <p style={{
//                   color: '#6b7280',
//                   margin: 0
//                 }}>
//                   Thank you for your purchase. Your books will be delivered soon!
//                 </p>
//               </div>
//             ) : (
//               <>
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   padding: '1.5rem',
//                   borderBottom: '1px solid #e5e5e5'
//                 }}>
//                   <h3 style={{
//                     fontSize: '1.5rem',
//                     fontWeight: '600',
//                     color: '#1f2937',
//                     margin: 0
//                   }}>
//                     Checkout
//                   </h3>
//                   <button
//                     onClick={() => setShowCheckout(false)}
//                     style={{
//                       background: 'none',
//                       border: 'none',
//                       cursor: 'pointer',
//                       padding: '0.5rem',
//                       borderRadius: '50%',
//                       backgroundColor: '#f3f4f6'
//                     }}
//                   >
//                     <X size={20} />
//                   </button>
//                 </div>
                
//                 <div style={{ padding: '1.5rem' }}>
//                   <form onSubmit={(e) => {
//                     e.preventDefault();
//                     handleCheckout();
//                   }}>
//                     <div style={{ marginBottom: '1.5rem' }}>
//                       <label style={{
//                         display: 'block',
//                         fontSize: '0.9rem',
//                         fontWeight: '600',
//                         color: '#374151',
//                         marginBottom: '0.5rem'
//                       }}>
//                         Full Name
//                       </label>
//                       <input
//                         type="text"
//                         required
//                         style={{
//                           width: '100%',
//                           padding: '0.75rem',
//                           border: '1px solid #d1d5db',
//                           borderRadius: '6px',
//                           fontSize: '1rem',
//                           outline: 'none',
//                           transition: 'border-color 0.2s'
//                         }}
//                         onFocus={(e) => e.target.style.borderColor = '#2563eb'}
//                         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//                       />
//                     </div>
                    
//                     <div style={{ marginBottom: '1.5rem' }}>
//                       <label style={{
//                         display: 'block',
//                         fontSize: '0.9rem',
//                         fontWeight: '600',
//                         color: '#374151',
//                         marginBottom: '0.5rem'
//                       }}>
//                         Email Address
//                       </label>
//                       <input
//                         type="email"
//                         required
//                         style={{
//                           width: '100%',
//                           padding: '0.75rem',
//                           border: '1px solid #d1d5db',
//                           borderRadius: '6px',
//                           fontSize: '1rem',
//                           outline: 'none',
//                           transition: 'border-color 0.2s'
//                         }}
//                         onFocus={(e) => e.target.style.borderColor = '#2563eb'}
//                         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//                       />
//                     </div>
                    
//                     <div style={{ marginBottom: '1.5rem' }}>
//                       <label style={{
//                         display: 'block',
//                         fontSize: '0.9rem',
//                         fontWeight: '600',
//                         color: '#374151',
//                         marginBottom: '0.5rem'
//                       }}>
//                         Shipping Address
//                       </label>
//                       <textarea
//                         required
//                         rows={3}
//                         style={{
//                           width: '100%',
//                           padding: '0.75rem',
//                           border: '1px solid #d1d5db',
//                           borderRadius: '6px',
//                           fontSize: '1rem',
//                           outline: 'none',
//                           transition: 'border-color 0.2s',
//                           resize: 'vertical'
//                         }}
//                         onFocus={(e) => e.target.style.borderColor = '#2563eb'}
//                         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//                       />
//                     </div>
                    
//                     <div style={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'center',
//                       marginBottom: '1.5rem',
//                       padding: '1rem',
//                       backgroundColor: '#f9fafb',
//                       borderRadius: '8px'
//                     }}>
//                       <span style={{
//                         fontSize: '1.1rem',
//                         fontWeight: '600',
//                         color: '#1f2937'
//                       }}>
//                         Total: ${getTotalPrice().toFixed(2)}
//                       </span>
//                     </div>
                    
//                     <button
//                       type="submit"
//                       style={{
//                         width: '100%',
//                         background: '#2563eb',
//                         color: 'white',
//                         border: 'none',
//                         padding: '1rem',
//                         borderRadius: '8px',
//                         fontSize: '1rem',
//                         fontWeight: '600',
//                         cursor: 'pointer',
//                         transition: 'background-color 0.2s'
//                       }}
//                       onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
//                       onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
//                     >
//                       Complete Order
//                     </button>
//                   </form>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // import logo from './logo.svg';
// // import './App.css';

// // function App() {
// //   return (
// //     <div className="App">
// //       <header className="App-header">
// //         <img src={logo} className="App-logo" alt="logo" />
// //         <p>
// //           Edit <code>src/App.js</code> and save to reload.
// //         </p>
// //         <a
// //           className="App-link"
// //           href="https://reactjs.org"
// //           target="_blank"
// //           rel="noopener noreferrer"
// //         >
// //           Learn React
// //         </a>
// //       </header>
// //     </div>
// //   );
// // }

// export default App;